;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="a9243972-e3ce-493c-ab27-f2ea57c4122e",e._sentryDebugIdIdentifier="sentry-dbid-a9243972-e3ce-493c-ab27-f2ea57c4122e")}catch(e){}}();
"use strict";
(self["webpackChunkretino"] = self["webpackChunkretino"] || []).push([[704],{

/***/ 70366:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   f: () => (/* binding */ BackendEnums)
/* harmony export */ });
/* eslint-disable no-shadow */
let BackendEnums;
(function (_BackendEnums) {
  let AICompletionStatusEnum = /*#__PURE__*/function (AICompletionStatusEnum) {
    AICompletionStatusEnum["PENDING"] = "pending";
    AICompletionStatusEnum["COMPLETED"] = "completed";
    AICompletionStatusEnum["FAILED"] = "failed";
    return AICompletionStatusEnum;
  }({});
  _BackendEnums.AICompletionStatusEnum = AICompletionStatusEnum;
  let ActionTypeEnum = /*#__PURE__*/function (ActionTypeEnum) {
    ActionTypeEnum["SEND_RATING_EMAIL"] = "SEND_RATING_EMAIL";
    ActionTypeEnum["SEND_MESSAGE_TEMPLATE"] = "SEND_MESSAGE_TEMPLATE";
    ActionTypeEnum["SEND_SMS"] = "SEND_SMS";
    ActionTypeEnum["ADD_DEADLINE"] = "ADD_DEADLINE";
    ActionTypeEnum["ASSIGN_AGENT"] = "ASSIGN_AGENT";
    ActionTypeEnum["UNASSIGN_AGENT"] = "UNASSIGN_AGENT";
    ActionTypeEnum["ADD_DOCUMENT"] = "ADD_DOCUMENT";
    ActionTypeEnum["ADD_TRANSPORT"] = "ADD_TRANSPORT";
    ActionTypeEnum["ADD_TAG"] = "ADD_TAG";
    ActionTypeEnum["REMOVE_TAG"] = "REMOVE_TAG";
    ActionTypeEnum["CLOSE_TICKET"] = "CLOSE_TICKET";
    ActionTypeEnum["REOPEN_TICKET"] = "REOPEN_TICKET";
    ActionTypeEnum["CHANGE_STATE"] = "CHANGE_STATE";
    ActionTypeEnum["ORDER_REQUESTED_SHIPPING"] = "ORDER_REQUESTED_SHIPPING";
    ActionTypeEnum["ADD_ACTIVITY"] = "ADD_ACTIVITY";
    ActionTypeEnum["FILL_CUSTOM_FIELD"] = "FILL_CUSTOM_FIELD";
    return ActionTypeEnum;
  }({});
  _BackendEnums.ActionTypeEnum = ActionTypeEnum;
  let ActivityStatusEnum = /*#__PURE__*/function (ActivityStatusEnum) {
    ActivityStatusEnum["STATUS_OPEN"] = "STATUS_OPEN";
    ActivityStatusEnum["STATUS_CLOSED"] = "STATUS_CLOSED";
    return ActivityStatusEnum;
  }({});
  _BackendEnums.ActivityStatusEnum = ActivityStatusEnum;
  let AgentInputRequestStatusEnum = /*#__PURE__*/function (AgentInputRequestStatusEnum) {
    AgentInputRequestStatusEnum["PENDING"] = "pending";
    AgentInputRequestStatusEnum["COMPLETED"] = "completed";
    AgentInputRequestStatusEnum["EXPIRED"] = "expired";
    AgentInputRequestStatusEnum["CANCELLED"] = "cancelled";
    return AgentInputRequestStatusEnum;
  }({});
  _BackendEnums.AgentInputRequestStatusEnum = AgentInputRequestStatusEnum;
  let AutomationScopeEnum = /*#__PURE__*/function (AutomationScopeEnum) {
    AutomationScopeEnum["DRAFTS"] = "DRAFTS";
    AutomationScopeEnum["ORDERS"] = "ORDERS";
    AutomationScopeEnum["DOCUMENTS"] = "DOCUMENTS";
    return AutomationScopeEnum;
  }({});
  _BackendEnums.AutomationScopeEnum = AutomationScopeEnum;
  let BilledInvoiceStatusEnum = /*#__PURE__*/function (BilledInvoiceStatusEnum) {
    BilledInvoiceStatusEnum["DRAFT"] = "DRAFT";
    BilledInvoiceStatusEnum["FINALIZED"] = "FINALIZED";
    BilledInvoiceStatusEnum["AWAITING_PAYMENT"] = "AWAITING_PAYMENT";
    BilledInvoiceStatusEnum["REQUIRES_ACTION"] = "REQUIRES_ACTION";
    BilledInvoiceStatusEnum["RETRYING"] = "RETRYING";
    BilledInvoiceStatusEnum["PAID"] = "PAID";
    BilledInvoiceStatusEnum["UNCOLLECTIBLE"] = "UNCOLLECTIBLE";
    BilledInvoiceStatusEnum["REFUNDED"] = "REFUNDED";
    BilledInvoiceStatusEnum["VOIDED"] = "VOIDED";
    BilledInvoiceStatusEnum["FAIL"] = "FAIL";
    return BilledInvoiceStatusEnum;
  }({});
  _BackendEnums.BilledInvoiceStatusEnum = BilledInvoiceStatusEnum;
  let BillingCurrencyEnum = /*#__PURE__*/function (BillingCurrencyEnum) {
    BillingCurrencyEnum["CZK"] = "CZK";
    BillingCurrencyEnum["EUR"] = "EUR";
    return BillingCurrencyEnum;
  }({});
  _BackendEnums.BillingCurrencyEnum = BillingCurrencyEnum;
  let BillingIssueEnum = /*#__PURE__*/function (BillingIssueEnum) {
    BillingIssueEnum["BLOCKED_NEED_CARD"] = "BLOCKED_NEED_CARD";
    BillingIssueEnum["NEED_CARD"] = "NEED_CARD";
    BillingIssueEnum["REQUIRES_AUTHENTICATION"] = "REQUIRES_AUTHENTICATION";
    return BillingIssueEnum;
  }({});
  _BackendEnums.BillingIssueEnum = BillingIssueEnum;
  let BillingSchemeEnum = /*#__PURE__*/function (BillingSchemeEnum) {
    BillingSchemeEnum["PER_UNIT"] = "PER_UNIT";
    BillingSchemeEnum["TIERED"] = "TIERED";
    BillingSchemeEnum["EXTERNAL"] = "EXTERNAL";
    return BillingSchemeEnum;
  }({});
  _BackendEnums.BillingSchemeEnum = BillingSchemeEnum;
  let BulkActionActionEnum = /*#__PURE__*/function (BulkActionActionEnum) {
    BulkActionActionEnum["CLOSE"] = "close";
    BulkActionActionEnum["DELETE"] = "delete";
    BulkActionActionEnum["ASSIGN"] = "assign";
    BulkActionActionEnum["STATE_CHANGE"] = "state_change";
    BulkActionActionEnum["ADD_TAGS"] = "add_tags";
    BulkActionActionEnum["REMOVE_TAGS"] = "remove_tags";
    BulkActionActionEnum["EXPORT_TICKETS"] = "export_tickets";
    BulkActionActionEnum["EXPORT_PRODUCTS"] = "export_products";
    BulkActionActionEnum["EXPORT_PDF"] = "export_pdf";
    return BulkActionActionEnum;
  }({});
  _BackendEnums.BulkActionActionEnum = BulkActionActionEnum;
  let ButtonRadiusEnum = /*#__PURE__*/function (ButtonRadiusEnum) {
    ButtonRadiusEnum["NONE"] = "none";
    ButtonRadiusEnum["SM"] = "sm";
    ButtonRadiusEnum["MD"] = "md";
    ButtonRadiusEnum["LG"] = "lg";
    ButtonRadiusEnum["FULL"] = "full";
    return ButtonRadiusEnum;
  }({});
  _BackendEnums.ButtonRadiusEnum = ButtonRadiusEnum;
  let CapabilityEnum = /*#__PURE__*/function (CapabilityEnum) {
    CapabilityEnum["TICKETS_VIEW"] = "tickets.view";
    CapabilityEnum["TICKETS_WORK"] = "tickets.work";
    CapabilityEnum["TICKETS_WRITE_TO_CUSTOMER"] = "tickets.write_to_customer";
    CapabilityEnum["TICKETS_DELETE"] = "tickets.delete";
    CapabilityEnum["TICKETS_SETTINGS"] = "tickets.settings";
    CapabilityEnum["REFUNDS_VIEW"] = "refunds.view";
    CapabilityEnum["REFUNDS_ISSUE"] = "refunds.issue";
    CapabilityEnum["REFUNDS_SETTINGS"] = "refunds.settings";
    CapabilityEnum["SHIPPING_VIEW"] = "shipping.view";
    CapabilityEnum["SHIPPING_CREATE"] = "shipping.create";
    CapabilityEnum["SHIPPING_SETTINGS"] = "shipping.settings";
    CapabilityEnum["DATA_ORDERS"] = "data.orders";
    CapabilityEnum["DATA_CUSTOMERS"] = "data.customers";
    CapabilityEnum["DATA_STATS"] = "data.stats";
    CapabilityEnum["DATA_EXPORT"] = "data.export";
    CapabilityEnum["FLOWS_RUN"] = "flows.run";
    CapabilityEnum["FLOWS_CONFIGURE"] = "flows.configure";
    CapabilityEnum["INTEGRATIONS_MANAGE"] = "integrations.manage";
    CapabilityEnum["INTEGRATIONS_MARKETPLACE"] = "integrations.marketplace";
    CapabilityEnum["INTEGRATIONS_API_ACCESS"] = "integrations.api_access";
    CapabilityEnum["INTEGRATIONS_MCP"] = "integrations.mcp";
    CapabilityEnum["TEAM_MANAGE"] = "team.manage";
    CapabilityEnum["BILLING_VIEW"] = "billing.view";
    CapabilityEnum["BILLING_MANAGE"] = "billing.manage";
    CapabilityEnum["COMPANY_SETTINGS"] = "company.settings";
    CapabilityEnum["TRACKING_VIEW"] = "tracking.view";
    CapabilityEnum["TRACKING_WORK"] = "tracking.work";
    CapabilityEnum["TRACKING_SETTINGS"] = "tracking.settings";
    return CapabilityEnum;
  }({});
  _BackendEnums.CapabilityEnum = CapabilityEnum;
  let CapabilityGroupEnum = /*#__PURE__*/function (CapabilityGroupEnum) {
    CapabilityGroupEnum["TICKETS"] = "tickets";
    CapabilityGroupEnum["REFUNDS"] = "refunds";
    CapabilityGroupEnum["SHIPPING"] = "shipping";
    CapabilityGroupEnum["DATA"] = "data";
    CapabilityGroupEnum["FLOWS"] = "flows";
    CapabilityGroupEnum["INTEGRATIONS"] = "integrations";
    CapabilityGroupEnum["TEAM"] = "team";
    CapabilityGroupEnum["COMPANY"] = "company";
    CapabilityGroupEnum["TRACKING"] = "tracking";
    return CapabilityGroupEnum;
  }({});
  _BackendEnums.CapabilityGroupEnum = CapabilityGroupEnum;
  let CardProviderEnum = /*#__PURE__*/function (CardProviderEnum) {
    CardProviderEnum["STRIPE"] = "STRIPE";
    return CardProviderEnum;
  }({});
  _BackendEnums.CardProviderEnum = CardProviderEnum;
  let ChoiceEnum = /*#__PURE__*/function (ChoiceEnum) {
    ChoiceEnum["STANDARD"] = "standard";
    ChoiceEnum["ADVANCED"] = "advanced";
    return ChoiceEnum;
  }({});
  _BackendEnums.ChoiceEnum = ChoiceEnum;
  let CompanyEmailSettingTypeEnum = /*#__PURE__*/function (CompanyEmailSettingTypeEnum) {
    CompanyEmailSettingTypeEnum["TYPE_TRANSPORT_LABEL"] = "TYPE_TRANSPORT_LABEL";
    CompanyEmailSettingTypeEnum["TYPE_TICKET_CREATED"] = "TYPE_TICKET_CREATED";
    CompanyEmailSettingTypeEnum["TYPE_RATING"] = "TYPE_RATING";
    CompanyEmailSettingTypeEnum["TYPE_DOCUMENT"] = "TYPE_DOCUMENT";
    CompanyEmailSettingTypeEnum["TYPE_CREDIT_NOTE"] = "TYPE_CREDIT_NOTE";
    CompanyEmailSettingTypeEnum["TYPE_VOUCHER"] = "TYPE_VOUCHER";
    return CompanyEmailSettingTypeEnum;
  }({});
  _BackendEnums.CompanyEmailSettingTypeEnum = CompanyEmailSettingTypeEnum;
  let CompanyOnboardingStepTypeEnum = /*#__PURE__*/function (CompanyOnboardingStepTypeEnum) {
    CompanyOnboardingStepTypeEnum["BASE_SETTINGS"] = "BASE_SETTINGS";
    CompanyOnboardingStepTypeEnum["DATA_INTEGRATION"] = "DATA_INTEGRATION";
    CompanyOnboardingStepTypeEnum["WIDGET_INTEGRATION"] = "WIDGET_INTEGRATION";
    CompanyOnboardingStepTypeEnum["SHIPPING_SETTINGS"] = "SHIPPING_SETTINGS";
    CompanyOnboardingStepTypeEnum["PORTAL_INTEGRATION"] = "PORTAL_INTEGRATION";
    CompanyOnboardingStepTypeEnum["PORTAL_FIRST_TICKET"] = "PORTAL_FIRST_TICKET";
    CompanyOnboardingStepTypeEnum["TRACKING_SELECT_LANGUAGES"] = "TRACKING_SELECT_LANGUAGES";
    CompanyOnboardingStepTypeEnum["TRACKING_ORDER_INTEGRATION"] = "TRACKING_ORDER_INTEGRATION";
    CompanyOnboardingStepTypeEnum["TRACKING_CARRIER_SELECTION"] = "TRACKING_CARRIER_SELECTION";
    CompanyOnboardingStepTypeEnum["TRACKING_BRAND_IDENTITY"] = "TRACKING_BRAND_IDENTITY";
    return CompanyOnboardingStepTypeEnum;
  }({});
  _BackendEnums.CompanyOnboardingStepTypeEnum = CompanyOnboardingStepTypeEnum;
  let CompanyOrderProviderProviderEnum = /*#__PURE__*/function (CompanyOrderProviderProviderEnum) {
    CompanyOrderProviderProviderEnum["SHOPTET_API"] = "SHOPTET_API";
    CompanyOrderProviderProviderEnum["RETINO_XML"] = "RETINO_XML";
    CompanyOrderProviderProviderEnum["PRESTASHOP_16"] = "PRESTASHOP_16";
    CompanyOrderProviderProviderEnum["UPGATES_API"] = "UPGATES_API";
    CompanyOrderProviderProviderEnum["SHOPIFY_PRIVATE"] = "SHOPIFY_PRIVATE";
    CompanyOrderProviderProviderEnum["SHOPIFY_API"] = "SHOPIFY_API";
    CompanyOrderProviderProviderEnum["SIMPLIA_API"] = "SIMPLIA_API";
    CompanyOrderProviderProviderEnum["SHOPRENTER_API"] = "SHOPRENTER_API";
    CompanyOrderProviderProviderEnum["WEBAREAL_API"] = "WEBAREAL_API";
    CompanyOrderProviderProviderEnum["SHOPWARE_5"] = "SHOPWARE_5";
    CompanyOrderProviderProviderEnum["SHOPWARE_6"] = "SHOPWARE_6";
    CompanyOrderProviderProviderEnum["BYZNYSWEB_API"] = "BYZNYSWEB_API";
    CompanyOrderProviderProviderEnum["WOOCOMMERCE_API"] = "WOOCOMMERCE_API";
    CompanyOrderProviderProviderEnum["RETINO_ORDERS_API"] = "RETINO_ORDERS_API";
    CompanyOrderProviderProviderEnum["UNAS_API"] = "UNAS_API";
    CompanyOrderProviderProviderEnum["ESHOP_RYCHLE_API"] = "ESHOP_RYCHLE_API";
    CompanyOrderProviderProviderEnum["IDOSELL_API"] = "IDOSELL_API";
    return CompanyOrderProviderProviderEnum;
  }({});
  _BackendEnums.CompanyOrderProviderProviderEnum = CompanyOrderProviderProviderEnum;
  let CompanyOrderProviderStateEnum = /*#__PURE__*/function (CompanyOrderProviderStateEnum) {
    CompanyOrderProviderStateEnum["READY"] = "READY";
    CompanyOrderProviderStateEnum["INIT"] = "INIT";
    CompanyOrderProviderStateEnum["FAILED"] = "FAILED";
    CompanyOrderProviderStateEnum["DISABLED"] = "DISABLED";
    CompanyOrderProviderStateEnum["STOPPED"] = "STOPPED";
    return CompanyOrderProviderStateEnum;
  }({});
  _BackendEnums.CompanyOrderProviderStateEnum = CompanyOrderProviderStateEnum;
  let ConditionOperationEnum = /*#__PURE__*/function (ConditionOperationEnum) {
    ConditionOperationEnum["AND"] = "AND";
    ConditionOperationEnum["OR"] = "OR";
    return ConditionOperationEnum;
  }({});
  _BackendEnums.ConditionOperationEnum = ConditionOperationEnum;
  let CountryEnum = /*#__PURE__*/function (CountryEnum) {
    CountryEnum["AF"] = "AF";
    CountryEnum["AX"] = "AX";
    CountryEnum["AL"] = "AL";
    CountryEnum["DZ"] = "DZ";
    CountryEnum["AS"] = "AS";
    CountryEnum["AD"] = "AD";
    CountryEnum["AO"] = "AO";
    CountryEnum["AI"] = "AI";
    CountryEnum["AQ"] = "AQ";
    CountryEnum["AG"] = "AG";
    CountryEnum["AR"] = "AR";
    CountryEnum["AM"] = "AM";
    CountryEnum["AW"] = "AW";
    CountryEnum["AU"] = "AU";
    CountryEnum["AT"] = "AT";
    CountryEnum["AZ"] = "AZ";
    CountryEnum["BS"] = "BS";
    CountryEnum["BH"] = "BH";
    CountryEnum["BD"] = "BD";
    CountryEnum["BB"] = "BB";
    CountryEnum["BY"] = "BY";
    CountryEnum["BE"] = "BE";
    CountryEnum["BZ"] = "BZ";
    CountryEnum["BJ"] = "BJ";
    CountryEnum["BM"] = "BM";
    CountryEnum["BT"] = "BT";
    CountryEnum["BO"] = "BO";
    CountryEnum["BQ"] = "BQ";
    CountryEnum["BA"] = "BA";
    CountryEnum["BW"] = "BW";
    CountryEnum["BV"] = "BV";
    CountryEnum["BR"] = "BR";
    CountryEnum["IO"] = "IO";
    CountryEnum["BN"] = "BN";
    CountryEnum["BG"] = "BG";
    CountryEnum["BF"] = "BF";
    CountryEnum["BI"] = "BI";
    CountryEnum["CV"] = "CV";
    CountryEnum["KH"] = "KH";
    CountryEnum["CM"] = "CM";
    CountryEnum["CA"] = "CA";
    CountryEnum["KY"] = "KY";
    CountryEnum["CF"] = "CF";
    CountryEnum["TD"] = "TD";
    CountryEnum["CL"] = "CL";
    CountryEnum["CN"] = "CN";
    CountryEnum["CX"] = "CX";
    CountryEnum["CC"] = "CC";
    CountryEnum["CO"] = "CO";
    CountryEnum["KM"] = "KM";
    CountryEnum["CD"] = "CD";
    CountryEnum["CG"] = "CG";
    CountryEnum["CK"] = "CK";
    CountryEnum["CR"] = "CR";
    CountryEnum["CI"] = "CI";
    CountryEnum["HR"] = "HR";
    CountryEnum["CU"] = "CU";
    CountryEnum["CW"] = "CW";
    CountryEnum["CY"] = "CY";
    CountryEnum["CZ"] = "CZ";
    CountryEnum["DK"] = "DK";
    CountryEnum["DJ"] = "DJ";
    CountryEnum["DM"] = "DM";
    CountryEnum["DO"] = "DO";
    CountryEnum["EC"] = "EC";
    CountryEnum["EG"] = "EG";
    CountryEnum["SV"] = "SV";
    CountryEnum["GQ"] = "GQ";
    CountryEnum["ER"] = "ER";
    CountryEnum["EE"] = "EE";
    CountryEnum["ET"] = "ET";
    CountryEnum["FK"] = "FK";
    CountryEnum["FO"] = "FO";
    CountryEnum["FJ"] = "FJ";
    CountryEnum["FI"] = "FI";
    CountryEnum["FR"] = "FR";
    CountryEnum["GF"] = "GF";
    CountryEnum["PF"] = "PF";
    CountryEnum["TF"] = "TF";
    CountryEnum["GA"] = "GA";
    CountryEnum["GM"] = "GM";
    CountryEnum["GE"] = "GE";
    CountryEnum["DE"] = "DE";
    CountryEnum["GH"] = "GH";
    CountryEnum["GI"] = "GI";
    CountryEnum["GR"] = "GR";
    CountryEnum["GL"] = "GL";
    CountryEnum["GD"] = "GD";
    CountryEnum["GP"] = "GP";
    CountryEnum["GU"] = "GU";
    CountryEnum["GT"] = "GT";
    CountryEnum["GG"] = "GG";
    CountryEnum["GN"] = "GN";
    CountryEnum["GW"] = "GW";
    CountryEnum["GY"] = "GY";
    CountryEnum["HT"] = "HT";
    CountryEnum["HM"] = "HM";
    CountryEnum["VA"] = "VA";
    CountryEnum["HN"] = "HN";
    CountryEnum["HK"] = "HK";
    CountryEnum["HU"] = "HU";
    CountryEnum["IS"] = "IS";
    CountryEnum["IN"] = "IN";
    CountryEnum["ID"] = "ID";
    CountryEnum["IR"] = "IR";
    CountryEnum["IQ"] = "IQ";
    CountryEnum["IE"] = "IE";
    CountryEnum["IM"] = "IM";
    CountryEnum["IL"] = "IL";
    CountryEnum["IT"] = "IT";
    CountryEnum["JM"] = "JM";
    CountryEnum["JP"] = "JP";
    CountryEnum["JE"] = "JE";
    CountryEnum["JO"] = "JO";
    CountryEnum["KZ"] = "KZ";
    CountryEnum["KE"] = "KE";
    CountryEnum["KI"] = "KI";
    CountryEnum["KP"] = "KP";
    CountryEnum["KR"] = "KR";
    CountryEnum["KW"] = "KW";
    CountryEnum["KG"] = "KG";
    CountryEnum["LA"] = "LA";
    CountryEnum["LV"] = "LV";
    CountryEnum["LB"] = "LB";
    CountryEnum["LS"] = "LS";
    CountryEnum["LR"] = "LR";
    CountryEnum["LY"] = "LY";
    CountryEnum["LI"] = "LI";
    CountryEnum["LT"] = "LT";
    CountryEnum["LU"] = "LU";
    CountryEnum["MO"] = "MO";
    CountryEnum["MK"] = "MK";
    CountryEnum["MG"] = "MG";
    CountryEnum["MW"] = "MW";
    CountryEnum["MY"] = "MY";
    CountryEnum["MV"] = "MV";
    CountryEnum["ML"] = "ML";
    CountryEnum["MT"] = "MT";
    CountryEnum["MH"] = "MH";
    CountryEnum["MQ"] = "MQ";
    CountryEnum["MR"] = "MR";
    CountryEnum["MU"] = "MU";
    CountryEnum["YT"] = "YT";
    CountryEnum["MX"] = "MX";
    CountryEnum["FM"] = "FM";
    CountryEnum["MD"] = "MD";
    CountryEnum["MC"] = "MC";
    CountryEnum["MN"] = "MN";
    CountryEnum["ME"] = "ME";
    CountryEnum["MS"] = "MS";
    CountryEnum["MA"] = "MA";
    CountryEnum["MZ"] = "MZ";
    CountryEnum["MM"] = "MM";
    CountryEnum["NA"] = "NA";
    CountryEnum["NR"] = "NR";
    CountryEnum["NP"] = "NP";
    CountryEnum["NL"] = "NL";
    CountryEnum["NC"] = "NC";
    CountryEnum["NZ"] = "NZ";
    CountryEnum["NI"] = "NI";
    CountryEnum["NE"] = "NE";
    CountryEnum["NG"] = "NG";
    CountryEnum["NU"] = "NU";
    CountryEnum["NF"] = "NF";
    CountryEnum["MP"] = "MP";
    CountryEnum["NO"] = "NO";
    CountryEnum["OM"] = "OM";
    CountryEnum["PK"] = "PK";
    CountryEnum["PW"] = "PW";
    CountryEnum["PS"] = "PS";
    CountryEnum["PA"] = "PA";
    CountryEnum["PG"] = "PG";
    CountryEnum["PY"] = "PY";
    CountryEnum["PE"] = "PE";
    CountryEnum["PH"] = "PH";
    CountryEnum["PN"] = "PN";
    CountryEnum["PL"] = "PL";
    CountryEnum["PT"] = "PT";
    CountryEnum["PR"] = "PR";
    CountryEnum["QA"] = "QA";
    CountryEnum["RE"] = "RE";
    CountryEnum["RO"] = "RO";
    CountryEnum["RU"] = "RU";
    CountryEnum["RW"] = "RW";
    CountryEnum["BL"] = "BL";
    CountryEnum["SH"] = "SH";
    CountryEnum["KN"] = "KN";
    CountryEnum["LC"] = "LC";
    CountryEnum["MF"] = "MF";
    CountryEnum["PM"] = "PM";
    CountryEnum["VC"] = "VC";
    CountryEnum["WS"] = "WS";
    CountryEnum["SM"] = "SM";
    CountryEnum["ST"] = "ST";
    CountryEnum["SA"] = "SA";
    CountryEnum["SN"] = "SN";
    CountryEnum["RS"] = "RS";
    CountryEnum["SC"] = "SC";
    CountryEnum["SL"] = "SL";
    CountryEnum["SG"] = "SG";
    CountryEnum["SX"] = "SX";
    CountryEnum["SK"] = "SK";
    CountryEnum["SI"] = "SI";
    CountryEnum["SB"] = "SB";
    CountryEnum["SO"] = "SO";
    CountryEnum["ZA"] = "ZA";
    CountryEnum["GS"] = "GS";
    CountryEnum["SS"] = "SS";
    CountryEnum["ES"] = "ES";
    CountryEnum["LK"] = "LK";
    CountryEnum["SD"] = "SD";
    CountryEnum["SR"] = "SR";
    CountryEnum["SJ"] = "SJ";
    CountryEnum["SZ"] = "SZ";
    CountryEnum["SE"] = "SE";
    CountryEnum["CH"] = "CH";
    CountryEnum["SY"] = "SY";
    CountryEnum["TW"] = "TW";
    CountryEnum["TJ"] = "TJ";
    CountryEnum["TZ"] = "TZ";
    CountryEnum["TH"] = "TH";
    CountryEnum["TL"] = "TL";
    CountryEnum["TG"] = "TG";
    CountryEnum["TK"] = "TK";
    CountryEnum["TO"] = "TO";
    CountryEnum["TT"] = "TT";
    CountryEnum["TN"] = "TN";
    CountryEnum["TR"] = "TR";
    CountryEnum["TM"] = "TM";
    CountryEnum["TC"] = "TC";
    CountryEnum["TV"] = "TV";
    CountryEnum["UG"] = "UG";
    CountryEnum["UA"] = "UA";
    CountryEnum["AE"] = "AE";
    CountryEnum["GB"] = "GB";
    CountryEnum["UM"] = "UM";
    CountryEnum["US"] = "US";
    CountryEnum["UY"] = "UY";
    CountryEnum["UZ"] = "UZ";
    CountryEnum["VU"] = "VU";
    CountryEnum["VE"] = "VE";
    CountryEnum["VN"] = "VN";
    CountryEnum["VG"] = "VG";
    CountryEnum["VI"] = "VI";
    CountryEnum["WF"] = "WF";
    CountryEnum["EH"] = "EH";
    CountryEnum["YE"] = "YE";
    CountryEnum["ZM"] = "ZM";
    CountryEnum["ZW"] = "ZW";
    return CountryEnum;
  }({});
  _BackendEnums.CountryEnum = CountryEnum;
  let CreditNoteStatusEnum = /*#__PURE__*/function (CreditNoteStatusEnum) {
    CreditNoteStatusEnum["NEW"] = "NEW";
    CreditNoteStatusEnum["SYNCED"] = "SYNCED";
    CreditNoteStatusEnum["FAILED"] = "FAILED";
    return CreditNoteStatusEnum;
  }({});
  _BackendEnums.CreditNoteStatusEnum = CreditNoteStatusEnum;
  let CreditNoteVariableSymbolSourceEnum = /*#__PURE__*/function (CreditNoteVariableSymbolSourceEnum) {
    CreditNoteVariableSymbolSourceEnum["TICKET_CODE"] = "TICKET_CODE";
    CreditNoteVariableSymbolSourceEnum["ORDER_CODE"] = "ORDER_CODE";
    CreditNoteVariableSymbolSourceEnum["ORDER_REMOTE_ID"] = "ORDER_REMOTE_ID";
    return CreditNoteVariableSymbolSourceEnum;
  }({});
  _BackendEnums.CreditNoteVariableSymbolSourceEnum = CreditNoteVariableSymbolSourceEnum;
  let CurrencyEnum = /*#__PURE__*/function (CurrencyEnum) {
    CurrencyEnum["AUD"] = "AUD";
    CurrencyEnum["BGN"] = "BGN";
    CurrencyEnum["CAD"] = "CAD";
    CurrencyEnum["CHF"] = "CHF";
    CurrencyEnum["CZK"] = "CZK";
    CurrencyEnum["DKK"] = "DKK";
    CurrencyEnum["EUR"] = "EUR";
    CurrencyEnum["GBP"] = "GBP";
    CurrencyEnum["HRK"] = "HRK";
    CurrencyEnum["HUF"] = "HUF";
    CurrencyEnum["ILS"] = "ILS";
    CurrencyEnum["JPY"] = "JPY";
    CurrencyEnum["MXN"] = "MXN";
    CurrencyEnum["NOK"] = "NOK";
    CurrencyEnum["PLN"] = "PLN";
    CurrencyEnum["RON"] = "RON";
    CurrencyEnum["SEK"] = "SEK";
    CurrencyEnum["SGD"] = "SGD";
    CurrencyEnum["THB"] = "THB";
    CurrencyEnum["UAH"] = "UAH";
    CurrencyEnum["USD"] = "USD";
    return CurrencyEnum;
  }({});
  _BackendEnums.CurrencyEnum = CurrencyEnum;
  let CustomFieldTypeEnum = /*#__PURE__*/function (CustomFieldTypeEnum) {
    CustomFieldTypeEnum["BANK_ACCOUNT"] = "BANK_ACCOUNT";
    CustomFieldTypeEnum["CHAR"] = "CHAR";
    CustomFieldTypeEnum["DATE"] = "DATE";
    CustomFieldTypeEnum["MULTILINE"] = "MULTILINE";
    CustomFieldTypeEnum["NUMERIC"] = "NUMERIC";
    CustomFieldTypeEnum["BOOL"] = "BOOL";
    CustomFieldTypeEnum["SELECT"] = "SELECT";
    CustomFieldTypeEnum["SELECTMULTI"] = "SELECTMULTI";
    CustomFieldTypeEnum["URL"] = "URL";
    CustomFieldTypeEnum["FILE"] = "FILE";
    CustomFieldTypeEnum["CZECH_BANK_ACCOUNT"] = "CZECH_BANK_ACCOUNT";
    CustomFieldTypeEnum["IBAN"] = "IBAN";
    return CustomFieldTypeEnum;
  }({});
  _BackendEnums.CustomFieldTypeEnum = CustomFieldTypeEnum;
  let CustomRefundExportFieldsEnum = /*#__PURE__*/function (CustomRefundExportFieldsEnum) {
    CustomRefundExportFieldsEnum["RECIPIENT_NAME"] = "recipient_name";
    CustomRefundExportFieldsEnum["TICKET__CODE"] = "ticket__code";
    CustomRefundExportFieldsEnum["VALUE"] = "value";
    CustomRefundExportFieldsEnum["CURRENCY"] = "currency";
    CustomRefundExportFieldsEnum["VALID_UNTIL"] = "valid_until";
    CustomRefundExportFieldsEnum["MESSAGE"] = "message";
    CustomRefundExportFieldsEnum["TICKET__TYPE__NAME"] = "ticket__type__name";
    CustomRefundExportFieldsEnum["TICKET__BOUND_ORDER__CODE"] = "ticket__bound_order__code";
    CustomRefundExportFieldsEnum["TICKET__BOUND_ORDER__CUSTOMER_EMAIL"] = "ticket__bound_order__customer_email";
    CustomRefundExportFieldsEnum["TICKET__BOUND_ORDER__CUSTOMER_PHONE"] = "ticket__bound_order__customer_phone";
    CustomRefundExportFieldsEnum["TICKET__BOUND_ORDER__TRACKING_NUMBER"] = "ticket__bound_order__tracking_number";
    CustomRefundExportFieldsEnum["ANNOTATED_BANK_ACCOUNT"] = "annotated_bank_account";
    return CustomRefundExportFieldsEnum;
  }({});
  _BackendEnums.CustomRefundExportFieldsEnum = CustomRefundExportFieldsEnum;
  let CustomerAddressTypeEnum = /*#__PURE__*/function (CustomerAddressTypeEnum) {
    CustomerAddressTypeEnum["BILLING"] = "billing";
    CustomerAddressTypeEnum["SHIPPING"] = "shipping";
    return CustomerAddressTypeEnum;
  }({});
  _BackendEnums.CustomerAddressTypeEnum = CustomerAddressTypeEnum;
  let CustomerCdpMetadataStatusEnum = /*#__PURE__*/function (CustomerCdpMetadataStatusEnum) {
    CustomerCdpMetadataStatusEnum["DISABLED"] = "DISABLED";
    CustomerCdpMetadataStatusEnum["BUILDING"] = "BUILDING";
    CustomerCdpMetadataStatusEnum["READY"] = "READY";
    return CustomerCdpMetadataStatusEnum;
  }({});
  _BackendEnums.CustomerCdpMetadataStatusEnum = CustomerCdpMetadataStatusEnum;
  let CustomerLifecycleStageEnum = /*#__PURE__*/function (CustomerLifecycleStageEnum) {
    CustomerLifecycleStageEnum["NEW"] = "new";
    CustomerLifecycleStageEnum["DORMANT"] = "dormant";
    CustomerLifecycleStageEnum["AT_RISK"] = "at_risk";
    CustomerLifecycleStageEnum["LOYAL"] = "loyal";
    CustomerLifecycleStageEnum["ACTIVE"] = "active";
    return CustomerLifecycleStageEnum;
  }({});
  _BackendEnums.CustomerLifecycleStageEnum = CustomerLifecycleStageEnum;
  let CustomerRatingEnum = /*#__PURE__*/function (CustomerRatingEnum) {
    CustomerRatingEnum[CustomerRatingEnum["VALUE_0"] = 0] = "VALUE_0";
    CustomerRatingEnum[CustomerRatingEnum["VALUE_1"] = 1] = "VALUE_1";
    CustomerRatingEnum[CustomerRatingEnum["VALUE_2"] = 2] = "VALUE_2";
    return CustomerRatingEnum;
  }({});
  _BackendEnums.CustomerRatingEnum = CustomerRatingEnum;
  let CustomerRiskLevelEnum = /*#__PURE__*/function (CustomerRiskLevelEnum) {
    CustomerRiskLevelEnum["HIGH"] = "high";
    CustomerRiskLevelEnum["MEDIUM"] = "medium";
    CustomerRiskLevelEnum["NONE"] = "none";
    return CustomerRiskLevelEnum;
  }({});
  _BackendEnums.CustomerRiskLevelEnum = CustomerRiskLevelEnum;
  let CustomerSegmentEnum = /*#__PURE__*/function (CustomerSegmentEnum) {
    CustomerSegmentEnum["FRAGILE_FIRST"] = "fragile_first";
    CustomerSegmentEnum["FADING_REGULAR"] = "fading_regular";
    CustomerSegmentEnum["VIP"] = "vip";
    CustomerSegmentEnum["SERIAL_RETURNER"] = "serial_returner";
    CustomerSegmentEnum["CLAIM_FREQUENT"] = "claim_frequent";
    CustomerSegmentEnum["LOYAL_AMBASSADOR"] = "loyal_ambassador";
    CustomerSegmentEnum["NEW_RISING"] = "new_rising";
    CustomerSegmentEnum["DORMANT"] = "dormant";
    CustomerSegmentEnum["ONE_TIME_BUYER"] = "one_time_buyer";
    CustomerSegmentEnum["STANDARD"] = "standard";
    return CustomerSegmentEnum;
  }({});
  _BackendEnums.CustomerSegmentEnum = CustomerSegmentEnum;
  let CustomerTimelineItemTypeEnum = /*#__PURE__*/function (CustomerTimelineItemTypeEnum) {
    CustomerTimelineItemTypeEnum["ORDER"] = "order";
    CustomerTimelineItemTypeEnum["TICKET"] = "ticket";
    CustomerTimelineItemTypeEnum["MESSAGE"] = "message";
    CustomerTimelineItemTypeEnum["NOTE"] = "note";
    return CustomerTimelineItemTypeEnum;
  }({});
  _BackendEnums.CustomerTimelineItemTypeEnum = CustomerTimelineItemTypeEnum;
  let DataRetentionPolicyEnum = /*#__PURE__*/function (DataRetentionPolicyEnum) {
    DataRetentionPolicyEnum["PRIVATE_DATA"] = "private_data";
    DataRetentionPolicyEnum["ALL_DATA"] = "all_data";
    return DataRetentionPolicyEnum;
  }({});
  _BackendEnums.DataRetentionPolicyEnum = DataRetentionPolicyEnum;
  let DirectionEnum = /*#__PURE__*/function (DirectionEnum) {
    DirectionEnum["IN"] = "in";
    DirectionEnum["OUT"] = "out";
    return DirectionEnum;
  }({});
  _BackendEnums.DirectionEnum = DirectionEnum;
  let DocumentsStatusEnum = /*#__PURE__*/function (DocumentsStatusEnum) {
    DocumentsStatusEnum["NOT_REQUIRED"] = "NOT_REQUIRED";
    DocumentsStatusEnum["PENDING"] = "PENDING";
    DocumentsStatusEnum["SYNCING"] = "SYNCING";
    DocumentsStatusEnum["FAILED"] = "FAILED";
    DocumentsStatusEnum["DONE"] = "DONE";
    return DocumentsStatusEnum;
  }({});
  _BackendEnums.DocumentsStatusEnum = DocumentsStatusEnum;
  let DropOffBranchShippingProvidersEnum = /*#__PURE__*/function (DropOffBranchShippingProvidersEnum) {
    DropOffBranchShippingProvidersEnum["ZASILKOVNA"] = "ZASILKOVNA";
    DropOffBranchShippingProvidersEnum["MY_GLS_DROPOFF"] = "MY_GLS_DROPOFF";
    DropOffBranchShippingProvidersEnum["DPD_DROPOFF"] = "DPD_DROPOFF";
    DropOffBranchShippingProvidersEnum["RETINO_PPL"] = "RETINO_PPL";
    DropOffBranchShippingProvidersEnum["CUSTOMER_RETINO_PPL"] = "CUSTOMER_RETINO_PPL";
    DropOffBranchShippingProvidersEnum["CUSTOMER_RETINO_GLS_DROPOFF"] = "CUSTOMER_RETINO_GLS_DROPOFF";
    DropOffBranchShippingProvidersEnum["LIFTAGO_RETINO_PPL"] = "LIFTAGO_RETINO_PPL";
    DropOffBranchShippingProvidersEnum["GLS_DROPOFF_PL"] = "GLS_DROPOFF_PL";
    DropOffBranchShippingProvidersEnum["RETURN_CONNECT"] = "RETURN_CONNECT";
    DropOffBranchShippingProvidersEnum["DHL_DROPOFF"] = "DHL_DROPOFF";
    return DropOffBranchShippingProvidersEnum;
  }({});
  _BackendEnums.DropOffBranchShippingProvidersEnum = DropOffBranchShippingProvidersEnum;
  let EqualityEnum = /*#__PURE__*/function (EqualityEnum) {
    EqualityEnum["EQUALS_TO"] = "EQUALS_TO";
    EqualityEnum["NOT_EQUALS_TO"] = "NOT_EQUALS_TO";
    EqualityEnum["GREATER_THAN"] = "GREATER_THAN";
    EqualityEnum["LESS_THAN"] = "LESS_THAN";
    EqualityEnum["GREATER_THAN_OR_EQUAL_TO"] = "GREATER_THAN_OR_EQUAL_TO";
    EqualityEnum["LESS_THAN_OR_EQUAL_TO"] = "LESS_THAN_OR_EQUAL_TO";
    EqualityEnum["EARLIER_THAN"] = "EARLIER_THAN";
    EqualityEnum["NOT_EARLIER_THAN"] = "NOT_EARLIER_THAN";
    EqualityEnum["EMPTY_FIELD"] = "EMPTY_FIELD";
    return EqualityEnum;
  }({});
  _BackendEnums.EqualityEnum = EqualityEnum;
  let EventEnum = /*#__PURE__*/function (EventEnum) {
    EventEnum["TICKET_CREATED"] = "ticket.created";
    EventEnum["TICKET_UPDATED"] = "ticket.updated";
    EventEnum["TICKET_PRODUCT_CREATED"] = "ticket.product.created";
    EventEnum["TICKET_PRODUCT_UPDATED"] = "ticket.product.updated";
    EventEnum["TICKET_SHIPPING_CREATED"] = "ticket.shipping.created";
    EventEnum["TICKET_SHIPPING_UPDATED"] = "ticket.shipping.updated";
    EventEnum["TICKET_REFUND_CREATED"] = "ticket.refund.created";
    EventEnum["TICKET_REFUND_UPDATED"] = "ticket.refund.updated";
    EventEnum["RETINO_CREDIT_NOTE_CREATED"] = "retino_credit_note.created";
    EventEnum["RETINO_REFUND_CREATED"] = "retino_refund.created";
    EventEnum["SHIPPING_ORDERED"] = "shipping.ordered";
    return EventEnum;
  }({});
  _BackendEnums.EventEnum = EventEnum;
  let EventsEnum = /*#__PURE__*/function (EventsEnum) {
    EventsEnum["TICKET_CREATED"] = "ticket.created";
    EventsEnum["TICKET_UPDATED"] = "ticket.updated";
    EventsEnum["TICKET_PRODUCT_CREATED"] = "ticket.product.created";
    EventsEnum["TICKET_PRODUCT_UPDATED"] = "ticket.product.updated";
    EventsEnum["TICKET_SHIPPING_CREATED"] = "ticket.shipping.created";
    EventsEnum["TICKET_SHIPPING_UPDATED"] = "ticket.shipping.updated";
    EventsEnum["TICKET_REFUND_CREATED"] = "ticket.refund.created";
    EventsEnum["TICKET_REFUND_UPDATED"] = "ticket.refund.updated";
    EventsEnum["RETINO_CREDIT_NOTE_CREATED"] = "retino_credit_note.created";
    EventsEnum["RETINO_REFUND_CREATED"] = "retino_refund.created";
    EventsEnum["SHIPPING_ORDERED"] = "shipping.ordered";
    return EventsEnum;
  }({});
  _BackendEnums.EventsEnum = EventsEnum;
  let ExchangeOrderStatusEnum = /*#__PURE__*/function (ExchangeOrderStatusEnum) {
    ExchangeOrderStatusEnum["DRAFT"] = "DRAFT";
    ExchangeOrderStatusEnum["CONFIRMED"] = "CONFIRMED";
    ExchangeOrderStatusEnum["AWAITING_DOCUMENTS"] = "AWAITING_DOCUMENTS";
    ExchangeOrderStatusEnum["AWAITING_PAYMENT"] = "AWAITING_PAYMENT";
    ExchangeOrderStatusEnum["COMPLETED"] = "COMPLETED";
    ExchangeOrderStatusEnum["REJECTED"] = "REJECTED";
    ExchangeOrderStatusEnum["EXPIRED"] = "EXPIRED";
    return ExchangeOrderStatusEnum;
  }({});
  _BackendEnums.ExchangeOrderStatusEnum = ExchangeOrderStatusEnum;
  let ExclusionEnum = /*#__PURE__*/function (ExclusionEnum) {
    ExclusionEnum["NO_EXCHANGE"] = "NO_EXCHANGE";
    return ExclusionEnum;
  }({});
  _BackendEnums.ExclusionEnum = ExclusionEnum;
  let ExternalStatusEnum = /*#__PURE__*/function (ExternalStatusEnum) {
    ExternalStatusEnum["STATUS_ORDERED"] = "STATUS_ORDERED";
    ExternalStatusEnum["STATUS_IN_TRANSIT"] = "STATUS_IN_TRANSIT";
    ExternalStatusEnum["STATUS_DELIVERED"] = "STATUS_DELIVERED";
    ExternalStatusEnum["STATUS_UNDELIVERED"] = "STATUS_UNDELIVERED";
    ExternalStatusEnum["STATUS_CANCELED"] = "STATUS_CANCELED";
    ExternalStatusEnum["STATUS_UNKNOWN"] = "STATUS_UNKNOWN";
    return ExternalStatusEnum;
  }({});
  _BackendEnums.ExternalStatusEnum = ExternalStatusEnum;
  let FeaturesEnum = /*#__PURE__*/function (FeaturesEnum) {
    FeaturesEnum["REFUNDS"] = "refunds";
    FeaturesEnum["DOCUMENTS"] = "documents";
    FeaturesEnum["CREDIT_NOTES"] = "credit_notes";
    FeaturesEnum["AUTOMATION"] = "automation";
    FeaturesEnum["SHIPPING"] = "shipping";
    FeaturesEnum["TAGS"] = "tags";
    FeaturesEnum["CUSTOM_FIELDS"] = "custom_fields";
    FeaturesEnum["VIEWS"] = "views";
    FeaturesEnum["TICKET_TYPES"] = "ticket_types";
    FeaturesEnum["PROCESSES"] = "processes";
    FeaturesEnum["CANNED_REPLIES"] = "canned_replies";
    FeaturesEnum["EMAILING"] = "emailing";
    FeaturesEnum["PORTAL_EDIT"] = "portal_edit";
    FeaturesEnum["MARKETPLACE"] = "marketplace";
    FeaturesEnum["API_ACCESS"] = "api_access";
    FeaturesEnum["WEBHOOKS"] = "webhooks";
    FeaturesEnum["TICKET_CREATE"] = "ticket_create";
    FeaturesEnum["USER_SIGNATURES"] = "user_signatures";
    FeaturesEnum["PRODUCTS_PAGE"] = "products_page";
    FeaturesEnum["ACTIVITIES"] = "activities";
    FeaturesEnum["STATS"] = "stats";
    FeaturesEnum["CDP"] = "cdp";
    FeaturesEnum["EXCHANGES"] = "exchanges";
    FeaturesEnum["FLOW"] = "flow";
    FeaturesEnum["CUSTOM_ROLES"] = "custom_roles";
    FeaturesEnum["MCP"] = "mcp";
    FeaturesEnum["TRACKING_TRACKNTRACE"] = "tracking_trackntrace";
    FeaturesEnum["TRACKING_EMAILING"] = "tracking_emailing";
    FeaturesEnum["TRACKING_AUTOMATION"] = "tracking_automation";
    FeaturesEnum["TRACKING_ANALYTICS"] = "tracking_analytics";
    FeaturesEnum["TRACKING_COST_ANALYSIS"] = "tracking_cost_analysis";
    return FeaturesEnum;
  }({});
  _BackendEnums.FeaturesEnum = FeaturesEnum;
  let HistoryItemTypeEnum = /*#__PURE__*/function (HistoryItemTypeEnum) {
    HistoryItemTypeEnum["ACTIVITY"] = "ACTIVITY";
    HistoryItemTypeEnum["CREDIT_NOTE"] = "CREDIT_NOTE";
    HistoryItemTypeEnum["DOCUMENT"] = "DOCUMENT";
    HistoryItemTypeEnum["EXCHANGE_ORDER"] = "EXCHANGE_ORDER";
    HistoryItemTypeEnum["INTERNAL_NOTE"] = "INTERNAL_NOTE";
    HistoryItemTypeEnum["MESSAGE"] = "MESSAGE";
    HistoryItemTypeEnum["RATING_COMMENT"] = "RATING_COMMENT";
    HistoryItemTypeEnum["REFUND_OPTION"] = "REFUND_OPTION";
    HistoryItemTypeEnum["REFUND_REQUEST"] = "REFUND_REQUEST";
    HistoryItemTypeEnum["RETINO_SHIPPING"] = "RETINO_SHIPPING";
    HistoryItemTypeEnum["SHIPPING_REQUEST"] = "SHIPPING_REQUEST";
    HistoryItemTypeEnum["SMS_MESSAGE"] = "SMS_MESSAGE";
    HistoryItemTypeEnum["SYSTEM"] = "SYSTEM";
    HistoryItemTypeEnum["TRANSPORT"] = "TRANSPORT";
    HistoryItemTypeEnum["VOUCHER"] = "VOUCHER";
    return HistoryItemTypeEnum;
  }({});
  _BackendEnums.HistoryItemTypeEnum = HistoryItemTypeEnum;
  let InputRadiusEnum = /*#__PURE__*/function (InputRadiusEnum) {
    InputRadiusEnum["NONE"] = "none";
    InputRadiusEnum["SM"] = "sm";
    InputRadiusEnum["MD"] = "md";
    InputRadiusEnum["LG"] = "lg";
    InputRadiusEnum["FULL"] = "full";
    return InputRadiusEnum;
  }({});
  _BackendEnums.InputRadiusEnum = InputRadiusEnum;
  let InstalledPluginStatusEnum = /*#__PURE__*/function (InstalledPluginStatusEnum) {
    InstalledPluginStatusEnum["NEW"] = "NEW";
    InstalledPluginStatusEnum["SETUP_PROVIDER"] = "SETUP_PROVIDER";
    InstalledPluginStatusEnum["ACTIVE"] = "ACTIVE";
    InstalledPluginStatusEnum["DISABLED"] = "DISABLED";
    return InstalledPluginStatusEnum;
  }({});
  _BackendEnums.InstalledPluginStatusEnum = InstalledPluginStatusEnum;
  let InternalSlugEnum = /*#__PURE__*/function (InternalSlugEnum) {
    InternalSlugEnum["TYPE_RETURN"] = "TYPE_RETURN";
    InternalSlugEnum["TYPE_WARRANTY_CLAIM"] = "TYPE_WARRANTY_CLAIM";
    InternalSlugEnum["TYPE_SUPPLIER_COMPLAINT"] = "TYPE_SUPPLIER_COMPLAINT";
    return InternalSlugEnum;
  }({});
  _BackendEnums.InternalSlugEnum = InternalSlugEnum;
  let InvoiceTypeEnum = /*#__PURE__*/function (InvoiceTypeEnum) {
    InvoiceTypeEnum["PROFORMA_INVOICE"] = "PROFORMA_INVOICE";
    InvoiceTypeEnum["ISSUED_INVOICE"] = "ISSUED_INVOICE";
    InvoiceTypeEnum["ISSUED_CREDIT_NOTICE"] = "ISSUED_CREDIT_NOTICE";
    return InvoiceTypeEnum;
  }({});
  _BackendEnums.InvoiceTypeEnum = InvoiceTypeEnum;
  let IssueTypeEnum = /*#__PURE__*/function (IssueTypeEnum) {
    IssueTypeEnum["NOT_PICKED_UP"] = "NOT_PICKED_UP";
    IssueTypeEnum["DRIVER_NOT_ASSIGNED"] = "DRIVER_NOT_ASSIGNED";
    IssueTypeEnum["IDLE_PACKAGE"] = "IDLE_PACKAGE";
    IssueTypeEnum["PICKUP_DATE_CHANGED"] = "PICKUP_DATE_CHANGED";
    return IssueTypeEnum;
  }({});
  _BackendEnums.IssueTypeEnum = IssueTypeEnum;
  let ItemTypeEnum = /*#__PURE__*/function (ItemTypeEnum) {
    ItemTypeEnum[ItemTypeEnum["VALUE_1"] = 1] = "VALUE_1";
    ItemTypeEnum[ItemTypeEnum["VALUE_2"] = 2] = "VALUE_2";
    ItemTypeEnum[ItemTypeEnum["VALUE_3"] = 3] = "VALUE_3";
    ItemTypeEnum[ItemTypeEnum["VALUE_4"] = 4] = "VALUE_4";
    ItemTypeEnum[ItemTypeEnum["VALUE_5"] = 5] = "VALUE_5";
    ItemTypeEnum[ItemTypeEnum["VALUE_6"] = 6] = "VALUE_6";
    return ItemTypeEnum;
  }({});
  _BackendEnums.ItemTypeEnum = ItemTypeEnum;
  let LabelTypeEnum = /*#__PURE__*/function (LabelTypeEnum) {
    LabelTypeEnum["PRINT_LABEL"] = "PRINT_LABEL";
    LabelTypeEnum["QR_CODE"] = "QR_CODE";
    LabelTypeEnum["DROP_OFF_CODE"] = "DROP_OFF_CODE";
    return LabelTypeEnum;
  }({});
  _BackendEnums.LabelTypeEnum = LabelTypeEnum;
  let LabelTypesEnum = /*#__PURE__*/function (LabelTypesEnum) {
    LabelTypesEnum["PRINT_LABEL"] = "PRINT_LABEL";
    LabelTypesEnum["QR_CODE"] = "QR_CODE";
    LabelTypesEnum["DROP_OFF_CODE"] = "DROP_OFF_CODE";
    return LabelTypesEnum;
  }({});
  _BackendEnums.LabelTypesEnum = LabelTypesEnum;
  let LanguageEnum = /*#__PURE__*/function (LanguageEnum) {
    LanguageEnum["EN"] = "en";
    LanguageEnum["DE"] = "de";
    LanguageEnum["DE-AT"] = "de-at";
    LanguageEnum["DE-CH"] = "de-ch";
    LanguageEnum["CS"] = "cs";
    LanguageEnum["SK"] = "sk";
    LanguageEnum["PL"] = "pl";
    LanguageEnum["HU"] = "hu";
    LanguageEnum["RO"] = "ro";
    LanguageEnum["ES"] = "es";
    LanguageEnum["IT"] = "it";
    LanguageEnum["IT-CH"] = "it-ch";
    LanguageEnum["FR"] = "fr";
    LanguageEnum["FR-CH"] = "fr-ch";
    LanguageEnum["FR-BE"] = "fr-be";
    LanguageEnum["HR"] = "hr";
    LanguageEnum["BG"] = "bg";
    LanguageEnum["SL"] = "sl";
    LanguageEnum["EL"] = "el";
    LanguageEnum["NL"] = "nl";
    LanguageEnum["NL-BE"] = "nl-be";
    LanguageEnum["NB"] = "nb";
    LanguageEnum["LV"] = "lv";
    LanguageEnum["LT"] = "lt";
    LanguageEnum["ET"] = "et";
    LanguageEnum["DA"] = "da";
    LanguageEnum["SV"] = "sv";
    LanguageEnum["FI"] = "fi";
    LanguageEnum["PT"] = "pt";
    LanguageEnum["UK"] = "uk";
    LanguageEnum["SR"] = "sr";
    return LanguageEnum;
  }({});
  _BackendEnums.LanguageEnum = LanguageEnum;
  let MessageListTypeEnum = /*#__PURE__*/function (MessageListTypeEnum) {
    MessageListTypeEnum["AGENT_MESSAGE"] = "AGENT_MESSAGE";
    MessageListTypeEnum["CUSTOMER_MESSAGE"] = "CUSTOMER_MESSAGE";
    MessageListTypeEnum["OTHERS_MESSAGE"] = "OTHERS_MESSAGE";
    MessageListTypeEnum["EMAIL"] = "EMAIL";
    MessageListTypeEnum["SMS"] = "SMS";
    return MessageListTypeEnum;
  }({});
  _BackendEnums.MessageListTypeEnum = MessageListTypeEnum;
  let NotificationTypeEnum = /*#__PURE__*/function (NotificationTypeEnum) {
    NotificationTypeEnum["TICKET_MESSAGE_ADDED_BY_CUSTOMER"] = "TICKET_MESSAGE_ADDED_BY_CUSTOMER";
    NotificationTypeEnum["TICKET_MESSAGE_UNDELIVERED"] = "TICKET_MESSAGE_UNDELIVERED";
    NotificationTypeEnum["TICKET_CREATED_BY_CUSTOMER"] = "TICKET_CREATED_BY_CUSTOMER";
    NotificationTypeEnum["TICKET_UPCOMING_DATE"] = "TICKET_UPCOMING_DATE";
    NotificationTypeEnum["TICKET_ASSIGNED"] = "TICKET_ASSIGNED";
    NotificationTypeEnum["TICKET_RATED"] = "TICKET_RATED";
    NotificationTypeEnum["ACTIVITY_DEADLINE_EXPIRES"] = "ACTIVITY_DEADLINE_EXPIRES";
    NotificationTypeEnum["ACTIVITY_CREATED"] = "ACTIVITY_CREATED";
    return NotificationTypeEnum;
  }({});
  _BackendEnums.NotificationTypeEnum = NotificationTypeEnum;
  let PaymentMethodEnum = /*#__PURE__*/function (PaymentMethodEnum) {
    PaymentMethodEnum["TRANSFER"] = "TRANSFER";
    PaymentMethodEnum["CARD"] = "CARD";
    return PaymentMethodEnum;
  }({});
  _BackendEnums.PaymentMethodEnum = PaymentMethodEnum;
  let PhonePrefixEnum = /*#__PURE__*/function (PhonePrefixEnum) {
    PhonePrefixEnum["+420"] = "+420";
    PhonePrefixEnum["+421"] = "+421";
    return PhonePrefixEnum;
  }({});
  _BackendEnums.PhonePrefixEnum = PhonePrefixEnum;
  let PlatformEnum = /*#__PURE__*/function (PlatformEnum) {
    PlatformEnum["SHOPTET"] = "SHOPTET";
    PlatformEnum["UPGATES"] = "UPGATES";
    PlatformEnum["SHOPIFY"] = "SHOPIFY";
    PlatformEnum["PRESTASHOP"] = "PRESTASHOP";
    PlatformEnum["NETDIRECT"] = "NETDIRECT";
    PlatformEnum["WOOCOMMERCE"] = "WOOCOMMERCE";
    PlatformEnum["MAGENTO_2"] = "MAGENTO_2";
    PlatformEnum["SHOPSYS"] = "SHOPSYS";
    PlatformEnum["SIMPLIA"] = "SIMPLIA";
    PlatformEnum["SHOPRENTER"] = "SHOPRENTER";
    PlatformEnum["BYZNYSWEB"] = "BYZNYSWEB";
    PlatformEnum["IDOSELL"] = "IDOSELL";
    PlatformEnum["CUSTOM"] = "CUSTOM";
    PlatformEnum["MULTIPLATFORM"] = "MULTIPLATFORM";
    return PlatformEnum;
  }({});
  _BackendEnums.PlatformEnum = PlatformEnum;
  let ProductCustomFieldTypeEnum = /*#__PURE__*/function (ProductCustomFieldTypeEnum) {
    ProductCustomFieldTypeEnum["CHAR"] = "CHAR";
    ProductCustomFieldTypeEnum["MULTILINE"] = "MULTILINE";
    ProductCustomFieldTypeEnum["DATE"] = "DATE";
    ProductCustomFieldTypeEnum["SELECT"] = "SELECT";
    ProductCustomFieldTypeEnum["FILE"] = "FILE";
    ProductCustomFieldTypeEnum["LINK"] = "LINK";
    return ProductCustomFieldTypeEnum;
  }({});
  _BackendEnums.ProductCustomFieldTypeEnum = ProductCustomFieldTypeEnum;
  let ProductFieldEnum = /*#__PURE__*/function (ProductFieldEnum) {
    ProductFieldEnum["MANUFACTURER"] = "manufacturer";
    ProductFieldEnum["CATEGORY"] = "category";
    ProductFieldEnum["VARIANT"] = "variant";
    ProductFieldEnum["PRODUCT_ID"] = "product_id";
    ProductFieldEnum["EAN"] = "ean";
    ProductFieldEnum["SERIAL"] = "serial";
    return ProductFieldEnum;
  }({});
  _BackendEnums.ProductFieldEnum = ProductFieldEnum;
  let QrCodeRefundVariableSymbolSourceEnum = /*#__PURE__*/function (QrCodeRefundVariableSymbolSourceEnum) {
    QrCodeRefundVariableSymbolSourceEnum["TICKET_CODE"] = "TICKET_CODE";
    QrCodeRefundVariableSymbolSourceEnum["ORDER_CODE"] = "ORDER_CODE";
    QrCodeRefundVariableSymbolSourceEnum["CREDIT_NOTE_VARIABLE_SYMBOL"] = "CREDIT_NOTE_VARIABLE_SYMBOL";
    return QrCodeRefundVariableSymbolSourceEnum;
  }({});
  _BackendEnums.QrCodeRefundVariableSymbolSourceEnum = QrCodeRefundVariableSymbolSourceEnum;
  let RefundAccountCurrencyEnum = /*#__PURE__*/function (RefundAccountCurrencyEnum) {
    RefundAccountCurrencyEnum["CZK"] = "CZK";
    RefundAccountCurrencyEnum["EUR"] = "EUR";
    RefundAccountCurrencyEnum["HUF"] = "HUF";
    RefundAccountCurrencyEnum["USD"] = "USD";
    RefundAccountCurrencyEnum["GBP"] = "GBP";
    RefundAccountCurrencyEnum["CHF"] = "CHF";
    RefundAccountCurrencyEnum["JPY"] = "JPY";
    RefundAccountCurrencyEnum["CAD"] = "CAD";
    RefundAccountCurrencyEnum["AUD"] = "AUD";
    RefundAccountCurrencyEnum["PLN"] = "PLN";
    RefundAccountCurrencyEnum["NOK"] = "NOK";
    RefundAccountCurrencyEnum["SEK"] = "SEK";
    return RefundAccountCurrencyEnum;
  }({});
  _BackendEnums.RefundAccountCurrencyEnum = RefundAccountCurrencyEnum;
  let RefundBatchStatusEnum = /*#__PURE__*/function (RefundBatchStatusEnum) {
    RefundBatchStatusEnum["UNPROCESSED"] = "unprocessed";
    RefundBatchStatusEnum["PROCESSED"] = "processed";
    RefundBatchStatusEnum["FAILED"] = "failed";
    RefundBatchStatusEnum["RETRYING"] = "retrying";
    return RefundBatchStatusEnum;
  }({});
  _BackendEnums.RefundBatchStatusEnum = RefundBatchStatusEnum;
  let RefundClientTypeEnum = /*#__PURE__*/function (RefundClientTypeEnum) {
    RefundClientTypeEnum["ABO"] = "ABO";
    RefundClientTypeEnum["FIO_ABO"] = "FIO_ABO";
    RefundClientTypeEnum["FIO_PAIN"] = "FIO_PAIN";
    RefundClientTypeEnum["FIO_FOREIGN"] = "FIO_FOREIGN";
    RefundClientTypeEnum["PAIN"] = "PAIN";
    RefundClientTypeEnum["HCT_PAIN"] = "HCT_PAIN";
    RefundClientTypeEnum["CUSTOM"] = "CUSTOM";
    RefundClientTypeEnum["WEBHOOK"] = "WEBHOOK";
    return RefundClientTypeEnum;
  }({});
  _BackendEnums.RefundClientTypeEnum = RefundClientTypeEnum;
  let RefundOptionTypeEnum = /*#__PURE__*/function (RefundOptionTypeEnum) {
    RefundOptionTypeEnum["TO_BANK_ACCOUNT"] = "TO_BANK_ACCOUNT";
    RefundOptionTypeEnum["VOUCHER"] = "VOUCHER";
    RefundOptionTypeEnum["CUSTOM"] = "CUSTOM";
    RefundOptionTypeEnum["WEBHOOK"] = "WEBHOOK";
    return RefundOptionTypeEnum;
  }({});
  _BackendEnums.RefundOptionTypeEnum = RefundOptionTypeEnum;
  let ResultTypeEnum = /*#__PURE__*/function (ResultTypeEnum) {
    ResultTypeEnum["TICKETS"] = "TICKETS";
    ResultTypeEnum["ACTIVITIES"] = "ACTIVITIES";
    ResultTypeEnum["RETINO_SHIPPING"] = "RETINO_SHIPPING";
    ResultTypeEnum["TICKET_PRODUCTS"] = "TICKET_PRODUCTS";
    ResultTypeEnum["CUSTOMERS"] = "CUSTOMERS";
    ResultTypeEnum["TRACKED_SHIPPING"] = "TRACKED_SHIPPING";
    return ResultTypeEnum;
  }({});
  _BackendEnums.ResultTypeEnum = ResultTypeEnum;
  let RunStatusEnum = /*#__PURE__*/function (RunStatusEnum) {
    RunStatusEnum["PENDING"] = "pending";
    RunStatusEnum["RUNNING"] = "running";
    RunStatusEnum["WAITING"] = "waiting";
    RunStatusEnum["DELAYED"] = "delayed";
    RunStatusEnum["COMPLETED"] = "completed";
    RunStatusEnum["FAILED"] = "failed";
    return RunStatusEnum;
  }({});
  _BackendEnums.RunStatusEnum = RunStatusEnum;
  let SectionNameEnum = /*#__PURE__*/function (SectionNameEnum) {
    SectionNameEnum["PRODUCTS"] = "PRODUCTS";
    SectionNameEnum["INFO"] = "INFO";
    SectionNameEnum["HISTORY"] = "HISTORY";
    SectionNameEnum["CUSTOMER"] = "CUSTOMER";
    SectionNameEnum["ORDER_ITEMS"] = "ORDER_ITEMS";
    return SectionNameEnum;
  }({});
  _BackendEnums.SectionNameEnum = SectionNameEnum;
  let SelectedRefundOptionStatusEnum = /*#__PURE__*/function (SelectedRefundOptionStatusEnum) {
    SelectedRefundOptionStatusEnum["WAITING"] = "WAITING";
    SelectedRefundOptionStatusEnum["ACCEPTED"] = "ACCEPTED";
    SelectedRefundOptionStatusEnum["DENIED"] = "DENIED";
    return SelectedRefundOptionStatusEnum;
  }({});
  _BackendEnums.SelectedRefundOptionStatusEnum = SelectedRefundOptionStatusEnum;
  let SettingDealQualificationTicketCountEstimateEnum = /*#__PURE__*/function (SettingDealQualificationTicketCountEstimateEnum) {
    SettingDealQualificationTicketCountEstimateEnum[SettingDealQualificationTicketCountEstimateEnum["VALUE_21"] = 21] = "VALUE_21";
    SettingDealQualificationTicketCountEstimateEnum[SettingDealQualificationTicketCountEstimateEnum["VALUE_22"] = 22] = "VALUE_22";
    SettingDealQualificationTicketCountEstimateEnum[SettingDealQualificationTicketCountEstimateEnum["VALUE_23"] = 23] = "VALUE_23";
    SettingDealQualificationTicketCountEstimateEnum[SettingDealQualificationTicketCountEstimateEnum["VALUE_24"] = 24] = "VALUE_24";
    SettingDealQualificationTicketCountEstimateEnum[SettingDealQualificationTicketCountEstimateEnum["VALUE_25"] = 25] = "VALUE_25";
    return SettingDealQualificationTicketCountEstimateEnum;
  }({});
  _BackendEnums.SettingDealQualificationTicketCountEstimateEnum = SettingDealQualificationTicketCountEstimateEnum;
  let ShippingListBulkActionActionEnum = /*#__PURE__*/function (ShippingListBulkActionActionEnum) {
    ShippingListBulkActionActionEnum["CONFIRM"] = "confirm";
    ShippingListBulkActionActionEnum["DECLINE"] = "decline";
    return ShippingListBulkActionActionEnum;
  }({});
  _BackendEnums.ShippingListBulkActionActionEnum = ShippingListBulkActionActionEnum;
  let ShippingPriceEnum = /*#__PURE__*/function (ShippingPriceEnum) {
    ShippingPriceEnum["BEFOREDISCOUNT"] = "beforeDiscount";
    ShippingPriceEnum["CART"] = "cart";
    ShippingPriceEnum["FREE"] = "free";
    return ShippingPriceEnum;
  }({});
  _BackendEnums.ShippingPriceEnum = ShippingPriceEnum;
  let ShippingProviderConfigSubmitTypeEnum = /*#__PURE__*/function (ShippingProviderConfigSubmitTypeEnum) {
    ShippingProviderConfigSubmitTypeEnum["DROP_OFF"] = "DROP_OFF";
    ShippingProviderConfigSubmitTypeEnum["PICKUP"] = "PICKUP";
    ShippingProviderConfigSubmitTypeEnum["FREIGHT"] = "FREIGHT";
    ShippingProviderConfigSubmitTypeEnum["CUSTOM"] = "CUSTOM";
    ShippingProviderConfigSubmitTypeEnum["IN_PERSON"] = "IN_PERSON";
    return ShippingProviderConfigSubmitTypeEnum;
  }({});
  _BackendEnums.ShippingProviderConfigSubmitTypeEnum = ShippingProviderConfigSubmitTypeEnum;
  let ShippingProvidersEnum = /*#__PURE__*/function (ShippingProvidersEnum) {
    ShippingProvidersEnum["CUSTOM"] = "CUSTOM";
    ShippingProvidersEnum["DHL24_PICKUP"] = "DHL24_PICKUP";
    ShippingProvidersEnum["DHL24_DROP_OFF"] = "DHL24_DROP_OFF";
    ShippingProvidersEnum["DHL_FREIGHT_PICKUP"] = "DHL_FREIGHT_PICKUP";
    ShippingProvidersEnum["DHL_INTERNATIONAL_DROPOFF"] = "DHL_INTERNATIONAL_DROPOFF";
    ShippingProvidersEnum["DPD_BELGIUM_DROPOFF"] = "DPD_BELGIUM_DROPOFF";
    ShippingProvidersEnum["DPD_GEO_API_DROPOFF"] = "DPD_GEO_API_DROPOFF";
    ShippingProvidersEnum["DPD_GEO_API_PICKUP"] = "DPD_GEO_API_PICKUP";
    ShippingProvidersEnum["DPD_HU_DROPOFF"] = "DPD_HU_DROPOFF";
    ShippingProvidersEnum["DPD_HU_PICKUP"] = "DPD_HU_PICKUP";
    ShippingProvidersEnum["DPD_REG_PRIJEMCE_PICKUP"] = "DPD_REG_PRIJEMCE_PICKUP";
    ShippingProvidersEnum["DPD_REG_PRIJEMCE_DROPOFF"] = "DPD_REG_PRIJEMCE_DROPOFF";
    ShippingProvidersEnum["DPD_SK_PICKUP"] = "DPD_SK_PICKUP";
    ShippingProvidersEnum["DPD_SK_DROPOFF"] = "DPD_SK_DROPOFF";
    ShippingProvidersEnum["FOXPOST_RETURNS"] = "FOXPOST_RETURNS";
    ShippingProvidersEnum["GEIS_PICKUP"] = "GEIS_PICKUP";
    ShippingProvidersEnum["GLS_PICKUP"] = "GLS_PICKUP";
    ShippingProvidersEnum["GLS_ISRS"] = "GLS_ISRS";
    ShippingProvidersEnum["GLS_POLAND_API_DROPOFF"] = "GLS_POLAND_API_DROPOFF";
    ShippingProvidersEnum["IN_PERSON"] = "IN_PERSON";
    ShippingProvidersEnum["INPOST_DROP_OFF"] = "INPOST_DROP_OFF";
    ShippingProvidersEnum["INPOST_PICKUP"] = "INPOST_PICKUP";
    ShippingProvidersEnum["LIFTAGO"] = "LIFTAGO";
    ShippingProvidersEnum["MY_GLS_DROP_OFF_CZ"] = "MY_GLS_DROP_OFF_CZ";
    ShippingProvidersEnum["MY_GLS_DROP_OFF_SK"] = "MY_GLS_DROP_OFF_SK";
    ShippingProvidersEnum["MY_GLS_DROP_OFF_HU"] = "MY_GLS_DROP_OFF_HU";
    ShippingProvidersEnum["MY_GLS_BOX_CZ"] = "MY_GLS_BOX_CZ";
    ShippingProvidersEnum["MY_GLS_PICKUP_CZ"] = "MY_GLS_PICKUP_CZ";
    ShippingProvidersEnum["MY_GLS_PICKUP_SK"] = "MY_GLS_PICKUP_SK";
    ShippingProvidersEnum["MY_GLS_PICKUP_HU"] = "MY_GLS_PICKUP_HU";
    ShippingProvidersEnum["MY_GLS_PICKUP_SI"] = "MY_GLS_PICKUP_SI";
    ShippingProvidersEnum["MY_GLS_PICKUP_HR"] = "MY_GLS_PICKUP_HR";
    ShippingProvidersEnum["MY_PPL_PICKUP"] = "MY_PPL_PICKUP";
    ShippingProvidersEnum["PACKETA_CLAIM_ASSISTANT"] = "PACKETA_CLAIM_ASSISTANT";
    ShippingProvidersEnum["MY_PPL_CPL_DROPOFF"] = "MY_PPL_CPL_DROPOFF";
    ShippingProvidersEnum["MY_PPL_CPL_PICKUP"] = "MY_PPL_CPL_PICKUP";
    ShippingProvidersEnum["PPL_RETURN_CONNECT_DROPOFF"] = "PPL_RETURN_CONNECT_DROPOFF";
    ShippingProvidersEnum["PPL_RETURN_CONNECT_PICKUP"] = "PPL_RETURN_CONNECT_PICKUP";
    ShippingProvidersEnum["RABEN_FREIGHT"] = "RABEN_FREIGHT";
    ShippingProvidersEnum["SPS_DROPOFF"] = "SPS_DROPOFF";
    ShippingProvidersEnum["UPS_PICKUP"] = "UPS_PICKUP";
    return ShippingProvidersEnum;
  }({});
  _BackendEnums.ShippingProvidersEnum = ShippingProvidersEnum;
  let ShippingProvidersListResponseSubmitTypeEnum = /*#__PURE__*/function (ShippingProvidersListResponseSubmitTypeEnum) {
    ShippingProvidersListResponseSubmitTypeEnum["PICKUP"] = "PICKUP";
    ShippingProvidersListResponseSubmitTypeEnum["DROP_OFF"] = "DROP_OFF";
    ShippingProvidersListResponseSubmitTypeEnum["OTHER"] = "OTHER";
    return ShippingProvidersListResponseSubmitTypeEnum;
  }({});
  _BackendEnums.ShippingProvidersListResponseSubmitTypeEnum = ShippingProvidersListResponseSubmitTypeEnum;
  let ShippingStatusEnum = /*#__PURE__*/function (ShippingStatusEnum) {
    ShippingStatusEnum["CONFIRMATION_REQUIRED"] = "CONFIRMATION_REQUIRED";
    ShippingStatusEnum["WAITING"] = "WAITING";
    ShippingStatusEnum["SYNCING"] = "SYNCING";
    ShippingStatusEnum["FINISHED"] = "FINISHED";
    ShippingStatusEnum["REFUNDED"] = "REFUNDED";
    ShippingStatusEnum["CANCELED"] = "CANCELED";
    ShippingStatusEnum["DECLINED"] = "DECLINED";
    ShippingStatusEnum["FAILURE"] = "FAILURE";
    ShippingStatusEnum["VOIDED"] = "VOIDED";
    return ShippingStatusEnum;
  }({});
  _BackendEnums.ShippingStatusEnum = ShippingStatusEnum;
  let ShoptetVoucherDiscountTypeEnum = /*#__PURE__*/function (ShoptetVoucherDiscountTypeEnum) {
    ShoptetVoucherDiscountTypeEnum["FIXED"] = "fixed";
    ShoptetVoucherDiscountTypeEnum["PERCENTUAL"] = "percentual";
    return ShoptetVoucherDiscountTypeEnum;
  }({});
  _BackendEnums.ShoptetVoucherDiscountTypeEnum = ShoptetVoucherDiscountTypeEnum;
  let StatusToneEnum = /*#__PURE__*/function (StatusToneEnum) {
    StatusToneEnum["POSITIVE"] = "positive";
    StatusToneEnum["NEGATIVE"] = "negative";
    StatusToneEnum["NEUTRAL"] = "neutral";
    return StatusToneEnum;
  }({});
  _BackendEnums.StatusToneEnum = StatusToneEnum;
  let StepStatusEnum = /*#__PURE__*/function (StepStatusEnum) {
    StepStatusEnum["COMPLETED"] = "completed";
    StepStatusEnum["FAILED"] = "failed";
    return StepStatusEnum;
  }({});
  _BackendEnums.StepStatusEnum = StepStatusEnum;
  let TicketFieldEnum = /*#__PURE__*/function (TicketFieldEnum) {
    TicketFieldEnum["ORDER_ID"] = "order_id";
    TicketFieldEnum["CUSTOMER_EMAIL"] = "customer_email";
    TicketFieldEnum["CUSTOMER_NAME"] = "customer_name";
    TicketFieldEnum["CUSTOMER_PHONE"] = "customer_phone";
    return TicketFieldEnum;
  }({});
  _BackendEnums.TicketFieldEnum = TicketFieldEnum;
  let TicketTypeInternalSlugEnum = /*#__PURE__*/function (TicketTypeInternalSlugEnum) {
    TicketTypeInternalSlugEnum["TYPE_RETURN"] = "TYPE_RETURN";
    TicketTypeInternalSlugEnum["TYPE_WARRANTY_CLAIM"] = "TYPE_WARRANTY_CLAIM";
    TicketTypeInternalSlugEnum["TYPE_SUPPLIER_COMPLAINT"] = "TYPE_SUPPLIER_COMPLAINT";
    return TicketTypeInternalSlugEnum;
  }({});
  _BackendEnums.TicketTypeInternalSlugEnum = TicketTypeInternalSlugEnum;
  let TransportProviderEnum = /*#__PURE__*/function (TransportProviderEnum) {
    TransportProviderEnum["ZASILKOVNA"] = "ZASILKOVNA";
    TransportProviderEnum["GLS"] = "GLS";
    TransportProviderEnum["MY_GLS"] = "MY_GLS";
    TransportProviderEnum["MY_GLS_DROPOFF"] = "MY_GLS_DROPOFF";
    TransportProviderEnum["PPL"] = "PPL";
    TransportProviderEnum["DPD_PICKUP"] = "DPD_PICKUP";
    TransportProviderEnum["DPD_DROPOFF"] = "DPD_DROPOFF";
    TransportProviderEnum["RETINO_PPL"] = "RETINO_PPL";
    TransportProviderEnum["CUSTOMER_RETINO_PPL"] = "CUSTOMER_RETINO_PPL";
    TransportProviderEnum["CUSTOMER_RETINO_GLS_PICKUP"] = "CUSTOMER_RETINO_GLS_PICKUP";
    TransportProviderEnum["CUSTOMER_RETINO_GLS_DROPOFF"] = "CUSTOMER_RETINO_GLS_DROPOFF";
    TransportProviderEnum["LIFTAGO"] = "LIFTAGO";
    TransportProviderEnum["LIFTAGO_RETINO_PPL"] = "LIFTAGO_RETINO_PPL";
    TransportProviderEnum["GEIS"] = "GEIS";
    TransportProviderEnum["GLS_DROPOFF_PL"] = "GLS_DROPOFF_PL";
    TransportProviderEnum["CUSTOMER_RETINO_GLS_PICKUP_SK"] = "CUSTOMER_RETINO_GLS_PICKUP_SK";
    TransportProviderEnum["CUSTOMER_RETINO_GLS_PICKUP_HU"] = "CUSTOMER_RETINO_GLS_PICKUP_HU";
    TransportProviderEnum["RETURN_CONNECT"] = "RETURN_CONNECT";
    TransportProviderEnum["DHL_FREIGHT"] = "DHL_FREIGHT";
    TransportProviderEnum["DHL_DROPOFF"] = "DHL_DROPOFF";
    TransportProviderEnum["CUSTOM_OTHER_PROVIDER"] = "CUSTOM_OTHER_PROVIDER";
    return TransportProviderEnum;
  }({});
  _BackendEnums.TransportProviderEnum = TransportProviderEnum;
  let TransportStatusEnum = /*#__PURE__*/function (TransportStatusEnum) {
    TransportStatusEnum["STATUS_PENDING_CONFIRMATION"] = "STATUS_PENDING_CONFIRMATION";
    TransportStatusEnum["STATUS_INIT"] = "STATUS_INIT";
    TransportStatusEnum["STATUS_ACCEPTED"] = "STATUS_ACCEPTED";
    TransportStatusEnum["STATUS_SUBMITTED"] = "STATUS_SUBMITTED";
    TransportStatusEnum["STATUS_TRANSPORT"] = "STATUS_TRANSPORT";
    TransportStatusEnum["STATUS_DELIVERED"] = "STATUS_DELIVERED";
    TransportStatusEnum["STATUS_UNDELIVERED"] = "STATUS_UNDELIVERED";
    TransportStatusEnum["STATUS_CANCELED"] = "STATUS_CANCELED";
    TransportStatusEnum["STATUS_WAITING_FOR_ORDERING"] = "STATUS_WAITING_FOR_ORDERING";
    TransportStatusEnum["STATUS_REFUNDED"] = "STATUS_REFUNDED";
    TransportStatusEnum["STATUS_UNKNOWN"] = "STATUS_UNKNOWN";
    return TransportStatusEnum;
  }({});
  _BackendEnums.TransportStatusEnum = TransportStatusEnum;
  let TriggerConditionTypeEnum = /*#__PURE__*/function (TriggerConditionTypeEnum) {
    TriggerConditionTypeEnum["STATE"] = "STATE";
    TriggerConditionTypeEnum["TYPE"] = "TYPE";
    TriggerConditionTypeEnum["TAG"] = "TAG";
    TriggerConditionTypeEnum["TICKET_LANGUAGE"] = "TICKET_LANGUAGE";
    TriggerConditionTypeEnum["TICKET_COUNTRY"] = "TICKET_COUNTRY";
    TriggerConditionTypeEnum["TICKET_OWNER"] = "TICKET_OWNER";
    TriggerConditionTypeEnum["TICKET_BOUND_ORDER"] = "TICKET_BOUND_ORDER";
    TriggerConditionTypeEnum["TICKET_VERIFICATION_STATE"] = "TICKET_VERIFICATION_STATE";
    TriggerConditionTypeEnum["TICKET_CURRENCY"] = "TICKET_CURRENCY";
    TriggerConditionTypeEnum["CUSTOM_FIELD"] = "CUSTOM_FIELD";
    TriggerConditionTypeEnum["PREFERRED_SHIPPING"] = "PREFERRED_SHIPPING";
    TriggerConditionTypeEnum["NUMBER_OF_PRODUCTS"] = "NUMBER_OF_PRODUCTS";
    TriggerConditionTypeEnum["SHIPPING_EXTERNAL_STATUS"] = "SHIPPING_EXTERNAL_STATUS";
    TriggerConditionTypeEnum["ORDER_DATE"] = "ORDER_DATE";
    TriggerConditionTypeEnum["TICKET_VALUE"] = "TICKET_VALUE";
    TriggerConditionTypeEnum["ORDER_VALUE"] = "ORDER_VALUE";
    return TriggerConditionTypeEnum;
  }({});
  _BackendEnums.TriggerConditionTypeEnum = TriggerConditionTypeEnum;
  let TriggerLogStateEnum = /*#__PURE__*/function (TriggerLogStateEnum) {
    TriggerLogStateEnum["SUCCESS"] = "SUCCESS";
    TriggerLogStateEnum["FAILED"] = "FAILED";
    TriggerLogStateEnum["CAN_RETRY"] = "CAN_RETRY";
    return TriggerLogStateEnum;
  }({});
  _BackendEnums.TriggerLogStateEnum = TriggerLogStateEnum;
  let TriggerTypeEnum = /*#__PURE__*/function (TriggerTypeEnum) {
    TriggerTypeEnum["TICKET_CREATED_BY_CUSTOMER"] = "TICKET_CREATED_BY_CUSTOMER";
    TriggerTypeEnum["TICKET_CREATED_BY_AGENT"] = "TICKET_CREATED_BY_AGENT";
    TriggerTypeEnum["TICKET_STATE_CHANGED"] = "TICKET_STATE_CHANGED";
    TriggerTypeEnum["TICKET_TAG_ADDED"] = "TICKET_TAG_ADDED";
    TriggerTypeEnum["TICKET_CLOSED"] = "TICKET_CLOSED";
    TriggerTypeEnum["TICKET_OWNER_CHANGED"] = "TICKET_OWNER_CHANGED";
    TriggerTypeEnum["CUSTOMER_SENT_MESSAGE"] = "CUSTOMER_SENT_MESSAGE";
    TriggerTypeEnum["REFUND_REQUEST_CREATED"] = "REFUND_REQUEST_CREATED";
    TriggerTypeEnum["ACTIVITY_CREATED"] = "ACTIVITY_CREATED";
    TriggerTypeEnum["ACTIVITY_DEADLINE_EXPIRED"] = "ACTIVITY_DEADLINE_EXPIRED";
    TriggerTypeEnum["SHIPPING_STATUS_CHANGED"] = "SHIPPING_STATUS_CHANGED";
    return TriggerTypeEnum;
  }({});
  _BackendEnums.TriggerTypeEnum = TriggerTypeEnum;
  let UsageTypeEnum = /*#__PURE__*/function (UsageTypeEnum) {
    UsageTypeEnum["LICENSED"] = "LICENSED";
    UsageTypeEnum["METERED"] = "METERED";
    return UsageTypeEnum;
  }({});
  _BackendEnums.UsageTypeEnum = UsageTypeEnum;
  let UserLanguageEnum = /*#__PURE__*/function (UserLanguageEnum) {
    UserLanguageEnum["EN"] = "en";
    UserLanguageEnum["DE"] = "de";
    UserLanguageEnum["CS"] = "cs";
    UserLanguageEnum["SK"] = "sk";
    UserLanguageEnum["PL"] = "pl";
    UserLanguageEnum["HU"] = "hu";
    UserLanguageEnum["RO"] = "ro";
    UserLanguageEnum["ES"] = "es";
    UserLanguageEnum["IT"] = "it";
    UserLanguageEnum["FR"] = "fr";
    UserLanguageEnum["HR"] = "hr";
    UserLanguageEnum["BG"] = "bg";
    UserLanguageEnum["SL"] = "sl";
    UserLanguageEnum["EL"] = "el";
    UserLanguageEnum["NL"] = "nl";
    UserLanguageEnum["NB"] = "nb";
    UserLanguageEnum["LV"] = "lv";
    UserLanguageEnum["LT"] = "lt";
    UserLanguageEnum["ET"] = "et";
    UserLanguageEnum["DA"] = "da";
    UserLanguageEnum["SV"] = "sv";
    UserLanguageEnum["FI"] = "fi";
    UserLanguageEnum["PT"] = "pt";
    UserLanguageEnum["UK"] = "uk";
    return UserLanguageEnum;
  }({});
  _BackendEnums.UserLanguageEnum = UserLanguageEnum;
  let VariableSymbolSourceEnum = /*#__PURE__*/function (VariableSymbolSourceEnum) {
    VariableSymbolSourceEnum["TICKET_CODE"] = "TICKET_CODE";
    VariableSymbolSourceEnum["ORDER_CODE"] = "ORDER_CODE";
    VariableSymbolSourceEnum["CREDIT_NOTE_VARIABLE_SYMBOL"] = "CREDIT_NOTE_VARIABLE_SYMBOL";
    return VariableSymbolSourceEnum;
  }({});
  _BackendEnums.VariableSymbolSourceEnum = VariableSymbolSourceEnum;
  let VerificationStateEnum = /*#__PURE__*/function (VerificationStateEnum) {
    VerificationStateEnum["VERIFIED_AUTOMATICALLY"] = "VERIFIED_AUTOMATICALLY";
    VerificationStateEnum["VERIFIED_MANUALLY"] = "VERIFIED_MANUALLY";
    VerificationStateEnum["UNVERIFIED"] = "UNVERIFIED";
    return VerificationStateEnum;
  }({});
  _BackendEnums.VerificationStateEnum = VerificationStateEnum;
  let WebhookEndpointStatusEnum = /*#__PURE__*/function (WebhookEndpointStatusEnum) {
    WebhookEndpointStatusEnum["ENABLED"] = "enabled";
    WebhookEndpointStatusEnum["DISABLED"] = "disabled";
    return WebhookEndpointStatusEnum;
  }({});
  _BackendEnums.WebhookEndpointStatusEnum = WebhookEndpointStatusEnum;
  let WebhookStatusEnum = /*#__PURE__*/function (WebhookStatusEnum) {
    WebhookStatusEnum["PENDING"] = "pending";
    WebhookStatusEnum["SUCCESS"] = "success";
    WebhookStatusEnum["RETRYING"] = "retrying";
    WebhookStatusEnum["FAILURE"] = "failure";
    return WebhookStatusEnum;
  }({});
  _BackendEnums.WebhookStatusEnum = WebhookStatusEnum;
  let WooCommerceVoucherDiscountTypeEnum = /*#__PURE__*/function (WooCommerceVoucherDiscountTypeEnum) {
    WooCommerceVoucherDiscountTypeEnum["FIXED_CART"] = "fixed_cart";
    WooCommerceVoucherDiscountTypeEnum["PERCENT"] = "percent";
    WooCommerceVoucherDiscountTypeEnum["FIXED_PRODUCT"] = "fixed_product";
    WooCommerceVoucherDiscountTypeEnum["PERCENT_PRODUCT"] = "percent_product";
    return WooCommerceVoucherDiscountTypeEnum;
  }({});
  _BackendEnums.WooCommerceVoucherDiscountTypeEnum = WooCommerceVoucherDiscountTypeEnum;
  let ActivitiesListStatusEnum = /*#__PURE__*/function (ActivitiesListStatusEnum) {
    ActivitiesListStatusEnum["STATUS_CLOSED"] = "STATUS_CLOSED";
    ActivitiesListStatusEnum["STATUS_OPEN"] = "STATUS_OPEN";
    return ActivitiesListStatusEnum;
  }({});
  _BackendEnums.ActivitiesListStatusEnum = ActivitiesListStatusEnum;
  let ActivitiesListTicketCountryEnum = /*#__PURE__*/function (ActivitiesListTicketCountryEnum) {
    ActivitiesListTicketCountryEnum["AD"] = "AD";
    ActivitiesListTicketCountryEnum["AE"] = "AE";
    ActivitiesListTicketCountryEnum["AF"] = "AF";
    ActivitiesListTicketCountryEnum["AG"] = "AG";
    ActivitiesListTicketCountryEnum["AI"] = "AI";
    ActivitiesListTicketCountryEnum["AL"] = "AL";
    ActivitiesListTicketCountryEnum["AM"] = "AM";
    ActivitiesListTicketCountryEnum["AO"] = "AO";
    ActivitiesListTicketCountryEnum["AQ"] = "AQ";
    ActivitiesListTicketCountryEnum["AR"] = "AR";
    ActivitiesListTicketCountryEnum["AS"] = "AS";
    ActivitiesListTicketCountryEnum["AT"] = "AT";
    ActivitiesListTicketCountryEnum["AU"] = "AU";
    ActivitiesListTicketCountryEnum["AW"] = "AW";
    ActivitiesListTicketCountryEnum["AX"] = "AX";
    ActivitiesListTicketCountryEnum["AZ"] = "AZ";
    ActivitiesListTicketCountryEnum["BA"] = "BA";
    ActivitiesListTicketCountryEnum["BB"] = "BB";
    ActivitiesListTicketCountryEnum["BD"] = "BD";
    ActivitiesListTicketCountryEnum["BE"] = "BE";
    ActivitiesListTicketCountryEnum["BF"] = "BF";
    ActivitiesListTicketCountryEnum["BG"] = "BG";
    ActivitiesListTicketCountryEnum["BH"] = "BH";
    ActivitiesListTicketCountryEnum["BI"] = "BI";
    ActivitiesListTicketCountryEnum["BJ"] = "BJ";
    ActivitiesListTicketCountryEnum["BL"] = "BL";
    ActivitiesListTicketCountryEnum["BM"] = "BM";
    ActivitiesListTicketCountryEnum["BN"] = "BN";
    ActivitiesListTicketCountryEnum["BO"] = "BO";
    ActivitiesListTicketCountryEnum["BQ"] = "BQ";
    ActivitiesListTicketCountryEnum["BR"] = "BR";
    ActivitiesListTicketCountryEnum["BS"] = "BS";
    ActivitiesListTicketCountryEnum["BT"] = "BT";
    ActivitiesListTicketCountryEnum["BV"] = "BV";
    ActivitiesListTicketCountryEnum["BW"] = "BW";
    ActivitiesListTicketCountryEnum["BY"] = "BY";
    ActivitiesListTicketCountryEnum["BZ"] = "BZ";
    ActivitiesListTicketCountryEnum["CA"] = "CA";
    ActivitiesListTicketCountryEnum["CC"] = "CC";
    ActivitiesListTicketCountryEnum["CD"] = "CD";
    ActivitiesListTicketCountryEnum["CF"] = "CF";
    ActivitiesListTicketCountryEnum["CG"] = "CG";
    ActivitiesListTicketCountryEnum["CH"] = "CH";
    ActivitiesListTicketCountryEnum["CI"] = "CI";
    ActivitiesListTicketCountryEnum["CK"] = "CK";
    ActivitiesListTicketCountryEnum["CL"] = "CL";
    ActivitiesListTicketCountryEnum["CM"] = "CM";
    ActivitiesListTicketCountryEnum["CN"] = "CN";
    ActivitiesListTicketCountryEnum["CO"] = "CO";
    ActivitiesListTicketCountryEnum["CR"] = "CR";
    ActivitiesListTicketCountryEnum["CU"] = "CU";
    ActivitiesListTicketCountryEnum["CV"] = "CV";
    ActivitiesListTicketCountryEnum["CW"] = "CW";
    ActivitiesListTicketCountryEnum["CX"] = "CX";
    ActivitiesListTicketCountryEnum["CY"] = "CY";
    ActivitiesListTicketCountryEnum["CZ"] = "CZ";
    ActivitiesListTicketCountryEnum["DE"] = "DE";
    ActivitiesListTicketCountryEnum["DJ"] = "DJ";
    ActivitiesListTicketCountryEnum["DK"] = "DK";
    ActivitiesListTicketCountryEnum["DM"] = "DM";
    ActivitiesListTicketCountryEnum["DO"] = "DO";
    ActivitiesListTicketCountryEnum["DZ"] = "DZ";
    ActivitiesListTicketCountryEnum["EC"] = "EC";
    ActivitiesListTicketCountryEnum["EE"] = "EE";
    ActivitiesListTicketCountryEnum["EG"] = "EG";
    ActivitiesListTicketCountryEnum["EH"] = "EH";
    ActivitiesListTicketCountryEnum["ER"] = "ER";
    ActivitiesListTicketCountryEnum["ES"] = "ES";
    ActivitiesListTicketCountryEnum["ET"] = "ET";
    ActivitiesListTicketCountryEnum["FI"] = "FI";
    ActivitiesListTicketCountryEnum["FJ"] = "FJ";
    ActivitiesListTicketCountryEnum["FK"] = "FK";
    ActivitiesListTicketCountryEnum["FM"] = "FM";
    ActivitiesListTicketCountryEnum["FO"] = "FO";
    ActivitiesListTicketCountryEnum["FR"] = "FR";
    ActivitiesListTicketCountryEnum["GA"] = "GA";
    ActivitiesListTicketCountryEnum["GB"] = "GB";
    ActivitiesListTicketCountryEnum["GD"] = "GD";
    ActivitiesListTicketCountryEnum["GE"] = "GE";
    ActivitiesListTicketCountryEnum["GF"] = "GF";
    ActivitiesListTicketCountryEnum["GG"] = "GG";
    ActivitiesListTicketCountryEnum["GH"] = "GH";
    ActivitiesListTicketCountryEnum["GI"] = "GI";
    ActivitiesListTicketCountryEnum["GL"] = "GL";
    ActivitiesListTicketCountryEnum["GM"] = "GM";
    ActivitiesListTicketCountryEnum["GN"] = "GN";
    ActivitiesListTicketCountryEnum["GP"] = "GP";
    ActivitiesListTicketCountryEnum["GQ"] = "GQ";
    ActivitiesListTicketCountryEnum["GR"] = "GR";
    ActivitiesListTicketCountryEnum["GS"] = "GS";
    ActivitiesListTicketCountryEnum["GT"] = "GT";
    ActivitiesListTicketCountryEnum["GU"] = "GU";
    ActivitiesListTicketCountryEnum["GW"] = "GW";
    ActivitiesListTicketCountryEnum["GY"] = "GY";
    ActivitiesListTicketCountryEnum["HK"] = "HK";
    ActivitiesListTicketCountryEnum["HM"] = "HM";
    ActivitiesListTicketCountryEnum["HN"] = "HN";
    ActivitiesListTicketCountryEnum["HR"] = "HR";
    ActivitiesListTicketCountryEnum["HT"] = "HT";
    ActivitiesListTicketCountryEnum["HU"] = "HU";
    ActivitiesListTicketCountryEnum["ID"] = "ID";
    ActivitiesListTicketCountryEnum["IE"] = "IE";
    ActivitiesListTicketCountryEnum["IL"] = "IL";
    ActivitiesListTicketCountryEnum["IM"] = "IM";
    ActivitiesListTicketCountryEnum["IN"] = "IN";
    ActivitiesListTicketCountryEnum["IO"] = "IO";
    ActivitiesListTicketCountryEnum["IQ"] = "IQ";
    ActivitiesListTicketCountryEnum["IR"] = "IR";
    ActivitiesListTicketCountryEnum["IS"] = "IS";
    ActivitiesListTicketCountryEnum["IT"] = "IT";
    ActivitiesListTicketCountryEnum["JE"] = "JE";
    ActivitiesListTicketCountryEnum["JM"] = "JM";
    ActivitiesListTicketCountryEnum["JO"] = "JO";
    ActivitiesListTicketCountryEnum["JP"] = "JP";
    ActivitiesListTicketCountryEnum["KE"] = "KE";
    ActivitiesListTicketCountryEnum["KG"] = "KG";
    ActivitiesListTicketCountryEnum["KH"] = "KH";
    ActivitiesListTicketCountryEnum["KI"] = "KI";
    ActivitiesListTicketCountryEnum["KM"] = "KM";
    ActivitiesListTicketCountryEnum["KN"] = "KN";
    ActivitiesListTicketCountryEnum["KP"] = "KP";
    ActivitiesListTicketCountryEnum["KR"] = "KR";
    ActivitiesListTicketCountryEnum["KW"] = "KW";
    ActivitiesListTicketCountryEnum["KY"] = "KY";
    ActivitiesListTicketCountryEnum["KZ"] = "KZ";
    ActivitiesListTicketCountryEnum["LA"] = "LA";
    ActivitiesListTicketCountryEnum["LB"] = "LB";
    ActivitiesListTicketCountryEnum["LC"] = "LC";
    ActivitiesListTicketCountryEnum["LI"] = "LI";
    ActivitiesListTicketCountryEnum["LK"] = "LK";
    ActivitiesListTicketCountryEnum["LR"] = "LR";
    ActivitiesListTicketCountryEnum["LS"] = "LS";
    ActivitiesListTicketCountryEnum["LT"] = "LT";
    ActivitiesListTicketCountryEnum["LU"] = "LU";
    ActivitiesListTicketCountryEnum["LV"] = "LV";
    ActivitiesListTicketCountryEnum["LY"] = "LY";
    ActivitiesListTicketCountryEnum["MA"] = "MA";
    ActivitiesListTicketCountryEnum["MC"] = "MC";
    ActivitiesListTicketCountryEnum["MD"] = "MD";
    ActivitiesListTicketCountryEnum["ME"] = "ME";
    ActivitiesListTicketCountryEnum["MF"] = "MF";
    ActivitiesListTicketCountryEnum["MG"] = "MG";
    ActivitiesListTicketCountryEnum["MH"] = "MH";
    ActivitiesListTicketCountryEnum["MK"] = "MK";
    ActivitiesListTicketCountryEnum["ML"] = "ML";
    ActivitiesListTicketCountryEnum["MM"] = "MM";
    ActivitiesListTicketCountryEnum["MN"] = "MN";
    ActivitiesListTicketCountryEnum["MO"] = "MO";
    ActivitiesListTicketCountryEnum["MP"] = "MP";
    ActivitiesListTicketCountryEnum["MQ"] = "MQ";
    ActivitiesListTicketCountryEnum["MR"] = "MR";
    ActivitiesListTicketCountryEnum["MS"] = "MS";
    ActivitiesListTicketCountryEnum["MT"] = "MT";
    ActivitiesListTicketCountryEnum["MU"] = "MU";
    ActivitiesListTicketCountryEnum["MV"] = "MV";
    ActivitiesListTicketCountryEnum["MW"] = "MW";
    ActivitiesListTicketCountryEnum["MX"] = "MX";
    ActivitiesListTicketCountryEnum["MY"] = "MY";
    ActivitiesListTicketCountryEnum["MZ"] = "MZ";
    ActivitiesListTicketCountryEnum["NA"] = "NA";
    ActivitiesListTicketCountryEnum["NC"] = "NC";
    ActivitiesListTicketCountryEnum["NE"] = "NE";
    ActivitiesListTicketCountryEnum["NF"] = "NF";
    ActivitiesListTicketCountryEnum["NG"] = "NG";
    ActivitiesListTicketCountryEnum["NI"] = "NI";
    ActivitiesListTicketCountryEnum["NL"] = "NL";
    ActivitiesListTicketCountryEnum["NO"] = "NO";
    ActivitiesListTicketCountryEnum["NP"] = "NP";
    ActivitiesListTicketCountryEnum["NR"] = "NR";
    ActivitiesListTicketCountryEnum["NU"] = "NU";
    ActivitiesListTicketCountryEnum["NZ"] = "NZ";
    ActivitiesListTicketCountryEnum["OM"] = "OM";
    ActivitiesListTicketCountryEnum["PA"] = "PA";
    ActivitiesListTicketCountryEnum["PE"] = "PE";
    ActivitiesListTicketCountryEnum["PF"] = "PF";
    ActivitiesListTicketCountryEnum["PG"] = "PG";
    ActivitiesListTicketCountryEnum["PH"] = "PH";
    ActivitiesListTicketCountryEnum["PK"] = "PK";
    ActivitiesListTicketCountryEnum["PL"] = "PL";
    ActivitiesListTicketCountryEnum["PM"] = "PM";
    ActivitiesListTicketCountryEnum["PN"] = "PN";
    ActivitiesListTicketCountryEnum["PR"] = "PR";
    ActivitiesListTicketCountryEnum["PS"] = "PS";
    ActivitiesListTicketCountryEnum["PT"] = "PT";
    ActivitiesListTicketCountryEnum["PW"] = "PW";
    ActivitiesListTicketCountryEnum["PY"] = "PY";
    ActivitiesListTicketCountryEnum["QA"] = "QA";
    ActivitiesListTicketCountryEnum["RE"] = "RE";
    ActivitiesListTicketCountryEnum["RO"] = "RO";
    ActivitiesListTicketCountryEnum["RS"] = "RS";
    ActivitiesListTicketCountryEnum["RU"] = "RU";
    ActivitiesListTicketCountryEnum["RW"] = "RW";
    ActivitiesListTicketCountryEnum["SA"] = "SA";
    ActivitiesListTicketCountryEnum["SB"] = "SB";
    ActivitiesListTicketCountryEnum["SC"] = "SC";
    ActivitiesListTicketCountryEnum["SD"] = "SD";
    ActivitiesListTicketCountryEnum["SE"] = "SE";
    ActivitiesListTicketCountryEnum["SG"] = "SG";
    ActivitiesListTicketCountryEnum["SH"] = "SH";
    ActivitiesListTicketCountryEnum["SI"] = "SI";
    ActivitiesListTicketCountryEnum["SJ"] = "SJ";
    ActivitiesListTicketCountryEnum["SK"] = "SK";
    ActivitiesListTicketCountryEnum["SL"] = "SL";
    ActivitiesListTicketCountryEnum["SM"] = "SM";
    ActivitiesListTicketCountryEnum["SN"] = "SN";
    ActivitiesListTicketCountryEnum["SO"] = "SO";
    ActivitiesListTicketCountryEnum["SR"] = "SR";
    ActivitiesListTicketCountryEnum["SS"] = "SS";
    ActivitiesListTicketCountryEnum["ST"] = "ST";
    ActivitiesListTicketCountryEnum["SV"] = "SV";
    ActivitiesListTicketCountryEnum["SX"] = "SX";
    ActivitiesListTicketCountryEnum["SY"] = "SY";
    ActivitiesListTicketCountryEnum["SZ"] = "SZ";
    ActivitiesListTicketCountryEnum["TC"] = "TC";
    ActivitiesListTicketCountryEnum["TD"] = "TD";
    ActivitiesListTicketCountryEnum["TF"] = "TF";
    ActivitiesListTicketCountryEnum["TG"] = "TG";
    ActivitiesListTicketCountryEnum["TH"] = "TH";
    ActivitiesListTicketCountryEnum["TJ"] = "TJ";
    ActivitiesListTicketCountryEnum["TK"] = "TK";
    ActivitiesListTicketCountryEnum["TL"] = "TL";
    ActivitiesListTicketCountryEnum["TM"] = "TM";
    ActivitiesListTicketCountryEnum["TN"] = "TN";
    ActivitiesListTicketCountryEnum["TO"] = "TO";
    ActivitiesListTicketCountryEnum["TR"] = "TR";
    ActivitiesListTicketCountryEnum["TT"] = "TT";
    ActivitiesListTicketCountryEnum["TV"] = "TV";
    ActivitiesListTicketCountryEnum["TW"] = "TW";
    ActivitiesListTicketCountryEnum["TZ"] = "TZ";
    ActivitiesListTicketCountryEnum["UA"] = "UA";
    ActivitiesListTicketCountryEnum["UG"] = "UG";
    ActivitiesListTicketCountryEnum["UM"] = "UM";
    ActivitiesListTicketCountryEnum["US"] = "US";
    ActivitiesListTicketCountryEnum["UY"] = "UY";
    ActivitiesListTicketCountryEnum["UZ"] = "UZ";
    ActivitiesListTicketCountryEnum["VA"] = "VA";
    ActivitiesListTicketCountryEnum["VC"] = "VC";
    ActivitiesListTicketCountryEnum["VE"] = "VE";
    ActivitiesListTicketCountryEnum["VG"] = "VG";
    ActivitiesListTicketCountryEnum["VI"] = "VI";
    ActivitiesListTicketCountryEnum["VN"] = "VN";
    ActivitiesListTicketCountryEnum["VU"] = "VU";
    ActivitiesListTicketCountryEnum["WF"] = "WF";
    ActivitiesListTicketCountryEnum["WS"] = "WS";
    ActivitiesListTicketCountryEnum["YE"] = "YE";
    ActivitiesListTicketCountryEnum["YT"] = "YT";
    ActivitiesListTicketCountryEnum["ZA"] = "ZA";
    ActivitiesListTicketCountryEnum["ZM"] = "ZM";
    ActivitiesListTicketCountryEnum["ZW"] = "ZW";
    return ActivitiesListTicketCountryEnum;
  }({});
  _BackendEnums.ActivitiesListTicketCountryEnum = ActivitiesListTicketCountryEnum;
  let CommunicationListTicketCountryEnum = /*#__PURE__*/function (CommunicationListTicketCountryEnum) {
    CommunicationListTicketCountryEnum["AD"] = "AD";
    CommunicationListTicketCountryEnum["AE"] = "AE";
    CommunicationListTicketCountryEnum["AF"] = "AF";
    CommunicationListTicketCountryEnum["AG"] = "AG";
    CommunicationListTicketCountryEnum["AI"] = "AI";
    CommunicationListTicketCountryEnum["AL"] = "AL";
    CommunicationListTicketCountryEnum["AM"] = "AM";
    CommunicationListTicketCountryEnum["AO"] = "AO";
    CommunicationListTicketCountryEnum["AQ"] = "AQ";
    CommunicationListTicketCountryEnum["AR"] = "AR";
    CommunicationListTicketCountryEnum["AS"] = "AS";
    CommunicationListTicketCountryEnum["AT"] = "AT";
    CommunicationListTicketCountryEnum["AU"] = "AU";
    CommunicationListTicketCountryEnum["AW"] = "AW";
    CommunicationListTicketCountryEnum["AX"] = "AX";
    CommunicationListTicketCountryEnum["AZ"] = "AZ";
    CommunicationListTicketCountryEnum["BA"] = "BA";
    CommunicationListTicketCountryEnum["BB"] = "BB";
    CommunicationListTicketCountryEnum["BD"] = "BD";
    CommunicationListTicketCountryEnum["BE"] = "BE";
    CommunicationListTicketCountryEnum["BF"] = "BF";
    CommunicationListTicketCountryEnum["BG"] = "BG";
    CommunicationListTicketCountryEnum["BH"] = "BH";
    CommunicationListTicketCountryEnum["BI"] = "BI";
    CommunicationListTicketCountryEnum["BJ"] = "BJ";
    CommunicationListTicketCountryEnum["BL"] = "BL";
    CommunicationListTicketCountryEnum["BM"] = "BM";
    CommunicationListTicketCountryEnum["BN"] = "BN";
    CommunicationListTicketCountryEnum["BO"] = "BO";
    CommunicationListTicketCountryEnum["BQ"] = "BQ";
    CommunicationListTicketCountryEnum["BR"] = "BR";
    CommunicationListTicketCountryEnum["BS"] = "BS";
    CommunicationListTicketCountryEnum["BT"] = "BT";
    CommunicationListTicketCountryEnum["BV"] = "BV";
    CommunicationListTicketCountryEnum["BW"] = "BW";
    CommunicationListTicketCountryEnum["BY"] = "BY";
    CommunicationListTicketCountryEnum["BZ"] = "BZ";
    CommunicationListTicketCountryEnum["CA"] = "CA";
    CommunicationListTicketCountryEnum["CC"] = "CC";
    CommunicationListTicketCountryEnum["CD"] = "CD";
    CommunicationListTicketCountryEnum["CF"] = "CF";
    CommunicationListTicketCountryEnum["CG"] = "CG";
    CommunicationListTicketCountryEnum["CH"] = "CH";
    CommunicationListTicketCountryEnum["CI"] = "CI";
    CommunicationListTicketCountryEnum["CK"] = "CK";
    CommunicationListTicketCountryEnum["CL"] = "CL";
    CommunicationListTicketCountryEnum["CM"] = "CM";
    CommunicationListTicketCountryEnum["CN"] = "CN";
    CommunicationListTicketCountryEnum["CO"] = "CO";
    CommunicationListTicketCountryEnum["CR"] = "CR";
    CommunicationListTicketCountryEnum["CU"] = "CU";
    CommunicationListTicketCountryEnum["CV"] = "CV";
    CommunicationListTicketCountryEnum["CW"] = "CW";
    CommunicationListTicketCountryEnum["CX"] = "CX";
    CommunicationListTicketCountryEnum["CY"] = "CY";
    CommunicationListTicketCountryEnum["CZ"] = "CZ";
    CommunicationListTicketCountryEnum["DE"] = "DE";
    CommunicationListTicketCountryEnum["DJ"] = "DJ";
    CommunicationListTicketCountryEnum["DK"] = "DK";
    CommunicationListTicketCountryEnum["DM"] = "DM";
    CommunicationListTicketCountryEnum["DO"] = "DO";
    CommunicationListTicketCountryEnum["DZ"] = "DZ";
    CommunicationListTicketCountryEnum["EC"] = "EC";
    CommunicationListTicketCountryEnum["EE"] = "EE";
    CommunicationListTicketCountryEnum["EG"] = "EG";
    CommunicationListTicketCountryEnum["EH"] = "EH";
    CommunicationListTicketCountryEnum["ER"] = "ER";
    CommunicationListTicketCountryEnum["ES"] = "ES";
    CommunicationListTicketCountryEnum["ET"] = "ET";
    CommunicationListTicketCountryEnum["FI"] = "FI";
    CommunicationListTicketCountryEnum["FJ"] = "FJ";
    CommunicationListTicketCountryEnum["FK"] = "FK";
    CommunicationListTicketCountryEnum["FM"] = "FM";
    CommunicationListTicketCountryEnum["FO"] = "FO";
    CommunicationListTicketCountryEnum["FR"] = "FR";
    CommunicationListTicketCountryEnum["GA"] = "GA";
    CommunicationListTicketCountryEnum["GB"] = "GB";
    CommunicationListTicketCountryEnum["GD"] = "GD";
    CommunicationListTicketCountryEnum["GE"] = "GE";
    CommunicationListTicketCountryEnum["GF"] = "GF";
    CommunicationListTicketCountryEnum["GG"] = "GG";
    CommunicationListTicketCountryEnum["GH"] = "GH";
    CommunicationListTicketCountryEnum["GI"] = "GI";
    CommunicationListTicketCountryEnum["GL"] = "GL";
    CommunicationListTicketCountryEnum["GM"] = "GM";
    CommunicationListTicketCountryEnum["GN"] = "GN";
    CommunicationListTicketCountryEnum["GP"] = "GP";
    CommunicationListTicketCountryEnum["GQ"] = "GQ";
    CommunicationListTicketCountryEnum["GR"] = "GR";
    CommunicationListTicketCountryEnum["GS"] = "GS";
    CommunicationListTicketCountryEnum["GT"] = "GT";
    CommunicationListTicketCountryEnum["GU"] = "GU";
    CommunicationListTicketCountryEnum["GW"] = "GW";
    CommunicationListTicketCountryEnum["GY"] = "GY";
    CommunicationListTicketCountryEnum["HK"] = "HK";
    CommunicationListTicketCountryEnum["HM"] = "HM";
    CommunicationListTicketCountryEnum["HN"] = "HN";
    CommunicationListTicketCountryEnum["HR"] = "HR";
    CommunicationListTicketCountryEnum["HT"] = "HT";
    CommunicationListTicketCountryEnum["HU"] = "HU";
    CommunicationListTicketCountryEnum["ID"] = "ID";
    CommunicationListTicketCountryEnum["IE"] = "IE";
    CommunicationListTicketCountryEnum["IL"] = "IL";
    CommunicationListTicketCountryEnum["IM"] = "IM";
    CommunicationListTicketCountryEnum["IN"] = "IN";
    CommunicationListTicketCountryEnum["IO"] = "IO";
    CommunicationListTicketCountryEnum["IQ"] = "IQ";
    CommunicationListTicketCountryEnum["IR"] = "IR";
    CommunicationListTicketCountryEnum["IS"] = "IS";
    CommunicationListTicketCountryEnum["IT"] = "IT";
    CommunicationListTicketCountryEnum["JE"] = "JE";
    CommunicationListTicketCountryEnum["JM"] = "JM";
    CommunicationListTicketCountryEnum["JO"] = "JO";
    CommunicationListTicketCountryEnum["JP"] = "JP";
    CommunicationListTicketCountryEnum["KE"] = "KE";
    CommunicationListTicketCountryEnum["KG"] = "KG";
    CommunicationListTicketCountryEnum["KH"] = "KH";
    CommunicationListTicketCountryEnum["KI"] = "KI";
    CommunicationListTicketCountryEnum["KM"] = "KM";
    CommunicationListTicketCountryEnum["KN"] = "KN";
    CommunicationListTicketCountryEnum["KP"] = "KP";
    CommunicationListTicketCountryEnum["KR"] = "KR";
    CommunicationListTicketCountryEnum["KW"] = "KW";
    CommunicationListTicketCountryEnum["KY"] = "KY";
    CommunicationListTicketCountryEnum["KZ"] = "KZ";
    CommunicationListTicketCountryEnum["LA"] = "LA";
    CommunicationListTicketCountryEnum["LB"] = "LB";
    CommunicationListTicketCountryEnum["LC"] = "LC";
    CommunicationListTicketCountryEnum["LI"] = "LI";
    CommunicationListTicketCountryEnum["LK"] = "LK";
    CommunicationListTicketCountryEnum["LR"] = "LR";
    CommunicationListTicketCountryEnum["LS"] = "LS";
    CommunicationListTicketCountryEnum["LT"] = "LT";
    CommunicationListTicketCountryEnum["LU"] = "LU";
    CommunicationListTicketCountryEnum["LV"] = "LV";
    CommunicationListTicketCountryEnum["LY"] = "LY";
    CommunicationListTicketCountryEnum["MA"] = "MA";
    CommunicationListTicketCountryEnum["MC"] = "MC";
    CommunicationListTicketCountryEnum["MD"] = "MD";
    CommunicationListTicketCountryEnum["ME"] = "ME";
    CommunicationListTicketCountryEnum["MF"] = "MF";
    CommunicationListTicketCountryEnum["MG"] = "MG";
    CommunicationListTicketCountryEnum["MH"] = "MH";
    CommunicationListTicketCountryEnum["MK"] = "MK";
    CommunicationListTicketCountryEnum["ML"] = "ML";
    CommunicationListTicketCountryEnum["MM"] = "MM";
    CommunicationListTicketCountryEnum["MN"] = "MN";
    CommunicationListTicketCountryEnum["MO"] = "MO";
    CommunicationListTicketCountryEnum["MP"] = "MP";
    CommunicationListTicketCountryEnum["MQ"] = "MQ";
    CommunicationListTicketCountryEnum["MR"] = "MR";
    CommunicationListTicketCountryEnum["MS"] = "MS";
    CommunicationListTicketCountryEnum["MT"] = "MT";
    CommunicationListTicketCountryEnum["MU"] = "MU";
    CommunicationListTicketCountryEnum["MV"] = "MV";
    CommunicationListTicketCountryEnum["MW"] = "MW";
    CommunicationListTicketCountryEnum["MX"] = "MX";
    CommunicationListTicketCountryEnum["MY"] = "MY";
    CommunicationListTicketCountryEnum["MZ"] = "MZ";
    CommunicationListTicketCountryEnum["NA"] = "NA";
    CommunicationListTicketCountryEnum["NC"] = "NC";
    CommunicationListTicketCountryEnum["NE"] = "NE";
    CommunicationListTicketCountryEnum["NF"] = "NF";
    CommunicationListTicketCountryEnum["NG"] = "NG";
    CommunicationListTicketCountryEnum["NI"] = "NI";
    CommunicationListTicketCountryEnum["NL"] = "NL";
    CommunicationListTicketCountryEnum["NO"] = "NO";
    CommunicationListTicketCountryEnum["NP"] = "NP";
    CommunicationListTicketCountryEnum["NR"] = "NR";
    CommunicationListTicketCountryEnum["NU"] = "NU";
    CommunicationListTicketCountryEnum["NZ"] = "NZ";
    CommunicationListTicketCountryEnum["OM"] = "OM";
    CommunicationListTicketCountryEnum["PA"] = "PA";
    CommunicationListTicketCountryEnum["PE"] = "PE";
    CommunicationListTicketCountryEnum["PF"] = "PF";
    CommunicationListTicketCountryEnum["PG"] = "PG";
    CommunicationListTicketCountryEnum["PH"] = "PH";
    CommunicationListTicketCountryEnum["PK"] = "PK";
    CommunicationListTicketCountryEnum["PL"] = "PL";
    CommunicationListTicketCountryEnum["PM"] = "PM";
    CommunicationListTicketCountryEnum["PN"] = "PN";
    CommunicationListTicketCountryEnum["PR"] = "PR";
    CommunicationListTicketCountryEnum["PS"] = "PS";
    CommunicationListTicketCountryEnum["PT"] = "PT";
    CommunicationListTicketCountryEnum["PW"] = "PW";
    CommunicationListTicketCountryEnum["PY"] = "PY";
    CommunicationListTicketCountryEnum["QA"] = "QA";
    CommunicationListTicketCountryEnum["RE"] = "RE";
    CommunicationListTicketCountryEnum["RO"] = "RO";
    CommunicationListTicketCountryEnum["RS"] = "RS";
    CommunicationListTicketCountryEnum["RU"] = "RU";
    CommunicationListTicketCountryEnum["RW"] = "RW";
    CommunicationListTicketCountryEnum["SA"] = "SA";
    CommunicationListTicketCountryEnum["SB"] = "SB";
    CommunicationListTicketCountryEnum["SC"] = "SC";
    CommunicationListTicketCountryEnum["SD"] = "SD";
    CommunicationListTicketCountryEnum["SE"] = "SE";
    CommunicationListTicketCountryEnum["SG"] = "SG";
    CommunicationListTicketCountryEnum["SH"] = "SH";
    CommunicationListTicketCountryEnum["SI"] = "SI";
    CommunicationListTicketCountryEnum["SJ"] = "SJ";
    CommunicationListTicketCountryEnum["SK"] = "SK";
    CommunicationListTicketCountryEnum["SL"] = "SL";
    CommunicationListTicketCountryEnum["SM"] = "SM";
    CommunicationListTicketCountryEnum["SN"] = "SN";
    CommunicationListTicketCountryEnum["SO"] = "SO";
    CommunicationListTicketCountryEnum["SR"] = "SR";
    CommunicationListTicketCountryEnum["SS"] = "SS";
    CommunicationListTicketCountryEnum["ST"] = "ST";
    CommunicationListTicketCountryEnum["SV"] = "SV";
    CommunicationListTicketCountryEnum["SX"] = "SX";
    CommunicationListTicketCountryEnum["SY"] = "SY";
    CommunicationListTicketCountryEnum["SZ"] = "SZ";
    CommunicationListTicketCountryEnum["TC"] = "TC";
    CommunicationListTicketCountryEnum["TD"] = "TD";
    CommunicationListTicketCountryEnum["TF"] = "TF";
    CommunicationListTicketCountryEnum["TG"] = "TG";
    CommunicationListTicketCountryEnum["TH"] = "TH";
    CommunicationListTicketCountryEnum["TJ"] = "TJ";
    CommunicationListTicketCountryEnum["TK"] = "TK";
    CommunicationListTicketCountryEnum["TL"] = "TL";
    CommunicationListTicketCountryEnum["TM"] = "TM";
    CommunicationListTicketCountryEnum["TN"] = "TN";
    CommunicationListTicketCountryEnum["TO"] = "TO";
    CommunicationListTicketCountryEnum["TR"] = "TR";
    CommunicationListTicketCountryEnum["TT"] = "TT";
    CommunicationListTicketCountryEnum["TV"] = "TV";
    CommunicationListTicketCountryEnum["TW"] = "TW";
    CommunicationListTicketCountryEnum["TZ"] = "TZ";
    CommunicationListTicketCountryEnum["UA"] = "UA";
    CommunicationListTicketCountryEnum["UG"] = "UG";
    CommunicationListTicketCountryEnum["UM"] = "UM";
    CommunicationListTicketCountryEnum["US"] = "US";
    CommunicationListTicketCountryEnum["UY"] = "UY";
    CommunicationListTicketCountryEnum["UZ"] = "UZ";
    CommunicationListTicketCountryEnum["VA"] = "VA";
    CommunicationListTicketCountryEnum["VC"] = "VC";
    CommunicationListTicketCountryEnum["VE"] = "VE";
    CommunicationListTicketCountryEnum["VG"] = "VG";
    CommunicationListTicketCountryEnum["VI"] = "VI";
    CommunicationListTicketCountryEnum["VN"] = "VN";
    CommunicationListTicketCountryEnum["VU"] = "VU";
    CommunicationListTicketCountryEnum["WF"] = "WF";
    CommunicationListTicketCountryEnum["WS"] = "WS";
    CommunicationListTicketCountryEnum["YE"] = "YE";
    CommunicationListTicketCountryEnum["YT"] = "YT";
    CommunicationListTicketCountryEnum["ZA"] = "ZA";
    CommunicationListTicketCountryEnum["ZM"] = "ZM";
    CommunicationListTicketCountryEnum["ZW"] = "ZW";
    return CommunicationListTicketCountryEnum;
  }({});
  _BackendEnums.CommunicationListTicketCountryEnum = CommunicationListTicketCountryEnum;
  let CommunicationListTicketLanguageEnum = /*#__PURE__*/function (CommunicationListTicketLanguageEnum) {
    CommunicationListTicketLanguageEnum["BG"] = "bg";
    CommunicationListTicketLanguageEnum["CS"] = "cs";
    CommunicationListTicketLanguageEnum["DA"] = "da";
    CommunicationListTicketLanguageEnum["DE"] = "de";
    CommunicationListTicketLanguageEnum["DE-AT"] = "de-at";
    CommunicationListTicketLanguageEnum["DE-CH"] = "de-ch";
    CommunicationListTicketLanguageEnum["EL"] = "el";
    CommunicationListTicketLanguageEnum["EN"] = "en";
    CommunicationListTicketLanguageEnum["ES"] = "es";
    CommunicationListTicketLanguageEnum["ET"] = "et";
    CommunicationListTicketLanguageEnum["FI"] = "fi";
    CommunicationListTicketLanguageEnum["FR"] = "fr";
    CommunicationListTicketLanguageEnum["FR-BE"] = "fr-be";
    CommunicationListTicketLanguageEnum["FR-CH"] = "fr-ch";
    CommunicationListTicketLanguageEnum["HR"] = "hr";
    CommunicationListTicketLanguageEnum["HU"] = "hu";
    CommunicationListTicketLanguageEnum["IT"] = "it";
    CommunicationListTicketLanguageEnum["IT-CH"] = "it-ch";
    CommunicationListTicketLanguageEnum["LT"] = "lt";
    CommunicationListTicketLanguageEnum["LV"] = "lv";
    CommunicationListTicketLanguageEnum["NB"] = "nb";
    CommunicationListTicketLanguageEnum["NL"] = "nl";
    CommunicationListTicketLanguageEnum["NL-BE"] = "nl-be";
    CommunicationListTicketLanguageEnum["PL"] = "pl";
    CommunicationListTicketLanguageEnum["PT"] = "pt";
    CommunicationListTicketLanguageEnum["RO"] = "ro";
    CommunicationListTicketLanguageEnum["SK"] = "sk";
    CommunicationListTicketLanguageEnum["SL"] = "sl";
    CommunicationListTicketLanguageEnum["SR"] = "sr";
    CommunicationListTicketLanguageEnum["SV"] = "sv";
    CommunicationListTicketLanguageEnum["UK"] = "uk";
    return CommunicationListTicketLanguageEnum;
  }({});
  _BackendEnums.CommunicationListTicketLanguageEnum = CommunicationListTicketLanguageEnum;
  let CustomFieldsListTypeEnum = /*#__PURE__*/function (CustomFieldsListTypeEnum) {
    CustomFieldsListTypeEnum["BANK_ACCOUNT"] = "BANK_ACCOUNT";
    CustomFieldsListTypeEnum["BOOL"] = "BOOL";
    CustomFieldsListTypeEnum["CHAR"] = "CHAR";
    CustomFieldsListTypeEnum["CZECH_BANK_ACCOUNT"] = "CZECH_BANK_ACCOUNT";
    CustomFieldsListTypeEnum["DATE"] = "DATE";
    CustomFieldsListTypeEnum["FILE"] = "FILE";
    CustomFieldsListTypeEnum["IBAN"] = "IBAN";
    CustomFieldsListTypeEnum["MULTILINE"] = "MULTILINE";
    CustomFieldsListTypeEnum["NUMERIC"] = "NUMERIC";
    CustomFieldsListTypeEnum["SELECT"] = "SELECT";
    CustomFieldsListTypeEnum["SELECTMULTI"] = "SELECTMULTI";
    CustomFieldsListTypeEnum["URL"] = "URL";
    return CustomFieldsListTypeEnum;
  }({});
  _BackendEnums.CustomFieldsListTypeEnum = CustomFieldsListTypeEnum;
  let CustomersListExcludeSegmentEnum = /*#__PURE__*/function (CustomersListExcludeSegmentEnum) {
    CustomersListExcludeSegmentEnum["CLAIM_FREQUENT"] = "claim_frequent";
    CustomersListExcludeSegmentEnum["DORMANT"] = "dormant";
    CustomersListExcludeSegmentEnum["FADING_REGULAR"] = "fading_regular";
    CustomersListExcludeSegmentEnum["FRAGILE_FIRST"] = "fragile_first";
    CustomersListExcludeSegmentEnum["LOYAL_AMBASSADOR"] = "loyal_ambassador";
    CustomersListExcludeSegmentEnum["NEW_RISING"] = "new_rising";
    CustomersListExcludeSegmentEnum["ONE_TIME_BUYER"] = "one_time_buyer";
    CustomersListExcludeSegmentEnum["SERIAL_RETURNER"] = "serial_returner";
    CustomersListExcludeSegmentEnum["STANDARD"] = "standard";
    CustomersListExcludeSegmentEnum["VIP"] = "vip";
    return CustomersListExcludeSegmentEnum;
  }({});
  _BackendEnums.CustomersListExcludeSegmentEnum = CustomersListExcludeSegmentEnum;
  let CustomersListSegmentEnum = /*#__PURE__*/function (CustomersListSegmentEnum) {
    CustomersListSegmentEnum["CLAIM_FREQUENT"] = "claim_frequent";
    CustomersListSegmentEnum["DORMANT"] = "dormant";
    CustomersListSegmentEnum["FADING_REGULAR"] = "fading_regular";
    CustomersListSegmentEnum["FRAGILE_FIRST"] = "fragile_first";
    CustomersListSegmentEnum["LOYAL_AMBASSADOR"] = "loyal_ambassador";
    CustomersListSegmentEnum["NEW_RISING"] = "new_rising";
    CustomersListSegmentEnum["ONE_TIME_BUYER"] = "one_time_buyer";
    CustomersListSegmentEnum["SERIAL_RETURNER"] = "serial_returner";
    CustomersListSegmentEnum["STANDARD"] = "standard";
    CustomersListSegmentEnum["VIP"] = "vip";
    return CustomersListSegmentEnum;
  }({});
  _BackendEnums.CustomersListSegmentEnum = CustomersListSegmentEnum;
  let CustomersTimelineRetrieveTypeEnum = /*#__PURE__*/function (CustomersTimelineRetrieveTypeEnum) {
    CustomersTimelineRetrieveTypeEnum["ALL"] = "all";
    CustomersTimelineRetrieveTypeEnum["ORDER"] = "order";
    CustomersTimelineRetrieveTypeEnum["TICKET"] = "ticket";
    CustomersTimelineRetrieveTypeEnum["MESSAGE"] = "message";
    CustomersTimelineRetrieveTypeEnum["NOTE"] = "note";
    return CustomersTimelineRetrieveTypeEnum;
  }({});
  _BackendEnums.CustomersTimelineRetrieveTypeEnum = CustomersTimelineRetrieveTypeEnum;
  let FlowAgentInputListOrderingEnum = /*#__PURE__*/function (FlowAgentInputListOrderingEnum) {
    FlowAgentInputListOrderingEnum["-CREATED_AT"] = "-created_at";
    FlowAgentInputListOrderingEnum["-EXPIRES_AT"] = "-expires_at";
    FlowAgentInputListOrderingEnum["CREATED_AT"] = "created_at";
    FlowAgentInputListOrderingEnum["EXPIRES_AT"] = "expires_at";
    return FlowAgentInputListOrderingEnum;
  }({});
  _BackendEnums.FlowAgentInputListOrderingEnum = FlowAgentInputListOrderingEnum;
  let FlowAgentInputListStatusEnum = /*#__PURE__*/function (FlowAgentInputListStatusEnum) {
    FlowAgentInputListStatusEnum["CANCELLED"] = "cancelled";
    FlowAgentInputListStatusEnum["COMPLETED"] = "completed";
    FlowAgentInputListStatusEnum["EXPIRED"] = "expired";
    FlowAgentInputListStatusEnum["PENDING"] = "pending";
    return FlowAgentInputListStatusEnum;
  }({});
  _BackendEnums.FlowAgentInputListStatusEnum = FlowAgentInputListStatusEnum;
  let RefundAccountsListCurrencyEnum = /*#__PURE__*/function (RefundAccountsListCurrencyEnum) {
    RefundAccountsListCurrencyEnum["AUD"] = "AUD";
    RefundAccountsListCurrencyEnum["CAD"] = "CAD";
    RefundAccountsListCurrencyEnum["CHF"] = "CHF";
    RefundAccountsListCurrencyEnum["CZK"] = "CZK";
    RefundAccountsListCurrencyEnum["EUR"] = "EUR";
    RefundAccountsListCurrencyEnum["GBP"] = "GBP";
    RefundAccountsListCurrencyEnum["HUF"] = "HUF";
    RefundAccountsListCurrencyEnum["JPY"] = "JPY";
    RefundAccountsListCurrencyEnum["NOK"] = "NOK";
    RefundAccountsListCurrencyEnum["PLN"] = "PLN";
    RefundAccountsListCurrencyEnum["SEK"] = "SEK";
    RefundAccountsListCurrencyEnum["USD"] = "USD";
    return RefundAccountsListCurrencyEnum;
  }({});
  _BackendEnums.RefundAccountsListCurrencyEnum = RefundAccountsListCurrencyEnum;
  let RetinoShippingShippingListListShippingProviderEnum = /*#__PURE__*/function (RetinoShippingShippingListListShippingProviderEnum) {
    RetinoShippingShippingListListShippingProviderEnum["CUSTOM"] = "CUSTOM";
    RetinoShippingShippingListListShippingProviderEnum["DHL24_DROP_OFF"] = "DHL24_DROP_OFF";
    RetinoShippingShippingListListShippingProviderEnum["DHL24_PICKUP"] = "DHL24_PICKUP";
    RetinoShippingShippingListListShippingProviderEnum["DHL_FREIGHT_PICKUP"] = "DHL_FREIGHT_PICKUP";
    RetinoShippingShippingListListShippingProviderEnum["DHL_INTERNATIONAL_DROPOFF"] = "DHL_INTERNATIONAL_DROPOFF";
    RetinoShippingShippingListListShippingProviderEnum["DPD_BELGIUM_DROPOFF"] = "DPD_BELGIUM_DROPOFF";
    RetinoShippingShippingListListShippingProviderEnum["DPD_GEO_API_DROPOFF"] = "DPD_GEO_API_DROPOFF";
    RetinoShippingShippingListListShippingProviderEnum["DPD_GEO_API_PICKUP"] = "DPD_GEO_API_PICKUP";
    RetinoShippingShippingListListShippingProviderEnum["DPD_HU_DROPOFF"] = "DPD_HU_DROPOFF";
    RetinoShippingShippingListListShippingProviderEnum["DPD_HU_PICKUP"] = "DPD_HU_PICKUP";
    RetinoShippingShippingListListShippingProviderEnum["DPD_REG_PRIJEMCE_DROPOFF"] = "DPD_REG_PRIJEMCE_DROPOFF";
    RetinoShippingShippingListListShippingProviderEnum["DPD_REG_PRIJEMCE_PICKUP"] = "DPD_REG_PRIJEMCE_PICKUP";
    RetinoShippingShippingListListShippingProviderEnum["DPD_SK_DROPOFF"] = "DPD_SK_DROPOFF";
    RetinoShippingShippingListListShippingProviderEnum["DPD_SK_PICKUP"] = "DPD_SK_PICKUP";
    RetinoShippingShippingListListShippingProviderEnum["FOXPOST_RETURNS"] = "FOXPOST_RETURNS";
    RetinoShippingShippingListListShippingProviderEnum["GEIS_PICKUP"] = "GEIS_PICKUP";
    RetinoShippingShippingListListShippingProviderEnum["GLS_ISRS"] = "GLS_ISRS";
    RetinoShippingShippingListListShippingProviderEnum["GLS_PICKUP"] = "GLS_PICKUP";
    RetinoShippingShippingListListShippingProviderEnum["GLS_POLAND_API_DROPOFF"] = "GLS_POLAND_API_DROPOFF";
    RetinoShippingShippingListListShippingProviderEnum["INPOST_DROP_OFF"] = "INPOST_DROP_OFF";
    RetinoShippingShippingListListShippingProviderEnum["INPOST_PICKUP"] = "INPOST_PICKUP";
    RetinoShippingShippingListListShippingProviderEnum["IN_PERSON"] = "IN_PERSON";
    RetinoShippingShippingListListShippingProviderEnum["LIFTAGO"] = "LIFTAGO";
    RetinoShippingShippingListListShippingProviderEnum["MY_GLS_BOX_CZ"] = "MY_GLS_BOX_CZ";
    RetinoShippingShippingListListShippingProviderEnum["MY_GLS_DROP_OFF_CZ"] = "MY_GLS_DROP_OFF_CZ";
    RetinoShippingShippingListListShippingProviderEnum["MY_GLS_DROP_OFF_HU"] = "MY_GLS_DROP_OFF_HU";
    RetinoShippingShippingListListShippingProviderEnum["MY_GLS_DROP_OFF_SK"] = "MY_GLS_DROP_OFF_SK";
    RetinoShippingShippingListListShippingProviderEnum["MY_GLS_PICKUP_CZ"] = "MY_GLS_PICKUP_CZ";
    RetinoShippingShippingListListShippingProviderEnum["MY_GLS_PICKUP_HR"] = "MY_GLS_PICKUP_HR";
    RetinoShippingShippingListListShippingProviderEnum["MY_GLS_PICKUP_HU"] = "MY_GLS_PICKUP_HU";
    RetinoShippingShippingListListShippingProviderEnum["MY_GLS_PICKUP_SI"] = "MY_GLS_PICKUP_SI";
    RetinoShippingShippingListListShippingProviderEnum["MY_GLS_PICKUP_SK"] = "MY_GLS_PICKUP_SK";
    RetinoShippingShippingListListShippingProviderEnum["MY_PPL_CPL_DROPOFF"] = "MY_PPL_CPL_DROPOFF";
    RetinoShippingShippingListListShippingProviderEnum["MY_PPL_CPL_PICKUP"] = "MY_PPL_CPL_PICKUP";
    RetinoShippingShippingListListShippingProviderEnum["MY_PPL_PICKUP"] = "MY_PPL_PICKUP";
    RetinoShippingShippingListListShippingProviderEnum["PACKETA_CLAIM_ASSISTANT"] = "PACKETA_CLAIM_ASSISTANT";
    RetinoShippingShippingListListShippingProviderEnum["PPL_RETURN_CONNECT_DROPOFF"] = "PPL_RETURN_CONNECT_DROPOFF";
    RetinoShippingShippingListListShippingProviderEnum["PPL_RETURN_CONNECT_PICKUP"] = "PPL_RETURN_CONNECT_PICKUP";
    RetinoShippingShippingListListShippingProviderEnum["RABEN_FREIGHT"] = "RABEN_FREIGHT";
    RetinoShippingShippingListListShippingProviderEnum["SPS_DROPOFF"] = "SPS_DROPOFF";
    RetinoShippingShippingListListShippingProviderEnum["UPS_PICKUP"] = "UPS_PICKUP";
    return RetinoShippingShippingListListShippingProviderEnum;
  }({});
  _BackendEnums.RetinoShippingShippingListListShippingProviderEnum = RetinoShippingShippingListListShippingProviderEnum;
  let RetinoShippingShippingListListTicketCountryEnum = /*#__PURE__*/function (RetinoShippingShippingListListTicketCountryEnum) {
    RetinoShippingShippingListListTicketCountryEnum["AD"] = "AD";
    RetinoShippingShippingListListTicketCountryEnum["AE"] = "AE";
    RetinoShippingShippingListListTicketCountryEnum["AF"] = "AF";
    RetinoShippingShippingListListTicketCountryEnum["AG"] = "AG";
    RetinoShippingShippingListListTicketCountryEnum["AI"] = "AI";
    RetinoShippingShippingListListTicketCountryEnum["AL"] = "AL";
    RetinoShippingShippingListListTicketCountryEnum["AM"] = "AM";
    RetinoShippingShippingListListTicketCountryEnum["AO"] = "AO";
    RetinoShippingShippingListListTicketCountryEnum["AQ"] = "AQ";
    RetinoShippingShippingListListTicketCountryEnum["AR"] = "AR";
    RetinoShippingShippingListListTicketCountryEnum["AS"] = "AS";
    RetinoShippingShippingListListTicketCountryEnum["AT"] = "AT";
    RetinoShippingShippingListListTicketCountryEnum["AU"] = "AU";
    RetinoShippingShippingListListTicketCountryEnum["AW"] = "AW";
    RetinoShippingShippingListListTicketCountryEnum["AX"] = "AX";
    RetinoShippingShippingListListTicketCountryEnum["AZ"] = "AZ";
    RetinoShippingShippingListListTicketCountryEnum["BA"] = "BA";
    RetinoShippingShippingListListTicketCountryEnum["BB"] = "BB";
    RetinoShippingShippingListListTicketCountryEnum["BD"] = "BD";
    RetinoShippingShippingListListTicketCountryEnum["BE"] = "BE";
    RetinoShippingShippingListListTicketCountryEnum["BF"] = "BF";
    RetinoShippingShippingListListTicketCountryEnum["BG"] = "BG";
    RetinoShippingShippingListListTicketCountryEnum["BH"] = "BH";
    RetinoShippingShippingListListTicketCountryEnum["BI"] = "BI";
    RetinoShippingShippingListListTicketCountryEnum["BJ"] = "BJ";
    RetinoShippingShippingListListTicketCountryEnum["BL"] = "BL";
    RetinoShippingShippingListListTicketCountryEnum["BM"] = "BM";
    RetinoShippingShippingListListTicketCountryEnum["BN"] = "BN";
    RetinoShippingShippingListListTicketCountryEnum["BO"] = "BO";
    RetinoShippingShippingListListTicketCountryEnum["BQ"] = "BQ";
    RetinoShippingShippingListListTicketCountryEnum["BR"] = "BR";
    RetinoShippingShippingListListTicketCountryEnum["BS"] = "BS";
    RetinoShippingShippingListListTicketCountryEnum["BT"] = "BT";
    RetinoShippingShippingListListTicketCountryEnum["BV"] = "BV";
    RetinoShippingShippingListListTicketCountryEnum["BW"] = "BW";
    RetinoShippingShippingListListTicketCountryEnum["BY"] = "BY";
    RetinoShippingShippingListListTicketCountryEnum["BZ"] = "BZ";
    RetinoShippingShippingListListTicketCountryEnum["CA"] = "CA";
    RetinoShippingShippingListListTicketCountryEnum["CC"] = "CC";
    RetinoShippingShippingListListTicketCountryEnum["CD"] = "CD";
    RetinoShippingShippingListListTicketCountryEnum["CF"] = "CF";
    RetinoShippingShippingListListTicketCountryEnum["CG"] = "CG";
    RetinoShippingShippingListListTicketCountryEnum["CH"] = "CH";
    RetinoShippingShippingListListTicketCountryEnum["CI"] = "CI";
    RetinoShippingShippingListListTicketCountryEnum["CK"] = "CK";
    RetinoShippingShippingListListTicketCountryEnum["CL"] = "CL";
    RetinoShippingShippingListListTicketCountryEnum["CM"] = "CM";
    RetinoShippingShippingListListTicketCountryEnum["CN"] = "CN";
    RetinoShippingShippingListListTicketCountryEnum["CO"] = "CO";
    RetinoShippingShippingListListTicketCountryEnum["CR"] = "CR";
    RetinoShippingShippingListListTicketCountryEnum["CU"] = "CU";
    RetinoShippingShippingListListTicketCountryEnum["CV"] = "CV";
    RetinoShippingShippingListListTicketCountryEnum["CW"] = "CW";
    RetinoShippingShippingListListTicketCountryEnum["CX"] = "CX";
    RetinoShippingShippingListListTicketCountryEnum["CY"] = "CY";
    RetinoShippingShippingListListTicketCountryEnum["CZ"] = "CZ";
    RetinoShippingShippingListListTicketCountryEnum["DE"] = "DE";
    RetinoShippingShippingListListTicketCountryEnum["DJ"] = "DJ";
    RetinoShippingShippingListListTicketCountryEnum["DK"] = "DK";
    RetinoShippingShippingListListTicketCountryEnum["DM"] = "DM";
    RetinoShippingShippingListListTicketCountryEnum["DO"] = "DO";
    RetinoShippingShippingListListTicketCountryEnum["DZ"] = "DZ";
    RetinoShippingShippingListListTicketCountryEnum["EC"] = "EC";
    RetinoShippingShippingListListTicketCountryEnum["EE"] = "EE";
    RetinoShippingShippingListListTicketCountryEnum["EG"] = "EG";
    RetinoShippingShippingListListTicketCountryEnum["EH"] = "EH";
    RetinoShippingShippingListListTicketCountryEnum["ER"] = "ER";
    RetinoShippingShippingListListTicketCountryEnum["ES"] = "ES";
    RetinoShippingShippingListListTicketCountryEnum["ET"] = "ET";
    RetinoShippingShippingListListTicketCountryEnum["FI"] = "FI";
    RetinoShippingShippingListListTicketCountryEnum["FJ"] = "FJ";
    RetinoShippingShippingListListTicketCountryEnum["FK"] = "FK";
    RetinoShippingShippingListListTicketCountryEnum["FM"] = "FM";
    RetinoShippingShippingListListTicketCountryEnum["FO"] = "FO";
    RetinoShippingShippingListListTicketCountryEnum["FR"] = "FR";
    RetinoShippingShippingListListTicketCountryEnum["GA"] = "GA";
    RetinoShippingShippingListListTicketCountryEnum["GB"] = "GB";
    RetinoShippingShippingListListTicketCountryEnum["GD"] = "GD";
    RetinoShippingShippingListListTicketCountryEnum["GE"] = "GE";
    RetinoShippingShippingListListTicketCountryEnum["GF"] = "GF";
    RetinoShippingShippingListListTicketCountryEnum["GG"] = "GG";
    RetinoShippingShippingListListTicketCountryEnum["GH"] = "GH";
    RetinoShippingShippingListListTicketCountryEnum["GI"] = "GI";
    RetinoShippingShippingListListTicketCountryEnum["GL"] = "GL";
    RetinoShippingShippingListListTicketCountryEnum["GM"] = "GM";
    RetinoShippingShippingListListTicketCountryEnum["GN"] = "GN";
    RetinoShippingShippingListListTicketCountryEnum["GP"] = "GP";
    RetinoShippingShippingListListTicketCountryEnum["GQ"] = "GQ";
    RetinoShippingShippingListListTicketCountryEnum["GR"] = "GR";
    RetinoShippingShippingListListTicketCountryEnum["GS"] = "GS";
    RetinoShippingShippingListListTicketCountryEnum["GT"] = "GT";
    RetinoShippingShippingListListTicketCountryEnum["GU"] = "GU";
    RetinoShippingShippingListListTicketCountryEnum["GW"] = "GW";
    RetinoShippingShippingListListTicketCountryEnum["GY"] = "GY";
    RetinoShippingShippingListListTicketCountryEnum["HK"] = "HK";
    RetinoShippingShippingListListTicketCountryEnum["HM"] = "HM";
    RetinoShippingShippingListListTicketCountryEnum["HN"] = "HN";
    RetinoShippingShippingListListTicketCountryEnum["HR"] = "HR";
    RetinoShippingShippingListListTicketCountryEnum["HT"] = "HT";
    RetinoShippingShippingListListTicketCountryEnum["HU"] = "HU";
    RetinoShippingShippingListListTicketCountryEnum["ID"] = "ID";
    RetinoShippingShippingListListTicketCountryEnum["IE"] = "IE";
    RetinoShippingShippingListListTicketCountryEnum["IL"] = "IL";
    RetinoShippingShippingListListTicketCountryEnum["IM"] = "IM";
    RetinoShippingShippingListListTicketCountryEnum["IN"] = "IN";
    RetinoShippingShippingListListTicketCountryEnum["IO"] = "IO";
    RetinoShippingShippingListListTicketCountryEnum["IQ"] = "IQ";
    RetinoShippingShippingListListTicketCountryEnum["IR"] = "IR";
    RetinoShippingShippingListListTicketCountryEnum["IS"] = "IS";
    RetinoShippingShippingListListTicketCountryEnum["IT"] = "IT";
    RetinoShippingShippingListListTicketCountryEnum["JE"] = "JE";
    RetinoShippingShippingListListTicketCountryEnum["JM"] = "JM";
    RetinoShippingShippingListListTicketCountryEnum["JO"] = "JO";
    RetinoShippingShippingListListTicketCountryEnum["JP"] = "JP";
    RetinoShippingShippingListListTicketCountryEnum["KE"] = "KE";
    RetinoShippingShippingListListTicketCountryEnum["KG"] = "KG";
    RetinoShippingShippingListListTicketCountryEnum["KH"] = "KH";
    RetinoShippingShippingListListTicketCountryEnum["KI"] = "KI";
    RetinoShippingShippingListListTicketCountryEnum["KM"] = "KM";
    RetinoShippingShippingListListTicketCountryEnum["KN"] = "KN";
    RetinoShippingShippingListListTicketCountryEnum["KP"] = "KP";
    RetinoShippingShippingListListTicketCountryEnum["KR"] = "KR";
    RetinoShippingShippingListListTicketCountryEnum["KW"] = "KW";
    RetinoShippingShippingListListTicketCountryEnum["KY"] = "KY";
    RetinoShippingShippingListListTicketCountryEnum["KZ"] = "KZ";
    RetinoShippingShippingListListTicketCountryEnum["LA"] = "LA";
    RetinoShippingShippingListListTicketCountryEnum["LB"] = "LB";
    RetinoShippingShippingListListTicketCountryEnum["LC"] = "LC";
    RetinoShippingShippingListListTicketCountryEnum["LI"] = "LI";
    RetinoShippingShippingListListTicketCountryEnum["LK"] = "LK";
    RetinoShippingShippingListListTicketCountryEnum["LR"] = "LR";
    RetinoShippingShippingListListTicketCountryEnum["LS"] = "LS";
    RetinoShippingShippingListListTicketCountryEnum["LT"] = "LT";
    RetinoShippingShippingListListTicketCountryEnum["LU"] = "LU";
    RetinoShippingShippingListListTicketCountryEnum["LV"] = "LV";
    RetinoShippingShippingListListTicketCountryEnum["LY"] = "LY";
    RetinoShippingShippingListListTicketCountryEnum["MA"] = "MA";
    RetinoShippingShippingListListTicketCountryEnum["MC"] = "MC";
    RetinoShippingShippingListListTicketCountryEnum["MD"] = "MD";
    RetinoShippingShippingListListTicketCountryEnum["ME"] = "ME";
    RetinoShippingShippingListListTicketCountryEnum["MF"] = "MF";
    RetinoShippingShippingListListTicketCountryEnum["MG"] = "MG";
    RetinoShippingShippingListListTicketCountryEnum["MH"] = "MH";
    RetinoShippingShippingListListTicketCountryEnum["MK"] = "MK";
    RetinoShippingShippingListListTicketCountryEnum["ML"] = "ML";
    RetinoShippingShippingListListTicketCountryEnum["MM"] = "MM";
    RetinoShippingShippingListListTicketCountryEnum["MN"] = "MN";
    RetinoShippingShippingListListTicketCountryEnum["MO"] = "MO";
    RetinoShippingShippingListListTicketCountryEnum["MP"] = "MP";
    RetinoShippingShippingListListTicketCountryEnum["MQ"] = "MQ";
    RetinoShippingShippingListListTicketCountryEnum["MR"] = "MR";
    RetinoShippingShippingListListTicketCountryEnum["MS"] = "MS";
    RetinoShippingShippingListListTicketCountryEnum["MT"] = "MT";
    RetinoShippingShippingListListTicketCountryEnum["MU"] = "MU";
    RetinoShippingShippingListListTicketCountryEnum["MV"] = "MV";
    RetinoShippingShippingListListTicketCountryEnum["MW"] = "MW";
    RetinoShippingShippingListListTicketCountryEnum["MX"] = "MX";
    RetinoShippingShippingListListTicketCountryEnum["MY"] = "MY";
    RetinoShippingShippingListListTicketCountryEnum["MZ"] = "MZ";
    RetinoShippingShippingListListTicketCountryEnum["NA"] = "NA";
    RetinoShippingShippingListListTicketCountryEnum["NC"] = "NC";
    RetinoShippingShippingListListTicketCountryEnum["NE"] = "NE";
    RetinoShippingShippingListListTicketCountryEnum["NF"] = "NF";
    RetinoShippingShippingListListTicketCountryEnum["NG"] = "NG";
    RetinoShippingShippingListListTicketCountryEnum["NI"] = "NI";
    RetinoShippingShippingListListTicketCountryEnum["NL"] = "NL";
    RetinoShippingShippingListListTicketCountryEnum["NO"] = "NO";
    RetinoShippingShippingListListTicketCountryEnum["NP"] = "NP";
    RetinoShippingShippingListListTicketCountryEnum["NR"] = "NR";
    RetinoShippingShippingListListTicketCountryEnum["NU"] = "NU";
    RetinoShippingShippingListListTicketCountryEnum["NZ"] = "NZ";
    RetinoShippingShippingListListTicketCountryEnum["OM"] = "OM";
    RetinoShippingShippingListListTicketCountryEnum["PA"] = "PA";
    RetinoShippingShippingListListTicketCountryEnum["PE"] = "PE";
    RetinoShippingShippingListListTicketCountryEnum["PF"] = "PF";
    RetinoShippingShippingListListTicketCountryEnum["PG"] = "PG";
    RetinoShippingShippingListListTicketCountryEnum["PH"] = "PH";
    RetinoShippingShippingListListTicketCountryEnum["PK"] = "PK";
    RetinoShippingShippingListListTicketCountryEnum["PL"] = "PL";
    RetinoShippingShippingListListTicketCountryEnum["PM"] = "PM";
    RetinoShippingShippingListListTicketCountryEnum["PN"] = "PN";
    RetinoShippingShippingListListTicketCountryEnum["PR"] = "PR";
    RetinoShippingShippingListListTicketCountryEnum["PS"] = "PS";
    RetinoShippingShippingListListTicketCountryEnum["PT"] = "PT";
    RetinoShippingShippingListListTicketCountryEnum["PW"] = "PW";
    RetinoShippingShippingListListTicketCountryEnum["PY"] = "PY";
    RetinoShippingShippingListListTicketCountryEnum["QA"] = "QA";
    RetinoShippingShippingListListTicketCountryEnum["RE"] = "RE";
    RetinoShippingShippingListListTicketCountryEnum["RO"] = "RO";
    RetinoShippingShippingListListTicketCountryEnum["RS"] = "RS";
    RetinoShippingShippingListListTicketCountryEnum["RU"] = "RU";
    RetinoShippingShippingListListTicketCountryEnum["RW"] = "RW";
    RetinoShippingShippingListListTicketCountryEnum["SA"] = "SA";
    RetinoShippingShippingListListTicketCountryEnum["SB"] = "SB";
    RetinoShippingShippingListListTicketCountryEnum["SC"] = "SC";
    RetinoShippingShippingListListTicketCountryEnum["SD"] = "SD";
    RetinoShippingShippingListListTicketCountryEnum["SE"] = "SE";
    RetinoShippingShippingListListTicketCountryEnum["SG"] = "SG";
    RetinoShippingShippingListListTicketCountryEnum["SH"] = "SH";
    RetinoShippingShippingListListTicketCountryEnum["SI"] = "SI";
    RetinoShippingShippingListListTicketCountryEnum["SJ"] = "SJ";
    RetinoShippingShippingListListTicketCountryEnum["SK"] = "SK";
    RetinoShippingShippingListListTicketCountryEnum["SL"] = "SL";
    RetinoShippingShippingListListTicketCountryEnum["SM"] = "SM";
    RetinoShippingShippingListListTicketCountryEnum["SN"] = "SN";
    RetinoShippingShippingListListTicketCountryEnum["SO"] = "SO";
    RetinoShippingShippingListListTicketCountryEnum["SR"] = "SR";
    RetinoShippingShippingListListTicketCountryEnum["SS"] = "SS";
    RetinoShippingShippingListListTicketCountryEnum["ST"] = "ST";
    RetinoShippingShippingListListTicketCountryEnum["SV"] = "SV";
    RetinoShippingShippingListListTicketCountryEnum["SX"] = "SX";
    RetinoShippingShippingListListTicketCountryEnum["SY"] = "SY";
    RetinoShippingShippingListListTicketCountryEnum["SZ"] = "SZ";
    RetinoShippingShippingListListTicketCountryEnum["TC"] = "TC";
    RetinoShippingShippingListListTicketCountryEnum["TD"] = "TD";
    RetinoShippingShippingListListTicketCountryEnum["TF"] = "TF";
    RetinoShippingShippingListListTicketCountryEnum["TG"] = "TG";
    RetinoShippingShippingListListTicketCountryEnum["TH"] = "TH";
    RetinoShippingShippingListListTicketCountryEnum["TJ"] = "TJ";
    RetinoShippingShippingListListTicketCountryEnum["TK"] = "TK";
    RetinoShippingShippingListListTicketCountryEnum["TL"] = "TL";
    RetinoShippingShippingListListTicketCountryEnum["TM"] = "TM";
    RetinoShippingShippingListListTicketCountryEnum["TN"] = "TN";
    RetinoShippingShippingListListTicketCountryEnum["TO"] = "TO";
    RetinoShippingShippingListListTicketCountryEnum["TR"] = "TR";
    RetinoShippingShippingListListTicketCountryEnum["TT"] = "TT";
    RetinoShippingShippingListListTicketCountryEnum["TV"] = "TV";
    RetinoShippingShippingListListTicketCountryEnum["TW"] = "TW";
    RetinoShippingShippingListListTicketCountryEnum["TZ"] = "TZ";
    RetinoShippingShippingListListTicketCountryEnum["UA"] = "UA";
    RetinoShippingShippingListListTicketCountryEnum["UG"] = "UG";
    RetinoShippingShippingListListTicketCountryEnum["UM"] = "UM";
    RetinoShippingShippingListListTicketCountryEnum["US"] = "US";
    RetinoShippingShippingListListTicketCountryEnum["UY"] = "UY";
    RetinoShippingShippingListListTicketCountryEnum["UZ"] = "UZ";
    RetinoShippingShippingListListTicketCountryEnum["VA"] = "VA";
    RetinoShippingShippingListListTicketCountryEnum["VC"] = "VC";
    RetinoShippingShippingListListTicketCountryEnum["VE"] = "VE";
    RetinoShippingShippingListListTicketCountryEnum["VG"] = "VG";
    RetinoShippingShippingListListTicketCountryEnum["VI"] = "VI";
    RetinoShippingShippingListListTicketCountryEnum["VN"] = "VN";
    RetinoShippingShippingListListTicketCountryEnum["VU"] = "VU";
    RetinoShippingShippingListListTicketCountryEnum["WF"] = "WF";
    RetinoShippingShippingListListTicketCountryEnum["WS"] = "WS";
    RetinoShippingShippingListListTicketCountryEnum["YE"] = "YE";
    RetinoShippingShippingListListTicketCountryEnum["YT"] = "YT";
    RetinoShippingShippingListListTicketCountryEnum["ZA"] = "ZA";
    RetinoShippingShippingListListTicketCountryEnum["ZM"] = "ZM";
    RetinoShippingShippingListListTicketCountryEnum["ZW"] = "ZW";
    return RetinoShippingShippingListListTicketCountryEnum;
  }({});
  _BackendEnums.RetinoShippingShippingListListTicketCountryEnum = RetinoShippingShippingListListTicketCountryEnum;
  let ShippingListStatusEnum = /*#__PURE__*/function (ShippingListStatusEnum) {
    ShippingListStatusEnum["STATUS_ACCEPTED"] = "STATUS_ACCEPTED";
    ShippingListStatusEnum["STATUS_CANCELED"] = "STATUS_CANCELED";
    ShippingListStatusEnum["STATUS_DELIVERED"] = "STATUS_DELIVERED";
    ShippingListStatusEnum["STATUS_INIT"] = "STATUS_INIT";
    ShippingListStatusEnum["STATUS_PENDING_CONFIRMATION"] = "STATUS_PENDING_CONFIRMATION";
    ShippingListStatusEnum["STATUS_REFUNDED"] = "STATUS_REFUNDED";
    ShippingListStatusEnum["STATUS_SUBMITTED"] = "STATUS_SUBMITTED";
    ShippingListStatusEnum["STATUS_TRANSPORT"] = "STATUS_TRANSPORT";
    ShippingListStatusEnum["STATUS_UNDELIVERED"] = "STATUS_UNDELIVERED";
    ShippingListStatusEnum["STATUS_UNKNOWN"] = "STATUS_UNKNOWN";
    ShippingListStatusEnum["STATUS_WAITING_FOR_ORDERING"] = "STATUS_WAITING_FOR_ORDERING";
    return ShippingListStatusEnum;
  }({});
  _BackendEnums.ShippingListStatusEnum = ShippingListStatusEnum;
  let ShippingShippingListListShippingProviderEnum = /*#__PURE__*/function (ShippingShippingListListShippingProviderEnum) {
    ShippingShippingListListShippingProviderEnum["CUSTOM"] = "CUSTOM";
    ShippingShippingListListShippingProviderEnum["DHL24_DROP_OFF"] = "DHL24_DROP_OFF";
    ShippingShippingListListShippingProviderEnum["DHL24_PICKUP"] = "DHL24_PICKUP";
    ShippingShippingListListShippingProviderEnum["DHL_FREIGHT_PICKUP"] = "DHL_FREIGHT_PICKUP";
    ShippingShippingListListShippingProviderEnum["DHL_INTERNATIONAL_DROPOFF"] = "DHL_INTERNATIONAL_DROPOFF";
    ShippingShippingListListShippingProviderEnum["DPD_BELGIUM_DROPOFF"] = "DPD_BELGIUM_DROPOFF";
    ShippingShippingListListShippingProviderEnum["DPD_GEO_API_DROPOFF"] = "DPD_GEO_API_DROPOFF";
    ShippingShippingListListShippingProviderEnum["DPD_GEO_API_PICKUP"] = "DPD_GEO_API_PICKUP";
    ShippingShippingListListShippingProviderEnum["DPD_HU_DROPOFF"] = "DPD_HU_DROPOFF";
    ShippingShippingListListShippingProviderEnum["DPD_HU_PICKUP"] = "DPD_HU_PICKUP";
    ShippingShippingListListShippingProviderEnum["DPD_REG_PRIJEMCE_DROPOFF"] = "DPD_REG_PRIJEMCE_DROPOFF";
    ShippingShippingListListShippingProviderEnum["DPD_REG_PRIJEMCE_PICKUP"] = "DPD_REG_PRIJEMCE_PICKUP";
    ShippingShippingListListShippingProviderEnum["DPD_SK_DROPOFF"] = "DPD_SK_DROPOFF";
    ShippingShippingListListShippingProviderEnum["DPD_SK_PICKUP"] = "DPD_SK_PICKUP";
    ShippingShippingListListShippingProviderEnum["FOXPOST_RETURNS"] = "FOXPOST_RETURNS";
    ShippingShippingListListShippingProviderEnum["GEIS_PICKUP"] = "GEIS_PICKUP";
    ShippingShippingListListShippingProviderEnum["GLS_ISRS"] = "GLS_ISRS";
    ShippingShippingListListShippingProviderEnum["GLS_PICKUP"] = "GLS_PICKUP";
    ShippingShippingListListShippingProviderEnum["GLS_POLAND_API_DROPOFF"] = "GLS_POLAND_API_DROPOFF";
    ShippingShippingListListShippingProviderEnum["INPOST_DROP_OFF"] = "INPOST_DROP_OFF";
    ShippingShippingListListShippingProviderEnum["INPOST_PICKUP"] = "INPOST_PICKUP";
    ShippingShippingListListShippingProviderEnum["IN_PERSON"] = "IN_PERSON";
    ShippingShippingListListShippingProviderEnum["LIFTAGO"] = "LIFTAGO";
    ShippingShippingListListShippingProviderEnum["MY_GLS_BOX_CZ"] = "MY_GLS_BOX_CZ";
    ShippingShippingListListShippingProviderEnum["MY_GLS_DROP_OFF_CZ"] = "MY_GLS_DROP_OFF_CZ";
    ShippingShippingListListShippingProviderEnum["MY_GLS_DROP_OFF_HU"] = "MY_GLS_DROP_OFF_HU";
    ShippingShippingListListShippingProviderEnum["MY_GLS_DROP_OFF_SK"] = "MY_GLS_DROP_OFF_SK";
    ShippingShippingListListShippingProviderEnum["MY_GLS_PICKUP_CZ"] = "MY_GLS_PICKUP_CZ";
    ShippingShippingListListShippingProviderEnum["MY_GLS_PICKUP_HR"] = "MY_GLS_PICKUP_HR";
    ShippingShippingListListShippingProviderEnum["MY_GLS_PICKUP_HU"] = "MY_GLS_PICKUP_HU";
    ShippingShippingListListShippingProviderEnum["MY_GLS_PICKUP_SI"] = "MY_GLS_PICKUP_SI";
    ShippingShippingListListShippingProviderEnum["MY_GLS_PICKUP_SK"] = "MY_GLS_PICKUP_SK";
    ShippingShippingListListShippingProviderEnum["MY_PPL_CPL_DROPOFF"] = "MY_PPL_CPL_DROPOFF";
    ShippingShippingListListShippingProviderEnum["MY_PPL_CPL_PICKUP"] = "MY_PPL_CPL_PICKUP";
    ShippingShippingListListShippingProviderEnum["MY_PPL_PICKUP"] = "MY_PPL_PICKUP";
    ShippingShippingListListShippingProviderEnum["PACKETA_CLAIM_ASSISTANT"] = "PACKETA_CLAIM_ASSISTANT";
    ShippingShippingListListShippingProviderEnum["PPL_RETURN_CONNECT_DROPOFF"] = "PPL_RETURN_CONNECT_DROPOFF";
    ShippingShippingListListShippingProviderEnum["PPL_RETURN_CONNECT_PICKUP"] = "PPL_RETURN_CONNECT_PICKUP";
    ShippingShippingListListShippingProviderEnum["RABEN_FREIGHT"] = "RABEN_FREIGHT";
    ShippingShippingListListShippingProviderEnum["SPS_DROPOFF"] = "SPS_DROPOFF";
    ShippingShippingListListShippingProviderEnum["UPS_PICKUP"] = "UPS_PICKUP";
    return ShippingShippingListListShippingProviderEnum;
  }({});
  _BackendEnums.ShippingShippingListListShippingProviderEnum = ShippingShippingListListShippingProviderEnum;
  let TicketProductsListTicketCountryEnum = /*#__PURE__*/function (TicketProductsListTicketCountryEnum) {
    TicketProductsListTicketCountryEnum["AD"] = "AD";
    TicketProductsListTicketCountryEnum["AE"] = "AE";
    TicketProductsListTicketCountryEnum["AF"] = "AF";
    TicketProductsListTicketCountryEnum["AG"] = "AG";
    TicketProductsListTicketCountryEnum["AI"] = "AI";
    TicketProductsListTicketCountryEnum["AL"] = "AL";
    TicketProductsListTicketCountryEnum["AM"] = "AM";
    TicketProductsListTicketCountryEnum["AO"] = "AO";
    TicketProductsListTicketCountryEnum["AQ"] = "AQ";
    TicketProductsListTicketCountryEnum["AR"] = "AR";
    TicketProductsListTicketCountryEnum["AS"] = "AS";
    TicketProductsListTicketCountryEnum["AT"] = "AT";
    TicketProductsListTicketCountryEnum["AU"] = "AU";
    TicketProductsListTicketCountryEnum["AW"] = "AW";
    TicketProductsListTicketCountryEnum["AX"] = "AX";
    TicketProductsListTicketCountryEnum["AZ"] = "AZ";
    TicketProductsListTicketCountryEnum["BA"] = "BA";
    TicketProductsListTicketCountryEnum["BB"] = "BB";
    TicketProductsListTicketCountryEnum["BD"] = "BD";
    TicketProductsListTicketCountryEnum["BE"] = "BE";
    TicketProductsListTicketCountryEnum["BF"] = "BF";
    TicketProductsListTicketCountryEnum["BG"] = "BG";
    TicketProductsListTicketCountryEnum["BH"] = "BH";
    TicketProductsListTicketCountryEnum["BI"] = "BI";
    TicketProductsListTicketCountryEnum["BJ"] = "BJ";
    TicketProductsListTicketCountryEnum["BL"] = "BL";
    TicketProductsListTicketCountryEnum["BM"] = "BM";
    TicketProductsListTicketCountryEnum["BN"] = "BN";
    TicketProductsListTicketCountryEnum["BO"] = "BO";
    TicketProductsListTicketCountryEnum["BQ"] = "BQ";
    TicketProductsListTicketCountryEnum["BR"] = "BR";
    TicketProductsListTicketCountryEnum["BS"] = "BS";
    TicketProductsListTicketCountryEnum["BT"] = "BT";
    TicketProductsListTicketCountryEnum["BV"] = "BV";
    TicketProductsListTicketCountryEnum["BW"] = "BW";
    TicketProductsListTicketCountryEnum["BY"] = "BY";
    TicketProductsListTicketCountryEnum["BZ"] = "BZ";
    TicketProductsListTicketCountryEnum["CA"] = "CA";
    TicketProductsListTicketCountryEnum["CC"] = "CC";
    TicketProductsListTicketCountryEnum["CD"] = "CD";
    TicketProductsListTicketCountryEnum["CF"] = "CF";
    TicketProductsListTicketCountryEnum["CG"] = "CG";
    TicketProductsListTicketCountryEnum["CH"] = "CH";
    TicketProductsListTicketCountryEnum["CI"] = "CI";
    TicketProductsListTicketCountryEnum["CK"] = "CK";
    TicketProductsListTicketCountryEnum["CL"] = "CL";
    TicketProductsListTicketCountryEnum["CM"] = "CM";
    TicketProductsListTicketCountryEnum["CN"] = "CN";
    TicketProductsListTicketCountryEnum["CO"] = "CO";
    TicketProductsListTicketCountryEnum["CR"] = "CR";
    TicketProductsListTicketCountryEnum["CU"] = "CU";
    TicketProductsListTicketCountryEnum["CV"] = "CV";
    TicketProductsListTicketCountryEnum["CW"] = "CW";
    TicketProductsListTicketCountryEnum["CX"] = "CX";
    TicketProductsListTicketCountryEnum["CY"] = "CY";
    TicketProductsListTicketCountryEnum["CZ"] = "CZ";
    TicketProductsListTicketCountryEnum["DE"] = "DE";
    TicketProductsListTicketCountryEnum["DJ"] = "DJ";
    TicketProductsListTicketCountryEnum["DK"] = "DK";
    TicketProductsListTicketCountryEnum["DM"] = "DM";
    TicketProductsListTicketCountryEnum["DO"] = "DO";
    TicketProductsListTicketCountryEnum["DZ"] = "DZ";
    TicketProductsListTicketCountryEnum["EC"] = "EC";
    TicketProductsListTicketCountryEnum["EE"] = "EE";
    TicketProductsListTicketCountryEnum["EG"] = "EG";
    TicketProductsListTicketCountryEnum["EH"] = "EH";
    TicketProductsListTicketCountryEnum["ER"] = "ER";
    TicketProductsListTicketCountryEnum["ES"] = "ES";
    TicketProductsListTicketCountryEnum["ET"] = "ET";
    TicketProductsListTicketCountryEnum["FI"] = "FI";
    TicketProductsListTicketCountryEnum["FJ"] = "FJ";
    TicketProductsListTicketCountryEnum["FK"] = "FK";
    TicketProductsListTicketCountryEnum["FM"] = "FM";
    TicketProductsListTicketCountryEnum["FO"] = "FO";
    TicketProductsListTicketCountryEnum["FR"] = "FR";
    TicketProductsListTicketCountryEnum["GA"] = "GA";
    TicketProductsListTicketCountryEnum["GB"] = "GB";
    TicketProductsListTicketCountryEnum["GD"] = "GD";
    TicketProductsListTicketCountryEnum["GE"] = "GE";
    TicketProductsListTicketCountryEnum["GF"] = "GF";
    TicketProductsListTicketCountryEnum["GG"] = "GG";
    TicketProductsListTicketCountryEnum["GH"] = "GH";
    TicketProductsListTicketCountryEnum["GI"] = "GI";
    TicketProductsListTicketCountryEnum["GL"] = "GL";
    TicketProductsListTicketCountryEnum["GM"] = "GM";
    TicketProductsListTicketCountryEnum["GN"] = "GN";
    TicketProductsListTicketCountryEnum["GP"] = "GP";
    TicketProductsListTicketCountryEnum["GQ"] = "GQ";
    TicketProductsListTicketCountryEnum["GR"] = "GR";
    TicketProductsListTicketCountryEnum["GS"] = "GS";
    TicketProductsListTicketCountryEnum["GT"] = "GT";
    TicketProductsListTicketCountryEnum["GU"] = "GU";
    TicketProductsListTicketCountryEnum["GW"] = "GW";
    TicketProductsListTicketCountryEnum["GY"] = "GY";
    TicketProductsListTicketCountryEnum["HK"] = "HK";
    TicketProductsListTicketCountryEnum["HM"] = "HM";
    TicketProductsListTicketCountryEnum["HN"] = "HN";
    TicketProductsListTicketCountryEnum["HR"] = "HR";
    TicketProductsListTicketCountryEnum["HT"] = "HT";
    TicketProductsListTicketCountryEnum["HU"] = "HU";
    TicketProductsListTicketCountryEnum["ID"] = "ID";
    TicketProductsListTicketCountryEnum["IE"] = "IE";
    TicketProductsListTicketCountryEnum["IL"] = "IL";
    TicketProductsListTicketCountryEnum["IM"] = "IM";
    TicketProductsListTicketCountryEnum["IN"] = "IN";
    TicketProductsListTicketCountryEnum["IO"] = "IO";
    TicketProductsListTicketCountryEnum["IQ"] = "IQ";
    TicketProductsListTicketCountryEnum["IR"] = "IR";
    TicketProductsListTicketCountryEnum["IS"] = "IS";
    TicketProductsListTicketCountryEnum["IT"] = "IT";
    TicketProductsListTicketCountryEnum["JE"] = "JE";
    TicketProductsListTicketCountryEnum["JM"] = "JM";
    TicketProductsListTicketCountryEnum["JO"] = "JO";
    TicketProductsListTicketCountryEnum["JP"] = "JP";
    TicketProductsListTicketCountryEnum["KE"] = "KE";
    TicketProductsListTicketCountryEnum["KG"] = "KG";
    TicketProductsListTicketCountryEnum["KH"] = "KH";
    TicketProductsListTicketCountryEnum["KI"] = "KI";
    TicketProductsListTicketCountryEnum["KM"] = "KM";
    TicketProductsListTicketCountryEnum["KN"] = "KN";
    TicketProductsListTicketCountryEnum["KP"] = "KP";
    TicketProductsListTicketCountryEnum["KR"] = "KR";
    TicketProductsListTicketCountryEnum["KW"] = "KW";
    TicketProductsListTicketCountryEnum["KY"] = "KY";
    TicketProductsListTicketCountryEnum["KZ"] = "KZ";
    TicketProductsListTicketCountryEnum["LA"] = "LA";
    TicketProductsListTicketCountryEnum["LB"] = "LB";
    TicketProductsListTicketCountryEnum["LC"] = "LC";
    TicketProductsListTicketCountryEnum["LI"] = "LI";
    TicketProductsListTicketCountryEnum["LK"] = "LK";
    TicketProductsListTicketCountryEnum["LR"] = "LR";
    TicketProductsListTicketCountryEnum["LS"] = "LS";
    TicketProductsListTicketCountryEnum["LT"] = "LT";
    TicketProductsListTicketCountryEnum["LU"] = "LU";
    TicketProductsListTicketCountryEnum["LV"] = "LV";
    TicketProductsListTicketCountryEnum["LY"] = "LY";
    TicketProductsListTicketCountryEnum["MA"] = "MA";
    TicketProductsListTicketCountryEnum["MC"] = "MC";
    TicketProductsListTicketCountryEnum["MD"] = "MD";
    TicketProductsListTicketCountryEnum["ME"] = "ME";
    TicketProductsListTicketCountryEnum["MF"] = "MF";
    TicketProductsListTicketCountryEnum["MG"] = "MG";
    TicketProductsListTicketCountryEnum["MH"] = "MH";
    TicketProductsListTicketCountryEnum["MK"] = "MK";
    TicketProductsListTicketCountryEnum["ML"] = "ML";
    TicketProductsListTicketCountryEnum["MM"] = "MM";
    TicketProductsListTicketCountryEnum["MN"] = "MN";
    TicketProductsListTicketCountryEnum["MO"] = "MO";
    TicketProductsListTicketCountryEnum["MP"] = "MP";
    TicketProductsListTicketCountryEnum["MQ"] = "MQ";
    TicketProductsListTicketCountryEnum["MR"] = "MR";
    TicketProductsListTicketCountryEnum["MS"] = "MS";
    TicketProductsListTicketCountryEnum["MT"] = "MT";
    TicketProductsListTicketCountryEnum["MU"] = "MU";
    TicketProductsListTicketCountryEnum["MV"] = "MV";
    TicketProductsListTicketCountryEnum["MW"] = "MW";
    TicketProductsListTicketCountryEnum["MX"] = "MX";
    TicketProductsListTicketCountryEnum["MY"] = "MY";
    TicketProductsListTicketCountryEnum["MZ"] = "MZ";
    TicketProductsListTicketCountryEnum["NA"] = "NA";
    TicketProductsListTicketCountryEnum["NC"] = "NC";
    TicketProductsListTicketCountryEnum["NE"] = "NE";
    TicketProductsListTicketCountryEnum["NF"] = "NF";
    TicketProductsListTicketCountryEnum["NG"] = "NG";
    TicketProductsListTicketCountryEnum["NI"] = "NI";
    TicketProductsListTicketCountryEnum["NL"] = "NL";
    TicketProductsListTicketCountryEnum["NO"] = "NO";
    TicketProductsListTicketCountryEnum["NP"] = "NP";
    TicketProductsListTicketCountryEnum["NR"] = "NR";
    TicketProductsListTicketCountryEnum["NU"] = "NU";
    TicketProductsListTicketCountryEnum["NZ"] = "NZ";
    TicketProductsListTicketCountryEnum["OM"] = "OM";
    TicketProductsListTicketCountryEnum["PA"] = "PA";
    TicketProductsListTicketCountryEnum["PE"] = "PE";
    TicketProductsListTicketCountryEnum["PF"] = "PF";
    TicketProductsListTicketCountryEnum["PG"] = "PG";
    TicketProductsListTicketCountryEnum["PH"] = "PH";
    TicketProductsListTicketCountryEnum["PK"] = "PK";
    TicketProductsListTicketCountryEnum["PL"] = "PL";
    TicketProductsListTicketCountryEnum["PM"] = "PM";
    TicketProductsListTicketCountryEnum["PN"] = "PN";
    TicketProductsListTicketCountryEnum["PR"] = "PR";
    TicketProductsListTicketCountryEnum["PS"] = "PS";
    TicketProductsListTicketCountryEnum["PT"] = "PT";
    TicketProductsListTicketCountryEnum["PW"] = "PW";
    TicketProductsListTicketCountryEnum["PY"] = "PY";
    TicketProductsListTicketCountryEnum["QA"] = "QA";
    TicketProductsListTicketCountryEnum["RE"] = "RE";
    TicketProductsListTicketCountryEnum["RO"] = "RO";
    TicketProductsListTicketCountryEnum["RS"] = "RS";
    TicketProductsListTicketCountryEnum["RU"] = "RU";
    TicketProductsListTicketCountryEnum["RW"] = "RW";
    TicketProductsListTicketCountryEnum["SA"] = "SA";
    TicketProductsListTicketCountryEnum["SB"] = "SB";
    TicketProductsListTicketCountryEnum["SC"] = "SC";
    TicketProductsListTicketCountryEnum["SD"] = "SD";
    TicketProductsListTicketCountryEnum["SE"] = "SE";
    TicketProductsListTicketCountryEnum["SG"] = "SG";
    TicketProductsListTicketCountryEnum["SH"] = "SH";
    TicketProductsListTicketCountryEnum["SI"] = "SI";
    TicketProductsListTicketCountryEnum["SJ"] = "SJ";
    TicketProductsListTicketCountryEnum["SK"] = "SK";
    TicketProductsListTicketCountryEnum["SL"] = "SL";
    TicketProductsListTicketCountryEnum["SM"] = "SM";
    TicketProductsListTicketCountryEnum["SN"] = "SN";
    TicketProductsListTicketCountryEnum["SO"] = "SO";
    TicketProductsListTicketCountryEnum["SR"] = "SR";
    TicketProductsListTicketCountryEnum["SS"] = "SS";
    TicketProductsListTicketCountryEnum["ST"] = "ST";
    TicketProductsListTicketCountryEnum["SV"] = "SV";
    TicketProductsListTicketCountryEnum["SX"] = "SX";
    TicketProductsListTicketCountryEnum["SY"] = "SY";
    TicketProductsListTicketCountryEnum["SZ"] = "SZ";
    TicketProductsListTicketCountryEnum["TC"] = "TC";
    TicketProductsListTicketCountryEnum["TD"] = "TD";
    TicketProductsListTicketCountryEnum["TF"] = "TF";
    TicketProductsListTicketCountryEnum["TG"] = "TG";
    TicketProductsListTicketCountryEnum["TH"] = "TH";
    TicketProductsListTicketCountryEnum["TJ"] = "TJ";
    TicketProductsListTicketCountryEnum["TK"] = "TK";
    TicketProductsListTicketCountryEnum["TL"] = "TL";
    TicketProductsListTicketCountryEnum["TM"] = "TM";
    TicketProductsListTicketCountryEnum["TN"] = "TN";
    TicketProductsListTicketCountryEnum["TO"] = "TO";
    TicketProductsListTicketCountryEnum["TR"] = "TR";
    TicketProductsListTicketCountryEnum["TT"] = "TT";
    TicketProductsListTicketCountryEnum["TV"] = "TV";
    TicketProductsListTicketCountryEnum["TW"] = "TW";
    TicketProductsListTicketCountryEnum["TZ"] = "TZ";
    TicketProductsListTicketCountryEnum["UA"] = "UA";
    TicketProductsListTicketCountryEnum["UG"] = "UG";
    TicketProductsListTicketCountryEnum["UM"] = "UM";
    TicketProductsListTicketCountryEnum["US"] = "US";
    TicketProductsListTicketCountryEnum["UY"] = "UY";
    TicketProductsListTicketCountryEnum["UZ"] = "UZ";
    TicketProductsListTicketCountryEnum["VA"] = "VA";
    TicketProductsListTicketCountryEnum["VC"] = "VC";
    TicketProductsListTicketCountryEnum["VE"] = "VE";
    TicketProductsListTicketCountryEnum["VG"] = "VG";
    TicketProductsListTicketCountryEnum["VI"] = "VI";
    TicketProductsListTicketCountryEnum["VN"] = "VN";
    TicketProductsListTicketCountryEnum["VU"] = "VU";
    TicketProductsListTicketCountryEnum["WF"] = "WF";
    TicketProductsListTicketCountryEnum["WS"] = "WS";
    TicketProductsListTicketCountryEnum["YE"] = "YE";
    TicketProductsListTicketCountryEnum["YT"] = "YT";
    TicketProductsListTicketCountryEnum["ZA"] = "ZA";
    TicketProductsListTicketCountryEnum["ZM"] = "ZM";
    TicketProductsListTicketCountryEnum["ZW"] = "ZW";
    return TicketProductsListTicketCountryEnum;
  }({});
  _BackendEnums.TicketProductsListTicketCountryEnum = TicketProductsListTicketCountryEnum;
  let TicketsListCountryEnum = /*#__PURE__*/function (TicketsListCountryEnum) {
    TicketsListCountryEnum["AD"] = "AD";
    TicketsListCountryEnum["AE"] = "AE";
    TicketsListCountryEnum["AF"] = "AF";
    TicketsListCountryEnum["AG"] = "AG";
    TicketsListCountryEnum["AI"] = "AI";
    TicketsListCountryEnum["AL"] = "AL";
    TicketsListCountryEnum["AM"] = "AM";
    TicketsListCountryEnum["AO"] = "AO";
    TicketsListCountryEnum["AQ"] = "AQ";
    TicketsListCountryEnum["AR"] = "AR";
    TicketsListCountryEnum["AS"] = "AS";
    TicketsListCountryEnum["AT"] = "AT";
    TicketsListCountryEnum["AU"] = "AU";
    TicketsListCountryEnum["AW"] = "AW";
    TicketsListCountryEnum["AX"] = "AX";
    TicketsListCountryEnum["AZ"] = "AZ";
    TicketsListCountryEnum["BA"] = "BA";
    TicketsListCountryEnum["BB"] = "BB";
    TicketsListCountryEnum["BD"] = "BD";
    TicketsListCountryEnum["BE"] = "BE";
    TicketsListCountryEnum["BF"] = "BF";
    TicketsListCountryEnum["BG"] = "BG";
    TicketsListCountryEnum["BH"] = "BH";
    TicketsListCountryEnum["BI"] = "BI";
    TicketsListCountryEnum["BJ"] = "BJ";
    TicketsListCountryEnum["BL"] = "BL";
    TicketsListCountryEnum["BM"] = "BM";
    TicketsListCountryEnum["BN"] = "BN";
    TicketsListCountryEnum["BO"] = "BO";
    TicketsListCountryEnum["BQ"] = "BQ";
    TicketsListCountryEnum["BR"] = "BR";
    TicketsListCountryEnum["BS"] = "BS";
    TicketsListCountryEnum["BT"] = "BT";
    TicketsListCountryEnum["BV"] = "BV";
    TicketsListCountryEnum["BW"] = "BW";
    TicketsListCountryEnum["BY"] = "BY";
    TicketsListCountryEnum["BZ"] = "BZ";
    TicketsListCountryEnum["CA"] = "CA";
    TicketsListCountryEnum["CC"] = "CC";
    TicketsListCountryEnum["CD"] = "CD";
    TicketsListCountryEnum["CF"] = "CF";
    TicketsListCountryEnum["CG"] = "CG";
    TicketsListCountryEnum["CH"] = "CH";
    TicketsListCountryEnum["CI"] = "CI";
    TicketsListCountryEnum["CK"] = "CK";
    TicketsListCountryEnum["CL"] = "CL";
    TicketsListCountryEnum["CM"] = "CM";
    TicketsListCountryEnum["CN"] = "CN";
    TicketsListCountryEnum["CO"] = "CO";
    TicketsListCountryEnum["CR"] = "CR";
    TicketsListCountryEnum["CU"] = "CU";
    TicketsListCountryEnum["CV"] = "CV";
    TicketsListCountryEnum["CW"] = "CW";
    TicketsListCountryEnum["CX"] = "CX";
    TicketsListCountryEnum["CY"] = "CY";
    TicketsListCountryEnum["CZ"] = "CZ";
    TicketsListCountryEnum["DE"] = "DE";
    TicketsListCountryEnum["DJ"] = "DJ";
    TicketsListCountryEnum["DK"] = "DK";
    TicketsListCountryEnum["DM"] = "DM";
    TicketsListCountryEnum["DO"] = "DO";
    TicketsListCountryEnum["DZ"] = "DZ";
    TicketsListCountryEnum["EC"] = "EC";
    TicketsListCountryEnum["EE"] = "EE";
    TicketsListCountryEnum["EG"] = "EG";
    TicketsListCountryEnum["EH"] = "EH";
    TicketsListCountryEnum["ER"] = "ER";
    TicketsListCountryEnum["ES"] = "ES";
    TicketsListCountryEnum["ET"] = "ET";
    TicketsListCountryEnum["FI"] = "FI";
    TicketsListCountryEnum["FJ"] = "FJ";
    TicketsListCountryEnum["FK"] = "FK";
    TicketsListCountryEnum["FM"] = "FM";
    TicketsListCountryEnum["FO"] = "FO";
    TicketsListCountryEnum["FR"] = "FR";
    TicketsListCountryEnum["GA"] = "GA";
    TicketsListCountryEnum["GB"] = "GB";
    TicketsListCountryEnum["GD"] = "GD";
    TicketsListCountryEnum["GE"] = "GE";
    TicketsListCountryEnum["GF"] = "GF";
    TicketsListCountryEnum["GG"] = "GG";
    TicketsListCountryEnum["GH"] = "GH";
    TicketsListCountryEnum["GI"] = "GI";
    TicketsListCountryEnum["GL"] = "GL";
    TicketsListCountryEnum["GM"] = "GM";
    TicketsListCountryEnum["GN"] = "GN";
    TicketsListCountryEnum["GP"] = "GP";
    TicketsListCountryEnum["GQ"] = "GQ";
    TicketsListCountryEnum["GR"] = "GR";
    TicketsListCountryEnum["GS"] = "GS";
    TicketsListCountryEnum["GT"] = "GT";
    TicketsListCountryEnum["GU"] = "GU";
    TicketsListCountryEnum["GW"] = "GW";
    TicketsListCountryEnum["GY"] = "GY";
    TicketsListCountryEnum["HK"] = "HK";
    TicketsListCountryEnum["HM"] = "HM";
    TicketsListCountryEnum["HN"] = "HN";
    TicketsListCountryEnum["HR"] = "HR";
    TicketsListCountryEnum["HT"] = "HT";
    TicketsListCountryEnum["HU"] = "HU";
    TicketsListCountryEnum["ID"] = "ID";
    TicketsListCountryEnum["IE"] = "IE";
    TicketsListCountryEnum["IL"] = "IL";
    TicketsListCountryEnum["IM"] = "IM";
    TicketsListCountryEnum["IN"] = "IN";
    TicketsListCountryEnum["IO"] = "IO";
    TicketsListCountryEnum["IQ"] = "IQ";
    TicketsListCountryEnum["IR"] = "IR";
    TicketsListCountryEnum["IS"] = "IS";
    TicketsListCountryEnum["IT"] = "IT";
    TicketsListCountryEnum["JE"] = "JE";
    TicketsListCountryEnum["JM"] = "JM";
    TicketsListCountryEnum["JO"] = "JO";
    TicketsListCountryEnum["JP"] = "JP";
    TicketsListCountryEnum["KE"] = "KE";
    TicketsListCountryEnum["KG"] = "KG";
    TicketsListCountryEnum["KH"] = "KH";
    TicketsListCountryEnum["KI"] = "KI";
    TicketsListCountryEnum["KM"] = "KM";
    TicketsListCountryEnum["KN"] = "KN";
    TicketsListCountryEnum["KP"] = "KP";
    TicketsListCountryEnum["KR"] = "KR";
    TicketsListCountryEnum["KW"] = "KW";
    TicketsListCountryEnum["KY"] = "KY";
    TicketsListCountryEnum["KZ"] = "KZ";
    TicketsListCountryEnum["LA"] = "LA";
    TicketsListCountryEnum["LB"] = "LB";
    TicketsListCountryEnum["LC"] = "LC";
    TicketsListCountryEnum["LI"] = "LI";
    TicketsListCountryEnum["LK"] = "LK";
    TicketsListCountryEnum["LR"] = "LR";
    TicketsListCountryEnum["LS"] = "LS";
    TicketsListCountryEnum["LT"] = "LT";
    TicketsListCountryEnum["LU"] = "LU";
    TicketsListCountryEnum["LV"] = "LV";
    TicketsListCountryEnum["LY"] = "LY";
    TicketsListCountryEnum["MA"] = "MA";
    TicketsListCountryEnum["MC"] = "MC";
    TicketsListCountryEnum["MD"] = "MD";
    TicketsListCountryEnum["ME"] = "ME";
    TicketsListCountryEnum["MF"] = "MF";
    TicketsListCountryEnum["MG"] = "MG";
    TicketsListCountryEnum["MH"] = "MH";
    TicketsListCountryEnum["MK"] = "MK";
    TicketsListCountryEnum["ML"] = "ML";
    TicketsListCountryEnum["MM"] = "MM";
    TicketsListCountryEnum["MN"] = "MN";
    TicketsListCountryEnum["MO"] = "MO";
    TicketsListCountryEnum["MP"] = "MP";
    TicketsListCountryEnum["MQ"] = "MQ";
    TicketsListCountryEnum["MR"] = "MR";
    TicketsListCountryEnum["MS"] = "MS";
    TicketsListCountryEnum["MT"] = "MT";
    TicketsListCountryEnum["MU"] = "MU";
    TicketsListCountryEnum["MV"] = "MV";
    TicketsListCountryEnum["MW"] = "MW";
    TicketsListCountryEnum["MX"] = "MX";
    TicketsListCountryEnum["MY"] = "MY";
    TicketsListCountryEnum["MZ"] = "MZ";
    TicketsListCountryEnum["NA"] = "NA";
    TicketsListCountryEnum["NC"] = "NC";
    TicketsListCountryEnum["NE"] = "NE";
    TicketsListCountryEnum["NF"] = "NF";
    TicketsListCountryEnum["NG"] = "NG";
    TicketsListCountryEnum["NI"] = "NI";
    TicketsListCountryEnum["NL"] = "NL";
    TicketsListCountryEnum["NO"] = "NO";
    TicketsListCountryEnum["NP"] = "NP";
    TicketsListCountryEnum["NR"] = "NR";
    TicketsListCountryEnum["NU"] = "NU";
    TicketsListCountryEnum["NZ"] = "NZ";
    TicketsListCountryEnum["OM"] = "OM";
    TicketsListCountryEnum["PA"] = "PA";
    TicketsListCountryEnum["PE"] = "PE";
    TicketsListCountryEnum["PF"] = "PF";
    TicketsListCountryEnum["PG"] = "PG";
    TicketsListCountryEnum["PH"] = "PH";
    TicketsListCountryEnum["PK"] = "PK";
    TicketsListCountryEnum["PL"] = "PL";
    TicketsListCountryEnum["PM"] = "PM";
    TicketsListCountryEnum["PN"] = "PN";
    TicketsListCountryEnum["PR"] = "PR";
    TicketsListCountryEnum["PS"] = "PS";
    TicketsListCountryEnum["PT"] = "PT";
    TicketsListCountryEnum["PW"] = "PW";
    TicketsListCountryEnum["PY"] = "PY";
    TicketsListCountryEnum["QA"] = "QA";
    TicketsListCountryEnum["RE"] = "RE";
    TicketsListCountryEnum["RO"] = "RO";
    TicketsListCountryEnum["RS"] = "RS";
    TicketsListCountryEnum["RU"] = "RU";
    TicketsListCountryEnum["RW"] = "RW";
    TicketsListCountryEnum["SA"] = "SA";
    TicketsListCountryEnum["SB"] = "SB";
    TicketsListCountryEnum["SC"] = "SC";
    TicketsListCountryEnum["SD"] = "SD";
    TicketsListCountryEnum["SE"] = "SE";
    TicketsListCountryEnum["SG"] = "SG";
    TicketsListCountryEnum["SH"] = "SH";
    TicketsListCountryEnum["SI"] = "SI";
    TicketsListCountryEnum["SJ"] = "SJ";
    TicketsListCountryEnum["SK"] = "SK";
    TicketsListCountryEnum["SL"] = "SL";
    TicketsListCountryEnum["SM"] = "SM";
    TicketsListCountryEnum["SN"] = "SN";
    TicketsListCountryEnum["SO"] = "SO";
    TicketsListCountryEnum["SR"] = "SR";
    TicketsListCountryEnum["SS"] = "SS";
    TicketsListCountryEnum["ST"] = "ST";
    TicketsListCountryEnum["SV"] = "SV";
    TicketsListCountryEnum["SX"] = "SX";
    TicketsListCountryEnum["SY"] = "SY";
    TicketsListCountryEnum["SZ"] = "SZ";
    TicketsListCountryEnum["TC"] = "TC";
    TicketsListCountryEnum["TD"] = "TD";
    TicketsListCountryEnum["TF"] = "TF";
    TicketsListCountryEnum["TG"] = "TG";
    TicketsListCountryEnum["TH"] = "TH";
    TicketsListCountryEnum["TJ"] = "TJ";
    TicketsListCountryEnum["TK"] = "TK";
    TicketsListCountryEnum["TL"] = "TL";
    TicketsListCountryEnum["TM"] = "TM";
    TicketsListCountryEnum["TN"] = "TN";
    TicketsListCountryEnum["TO"] = "TO";
    TicketsListCountryEnum["TR"] = "TR";
    TicketsListCountryEnum["TT"] = "TT";
    TicketsListCountryEnum["TV"] = "TV";
    TicketsListCountryEnum["TW"] = "TW";
    TicketsListCountryEnum["TZ"] = "TZ";
    TicketsListCountryEnum["UA"] = "UA";
    TicketsListCountryEnum["UG"] = "UG";
    TicketsListCountryEnum["UM"] = "UM";
    TicketsListCountryEnum["US"] = "US";
    TicketsListCountryEnum["UY"] = "UY";
    TicketsListCountryEnum["UZ"] = "UZ";
    TicketsListCountryEnum["VA"] = "VA";
    TicketsListCountryEnum["VC"] = "VC";
    TicketsListCountryEnum["VE"] = "VE";
    TicketsListCountryEnum["VG"] = "VG";
    TicketsListCountryEnum["VI"] = "VI";
    TicketsListCountryEnum["VN"] = "VN";
    TicketsListCountryEnum["VU"] = "VU";
    TicketsListCountryEnum["WF"] = "WF";
    TicketsListCountryEnum["WS"] = "WS";
    TicketsListCountryEnum["YE"] = "YE";
    TicketsListCountryEnum["YT"] = "YT";
    TicketsListCountryEnum["ZA"] = "ZA";
    TicketsListCountryEnum["ZM"] = "ZM";
    TicketsListCountryEnum["ZW"] = "ZW";
    return TicketsListCountryEnum;
  }({});
  _BackendEnums.TicketsListCountryEnum = TicketsListCountryEnum;
  let TicketsListCustomerRatingEnum = /*#__PURE__*/function (TicketsListCustomerRatingEnum) {
    TicketsListCustomerRatingEnum[TicketsListCustomerRatingEnum["VALUE_0"] = 0] = "VALUE_0";
    TicketsListCustomerRatingEnum[TicketsListCustomerRatingEnum["VALUE_1"] = 1] = "VALUE_1";
    TicketsListCustomerRatingEnum[TicketsListCustomerRatingEnum["VALUE_2"] = 2] = "VALUE_2";
    return TicketsListCustomerRatingEnum;
  }({});
  _BackendEnums.TicketsListCustomerRatingEnum = TicketsListCustomerRatingEnum;
  let TicketsListLanguageEnum = /*#__PURE__*/function (TicketsListLanguageEnum) {
    TicketsListLanguageEnum["BG"] = "bg";
    TicketsListLanguageEnum["CS"] = "cs";
    TicketsListLanguageEnum["DA"] = "da";
    TicketsListLanguageEnum["DE"] = "de";
    TicketsListLanguageEnum["DE-AT"] = "de-at";
    TicketsListLanguageEnum["DE-CH"] = "de-ch";
    TicketsListLanguageEnum["EL"] = "el";
    TicketsListLanguageEnum["EN"] = "en";
    TicketsListLanguageEnum["ES"] = "es";
    TicketsListLanguageEnum["ET"] = "et";
    TicketsListLanguageEnum["FI"] = "fi";
    TicketsListLanguageEnum["FR"] = "fr";
    TicketsListLanguageEnum["FR-BE"] = "fr-be";
    TicketsListLanguageEnum["FR-CH"] = "fr-ch";
    TicketsListLanguageEnum["HR"] = "hr";
    TicketsListLanguageEnum["HU"] = "hu";
    TicketsListLanguageEnum["IT"] = "it";
    TicketsListLanguageEnum["IT-CH"] = "it-ch";
    TicketsListLanguageEnum["LT"] = "lt";
    TicketsListLanguageEnum["LV"] = "lv";
    TicketsListLanguageEnum["NB"] = "nb";
    TicketsListLanguageEnum["NL"] = "nl";
    TicketsListLanguageEnum["NL-BE"] = "nl-be";
    TicketsListLanguageEnum["PL"] = "pl";
    TicketsListLanguageEnum["PT"] = "pt";
    TicketsListLanguageEnum["RO"] = "ro";
    TicketsListLanguageEnum["SK"] = "sk";
    TicketsListLanguageEnum["SL"] = "sl";
    TicketsListLanguageEnum["SR"] = "sr";
    TicketsListLanguageEnum["SV"] = "sv";
    TicketsListLanguageEnum["UK"] = "uk";
    return TicketsListLanguageEnum;
  }({});
  _BackendEnums.TicketsListLanguageEnum = TicketsListLanguageEnum;
  let TicketsListOrderingEnum = /*#__PURE__*/function (TicketsListOrderingEnum) {
    TicketsListOrderingEnum["-CODE"] = "-code";
    TicketsListOrderingEnum["-CREATED_AT"] = "-created_at";
    TicketsListOrderingEnum["-CUSTOMER_NAME"] = "-customer_name";
    TicketsListOrderingEnum["CODE"] = "code";
    TicketsListOrderingEnum["CREATED_AT"] = "created_at";
    TicketsListOrderingEnum["CUSTOMER_NAME"] = "customer_name";
    return TicketsListOrderingEnum;
  }({});
  _BackendEnums.TicketsListOrderingEnum = TicketsListOrderingEnum;
  let TicketsListShippingStatusEnum = /*#__PURE__*/function (TicketsListShippingStatusEnum) {
    TicketsListShippingStatusEnum["CANCELED"] = "CANCELED";
    TicketsListShippingStatusEnum["CONFIRMATION_REQUIRED"] = "CONFIRMATION_REQUIRED";
    TicketsListShippingStatusEnum["DECLINED"] = "DECLINED";
    TicketsListShippingStatusEnum["FAILURE"] = "FAILURE";
    TicketsListShippingStatusEnum["FINISHED"] = "FINISHED";
    TicketsListShippingStatusEnum["REFUNDED"] = "REFUNDED";
    TicketsListShippingStatusEnum["SYNCING"] = "SYNCING";
    TicketsListShippingStatusEnum["VOIDED"] = "VOIDED";
    TicketsListShippingStatusEnum["WAITING"] = "WAITING";
    return TicketsListShippingStatusEnum;
  }({});
  _BackendEnums.TicketsListShippingStatusEnum = TicketsListShippingStatusEnum;
  let TicketsHistoryListTypeEnum = /*#__PURE__*/function (TicketsHistoryListTypeEnum) {
    TicketsHistoryListTypeEnum["ACTIVITY"] = "ACTIVITY";
    TicketsHistoryListTypeEnum["ALL"] = "ALL";
    TicketsHistoryListTypeEnum["DOCUMENT"] = "DOCUMENT";
    TicketsHistoryListTypeEnum["INTERNAL_NOTE"] = "INTERNAL_NOTE";
    TicketsHistoryListTypeEnum["MESSAGES"] = "MESSAGES";
    TicketsHistoryListTypeEnum["REFUND_REQUEST"] = "REFUND_REQUEST";
    TicketsHistoryListTypeEnum["RETINO_SHIPPING"] = "RETINO_SHIPPING";
    TicketsHistoryListTypeEnum["SMS_MESSAGES"] = "SMS_MESSAGES";
    TicketsHistoryListTypeEnum["SYSTEM"] = "SYSTEM";
    return TicketsHistoryListTypeEnum;
  }({});
  _BackendEnums.TicketsHistoryListTypeEnum = TicketsHistoryListTypeEnum;
  let TriggerLogsListStateEnum = /*#__PURE__*/function (TriggerLogsListStateEnum) {
    TriggerLogsListStateEnum["CAN_RETRY"] = "CAN_RETRY";
    TriggerLogsListStateEnum["FAILED"] = "FAILED";
    TriggerLogsListStateEnum["SUCCESS"] = "SUCCESS";
    return TriggerLogsListStateEnum;
  }({});
  _BackendEnums.TriggerLogsListStateEnum = TriggerLogsListStateEnum;
})(BackendEnums || (BackendEnums = {}));

/***/ }),

/***/ 29268:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   f: () => (/* reexport safe */ _enums__WEBPACK_IMPORTED_MODULE_0__.f)
/* harmony export */ });
/* harmony import */ var _enums__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70366);


/***/ }),

/***/ 16787:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);

function DropOffCode(_ref) {
  let {
    code,
    variant = 'stacked'
  } = _ref;
  if (variant === 'inline') {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
      className: "text-gray-500"
    }, gettext('Drop-off code'), ":"), ' ', /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
      className: "font-mono font-bold tracking-wider text-indigo-600"
    }, code));
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex flex-col items-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "text-sm text-gray-500"
  }, gettext('Drop-off code')), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "text-2xl font-bold font-mono tracking-wider text-indigo-600"
  }, code));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (DropOffCode);

/***/ }),

/***/ 83073:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35443);


const EllipsisButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((_ref, ref) => {
  let {
    onClick,
    size
  } = _ref;
  const classArray = ['inline-flex', 'cursor-pointer', 'border', 'border-transparent', 'hover:border-gray-200', 'hover:bg-white', 'hover:shadow-sm', 'transition-all', 'text-sm'];
  let roundingSize = '';
  switch (size) {
    case 'tiny':
      classArray.push('px-2.5', 'py-1.5', 'text-xs');
      break;
    case 'small':
      roundingSize = '-md';
      classArray.push('px-3', 'py-2.5', 'text-sm');
      break;
    default:
    case 'medium':
      roundingSize = '-md';
      classArray.push('px-4', 'py-2.5', 'text-sm');
      break;
    case 'large':
      roundingSize = '-md';
      classArray.push('px-4', 'py-2.5', 'text-base');
      break;
    case 'huge':
      roundingSize = '-md';
      classArray.push('px-6', 'py-3.5', 'text-base');
      break;
  }
  classArray.push("rounded".concat(roundingSize));
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    ref: ref,
    type: "button",
    className: classArray.join(' '),
    onClick: onClick
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .In, {
    fitted: true,
    name: "dots-horizontal",
    className: "w-4 text-gray-600 hover:text-gray-700"
  }));
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (EllipsisButton);

/***/ }),

/***/ 49186:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ components_RatingEmoji)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(96540);
;// ./react/components/RatingEmoji/img/emoji_negative.svg
/* harmony default export */ const emoji_negative = ("https://cdn.retino.com/dist/files/react/components/RatingEmoji/img/emoji_negative.svg");
;// ./react/components/RatingEmoji/img/emoji_neutral.svg
/* harmony default export */ const emoji_neutral = ("https://cdn.retino.com/dist/files/react/components/RatingEmoji/img/emoji_neutral.svg");
;// ./react/components/RatingEmoji/img/emoji_positive.svg
/* harmony default export */ const emoji_positive = ("https://cdn.retino.com/dist/files/react/components/RatingEmoji/img/emoji_positive.svg");
;// ./react/components/RatingEmoji/index.tsx
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




function RatingEmoji(_ref) {
  let {
    rating,
    size = 'big'
  } = _ref;
  let imgSize = '45px';
  const baseStyles = {
    verticalAlign: 'middle'
  };
  switch (size) {
    case 'massive':
      imgSize = '101px';
      break;
    case 'large':
      imgSize = '40px';
      break;
    case 'small':
      imgSize = '25px';
      break;
    default:
      break;
  }
  switch (rating) {
    case 0:
      return /*#__PURE__*/react.createElement("img", {
        src: emoji_negative,
        alt: gettext('Bad'),
        style: _objectSpread({
          height: imgSize,
          width: imgSize,
          maxWidth: imgSize
        }, baseStyles)
      });
    case 1:
      return /*#__PURE__*/react.createElement("img", {
        src: emoji_neutral,
        alt: gettext('Good, but...'),
        style: _objectSpread({
          height: imgSize,
          width: imgSize,
          maxWidth: imgSize
        }, baseStyles)
      });
    case 2:
      return /*#__PURE__*/react.createElement("img", {
        src: emoji_positive,
        alt: gettext('Perfect'),
        style: _objectSpread({
          height: imgSize,
          width: imgSize,
          maxWidth: imgSize
        }, baseStyles)
      });
    default:
      return null;
  }
}
/* harmony default export */ const components_RatingEmoji = (RatingEmoji);

/***/ }),

/***/ 7321:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var components_thumbnails_Thumbnails__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85477);
/* harmony import */ var public_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35750);



function FileUploadFieldValueWrapper(_ref) {
  let {
    value
  } = _ref;
  const [fileUploads, setFileUploads] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
  const api = (0,public_api__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Ay)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const fetchFileUploads = async () => {
      const response = await Promise.all(value.map(fileId => api.FilesFilesApi.retrieve({
        id: fileId
      })));
      return response;
    };
    if (value) {
      (async () => {
        const fetchedFileUploads = await fetchFileUploads();
        setFileUploads(fetchedFileUploads);
      })();
    }
  }, [api.FilesFilesApi, value]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(components_thumbnails_Thumbnails__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A, {
    fileUploads: fileUploads
  });
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FileUploadFieldValueWrapper);

/***/ }),

/***/ 85477:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ thumbnails_Thumbnails)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(96540);
// EXTERNAL MODULE: ./node_modules/react-image-gallery/build/image-gallery.js
var image_gallery = __webpack_require__(78074);
var image_gallery_default = /*#__PURE__*/__webpack_require__.n(image_gallery);
// EXTERNAL MODULE: ./react/helpers/utils.ts
var utils = __webpack_require__(41906);
// EXTERNAL MODULE: ./react/ui/index.ts + 3 modules
var ui = __webpack_require__(35443);
;// ./react/components/thumbnails/IconThumbnail.tsx


function IconThumbnail(_ref) {
  let {
    filename
  } = _ref;
  const regexIcon = [[/(.*\.pdf)/, 'document-text'], [/(.*\.mp3|.*\.wav)/, 'volume-up'], [/(.*\.mp4|.*\.avi|.*\.mov)/, 'video-camera'], [/(.*\.txt)/, 'document-text'], [/(.*\.html)/, 'document-text'], [/(.*\.docx)/, 'document-text'], [/(.*\.jpeg|.*\.jpg|.*\.png|.*\.gif|.*\.svg)/, 'photograph'], [/(.*\.zip|.*\.rar|.*\.tar)/, 'folder-download']];
  const icons = regexIcon.map(_ref2 => {
    let [regex, icon] = _ref2;
    return filename.match(regex) ? icon : undefined;
  }).filter(icon => icon !== undefined);
  const icon = icons.length ? icons[0] : 'file outline';
  return /*#__PURE__*/react.createElement("div", {
    className: "flex h-full items-center justify-center"
  }, /*#__PURE__*/react.createElement(ui/* Icon */.In, {
    fitted: true,
    name: icon,
    size: "huge"
  }));
}
/* harmony default export */ const thumbnails_IconThumbnail = (IconThumbnail);
// EXTERNAL MODULE: ./react/components/PaddedLoader.tsx
var PaddedLoader = __webpack_require__(90931);
;// ./react/components/thumbnails/ImageThumbnail.tsx



function ImageThumbnail(_ref) {
  let {
    filename,
    url,
    thumbnailUrl,
    disablePreview = false
  } = _ref;
  const [backgroundImage, setBackgroundImage] = (0,react.useState)(undefined);
  const [isLoading, setIsLoading] = (0,react.useState)(true);
  const loadImage = () => {
    setIsLoading(true);
    const img = new Image();
    img.src = thumbnailUrl;
    img.onload = () => {
      setBackgroundImage(thumbnailUrl);
      setIsLoading(false);
    };
    img.onerror = () => {
      setIsLoading(false);
    };
  };
  (0,react.useEffect)(() => {
    loadImage();
  }, []);
  if (isLoading) {
    return /*#__PURE__*/react.createElement("div", {
      style: {
        width: '100%',
        height: '100%'
      }
    }, /*#__PURE__*/react.createElement(PaddedLoader/* default */.A, null));
  }
  return /*#__PURE__*/react.createElement("div", {
    className: !disablePreview ? 'cursor-pointer' : undefined,
    style: {
      width: '100%',
      height: '100%'
    },
    role: "presentation"
  }, backgroundImage ? /*#__PURE__*/react.createElement("div", {
    style: {
      borderRadius: 3,
      width: '100%',
      height: '100%',
      background: "url(".concat(backgroundImage, ")"),
      backgroundPosition: 'center center',
      backgroundSize: 'cover'
    }
  }) : /*#__PURE__*/react.createElement("span", {
    className: "anchor"
  }, /*#__PURE__*/react.createElement(thumbnails_IconThumbnail, {
    filename: filename,
    url: url
  })));
}
/* harmony default export */ const thumbnails_ImageThumbnail = (ImageThumbnail);
;// ./react/components/thumbnails/Thumbnail.tsx




function Thumbnail(_ref) {
  let {
    fileUpload,
    disablePreview = false,
    onClick = () => {}
  } = _ref;
  return /*#__PURE__*/react.createElement("div", {
    className: "flex h-full w-full items-center justify-center",
    onClick: onClick,
    role: "presentation"
  }, (0,utils/* isImage */.wu)(fileUpload.filename) ? /*#__PURE__*/react.createElement(thumbnails_ImageThumbnail, {
    disablePreview: disablePreview,
    filename: fileUpload.filename,
    url: fileUpload.file,
    thumbnailUrl: "".concat(fileUpload.file, "__320x320.png")
  }) : /*#__PURE__*/react.createElement("a", {
    href: fileUpload.file,
    download: fileUpload.filename,
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      display: 'block',
      width: '100%',
      height: '100%'
    }
  }, /*#__PURE__*/react.createElement(thumbnails_IconThumbnail, {
    filename: fileUpload.filename,
    url: fileUpload.file
  })));
}
/* harmony default export */ const thumbnails_Thumbnail = (Thumbnail);
;// ./react/components/thumbnails/ThumbnailsWrapper.tsx
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

function ThumbnailsWrapper(_ref) {
  let {
    children,
    style
  } = _ref;
  return /*#__PURE__*/react.createElement("div", {
    className: "grid w-64 max-w-full grid-cols-3 gap-1 md:w-96 md:grid-cols-5",
    style: _objectSpread({}, style)
  }, children.map((child, index) => /*#__PURE__*/react.createElement("div", {
    key: index,
    className: "relative flex items-center justify-center rounded border border-gray-200 bg-white p-1"
  }, /*#__PURE__*/react.createElement("div", {
    style: {
      paddingBottom: '100%'
    }
  }), /*#__PURE__*/react.createElement("div", {
    className: "absolute top-0 bottom-0 left-0 right-0"
  }, child))));
}
/* harmony default export */ const thumbnails_ThumbnailsWrapper = (ThumbnailsWrapper);
;// ./react/components/thumbnails/Thumbnails.tsx







function GalleryNavButton(_ref) {
  let {
    icon,
    onClick,
    disabled,
    direction
  } = _ref;
  const classArray = ['inline-flex', 'items-center', 'font-medium', 'whitespace-nowrap', 'text-base', 'image-gallery-icon', "image-gallery-".concat(direction, "-nav"), 'hover:text-indigo-500'];
  const iconClassArray = ['h-16', 'w-16', 'px-1.5', 'py-2.5'];
  if (disabled) {
    classArray.push('opacity-50', 'cursor-not-allowed');
  }
  return /*#__PURE__*/react.createElement("button", {
    type: "button",
    className: classArray.join(' '),
    disabled: disabled,
    onClick: onClick
  }, /*#__PURE__*/react.createElement(ui/* Icon */.In, {
    name: icon,
    size: "huge",
    className: iconClassArray.join(' ')
  }));
}
function Thumbnails(_ref2) {
  let {
    fileUploads,
    disablePreview = false
  } = _ref2;
  const [isModalOpen, setIsModalOpen] = (0,react.useState)(false);
  const [selectedIdx, setSelectedIdx] = (0,react.useState)(0);

  // used gallery library - https://github.com/xiaolin/react-image-gallery
  const galleryRef = (0,react.useCallback)(galleryNode => {
    if (galleryNode) {
      galleryNode.slideToIndex(selectedIdx);
    }
  }, [selectedIdx]);
  const imageFileUploads = fileUploads.filter(fileUpload => (0,utils/* isImage */.wu)(fileUpload.filename));
  const handleFileUploadClick = fileUpload => {
    const fileUploadIdx = imageFileUploads.findIndex(item => item.id === fileUpload.id);
    if (fileUploadIdx !== -1) {
      setIsModalOpen(true);
      setSelectedIdx(fileUploadIdx);
    }
  };
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(thumbnails_ThumbnailsWrapper, null, fileUploads.map(item => /*#__PURE__*/react.createElement(thumbnails_Thumbnail, {
    key: item.id,
    disablePreview: disablePreview,
    fileUpload: item,
    onClick: () => handleFileUploadClick(item)
  }))), /*#__PURE__*/react.createElement(ui/* Modal */.aF, {
    open: isModalOpen,
    onClose: () => setIsModalOpen(false),
    size: "7xl"
  }, /*#__PURE__*/react.createElement("div", {
    className: "react-image-gallery-wrapper rounded-lg bg-gray-200 px-4 pt-4"
  }, /*#__PURE__*/react.createElement((image_gallery_default()), {
    ref: galleryRef,
    items: imageFileUploads.map(fileUpload => ({
      original: fileUpload.file,
      thumbnail: "".concat(fileUpload.file),
      originalTitle: fileUpload.filename,
      originalAlt: fileUpload.filename,
      thumbnailTitle: fileUpload.filename,
      thumbnailAlt: fileUpload.filename
    })),
    showPlayButton: false,
    showFullscreenButton: false,
    infinite: false,
    renderLeftNav: (onClick, disabled) => /*#__PURE__*/react.createElement(GalleryNavButton, {
      icon: "arrow-left",
      onClick: onClick,
      disabled: disabled,
      direction: "left"
    }),
    renderRightNav: (onClick, disabled) => /*#__PURE__*/react.createElement(GalleryNavButton, {
      icon: "arrow-right",
      onClick: onClick,
      disabled: disabled,
      direction: "right"
    })
  }))));
}
/* harmony default export */ const thumbnails_Thumbnails = (Thumbnails);

/***/ }),

/***/ 77126:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var components_form_controls_FileUploadFieldValueWrapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7321);
/* harmony import */ var helpers_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41906);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35443);
/* provided dependency */ var moment = __webpack_require__(95093);




function ProductCustomFieldValueRender(_ref) {
  var _customField$options;
  let {
    value,
    customField
  } = _ref;
  switch (customField.type) {
    case 'SELECT':
      return (0,helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .currentLanguage */ .aS)(((_customField$options = customField.options) === null || _customField$options === void 0 ? void 0 : _customField$options.find(o => o.id === value)) && customField.options.find(o => o.id === value).label) || '–';
    case 'DATE':
      return value ? moment(value).format('LL') : '–';
    case 'CHAR':
      return value || '–';
    case 'MULTILINE':
      return value ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, (0,helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .nl2br */ .HA)(String(value))) : '–';
    case 'LINK':
      return value && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
        href: value.url,
        target: "_blank",
        rel: "noreferrer"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .$n, {
        link: true
      }, value.text)) || '–';
    case 'FILE':
      return value && value.length > 0 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(components_form_controls_FileUploadFieldValueWrapper__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A, {
        value: value
      }) : '–';
    default:
      return null;
  }
}
function ProductCustomFieldValue(_ref2) {
  let {
    customFields,
    customField
  } = _ref2;
  const value = customFields[customField.id];
  if (customField.is_internal && !value) {
    return null;
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_3__/* .NamedProperty */ .pF, {
    name: (0,helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .currentLanguage */ .aS)(customField.name),
    value: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ProductCustomFieldValueRender, {
      customField: customField,
      value: value
    })
  });
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductCustomFieldValue);

/***/ }),

/***/ 45751:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var _FeedEvent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31871);


function Feed(_ref) {
  let {
    children
  } = _ref;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "feed flow-root"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", null, children));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Object.assign(Feed, {
  Event: _FeedEvent__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A
}));

/***/ })

}]);